import React, { useEffect, useState, useContext, useMemo, useCallback, useRef } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { DatePicker } from "antd";
import { Modal, Tabs, Tab } from "react-bootstrap";
import dayjs from "dayjs";
import { all_routes } from "./router/all_routes";
import Select from "react-select";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGraduate, faUsers, faGraduationCap, faPhone, faFileAlt, faTimes, faDownload, faChartLine, faCalendarCheck, faMoneyBill, faCheck } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { ProductContext } from "../context/AppContext";
import Swal from 'sweetalert2';
import axios from "axios";
import Header from "./Header";
const normalizePhone = (value) => (value ?? '').toString().trim();
const sanitizeContactInput = (value) => (value ?? '').toString().replace(/\D/g, '').slice(0, 10);

const isAlreadyVerifiedContact = (value, field, verifiedNumbers, verifiedContacts) => {
  const target = normalizePhone(value);
  if (!target) {
    return false;
  }

  return Object.entries(verifiedNumbers || {}).some(([key, verifiedValue]) => {
    const candidate = normalizePhone(verifiedValue);
    if (!candidate || candidate !== target) {
      return false;
    }

    if (key === field) {
      return true;
    }

    return Boolean(verifiedContacts?.[key]);
  });
};

const normalizeEmail = (value) => (value ?? '').toString().trim().toLowerCase();

const isAlreadyVerifiedEmail = (value, field, verifiedEmailValues, verifiedEmailsState) => {
  const target = normalizeEmail(value);
  if (!target) {
    return false;
  }

  return Object.entries(verifiedEmailValues || {}).some(([key, verifiedValue]) => {
    const candidate = normalizeEmail(verifiedValue);
    if (!candidate || candidate !== target) {
      return false;
    }

    if (key === field) {
      return true;
    }

    return Boolean(verifiedEmailsState?.[key]);
  });
};


const gender = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

const allClass = [
  { value: "I", label: "I" },
  { value: "II", label: "II" },
  { value: "III", label: "III" },
  { value: "IV", label: "IV" },
];

const religion = [
  { value: "Hindu", label: "Hindu" },
  { value: "Muslim", label: "Muslim" },
];

const BloodGroup = [
  { value: "Yes", label: "A" },
  { value: "AB+", label: "AB+" },
];
const MajorityData2 = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const FeesType = [
  { value: "Annual", label: "Annual" },
  { value: "Monthly", label: "Monthly" },
];

const PaymentMethod = [
  { value: "Online", label: "Online" },
  { value: "Offline", label: "Offline" },
];

const RegistrationFeeStatusOptions = [
  { value: 'paid', label: 'Already Paid' },
  { value: 'unpaid', label: 'Pending' },
];

const FatherOccupationData2 = [
  { label: 'Self Employed', value: 'Self Employed' },
  { label: 'Government Employed', value: 'Government Employed' },
  { label: 'Service', value: 'Service' },
  { label: 'Salaried', value: 'Salaried' },
];
const MotherOccupationData2 = [
  { label: 'Self Employed', value: 'Self Employed' },
  { label: 'Government Employed', value: 'Government Employed' },
  { label: 'Service', value: 'Service' },
  { label: 'Salaried', value: 'Salaried' },
  { label: 'House Wife', value: 'House Wife' },
];


const SiblingSelectData2 = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];




const TCOptionData2 = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];
const AadharOptionData2 = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const AppliedData2 = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const DOCUMENT_CONFIG_KEYS = [
  'dob_certificate',
  'aadhar_file',
  'cast_certificate',
  'tc',
  'pen_certificate',
  'bonafide_certificate',
  'father_aadhar_file',
  'mother_aadhar_file',
  'guardian_aadhar_file',
  'upload_photo',
  'father_photo',
  'mother_photo_upload',
  'guardian_photo',
];

const DOC_TYPE_TO_KEY_MAP = {
  upload_guardian_photo: 'guardian_photo',
};

const DOCUMENT_CONSENT_KEY_MAP = {
  dob_certificate: 'dob_certificate_not_available',
  aadhar_file: 'aadhar_file_not_available',
  cast_certificate: 'cast_certificate_not_available',
  tc: 'tc_not_available',
  pen_certificate: 'pen_not_available_applied',
  bonafide_certificate: 'bonafide_not_available_applied',
  father_aadhar_file: 'father_aadhar_file_not_available',
  mother_aadhar_file: 'mother_aadhar_file_not_available',
  guardian_aadhar_file: 'guardian_aadhar_file_not_available',
  upload_photo: 'upload_photo_not_available',
  father_photo: 'father_photo_not_available',
  mother_photo_upload: 'mother_photo_upload_not_available',
  guardian_photo: 'upload_guardian_photo_not_available', // Make sure this key exists
};

const session = [{ value: "2025-2026", label: "2025-2026" }];
const enquirysources = [{ value: "Online", label: "Online" }];

const UpdateRegistration = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const { getRegistration } = location.state || {};
  const id = getRegistration?.data?.id;


  const {
      Class,
      Session,
      CastCategory,
      Religion,
      fetchReligionalData,
      fetchCasteCategory,
      userData,
      fetchMyReegistrationData,
    } = useContext(ProductContext);

  const [verifiedContacts, setVerifiedContacts] = useState({
    father_mobile_no: false,
    mother_mobile_no: false,
    guardian_mobile_no: false,
  });
  const [emailData, setEmailData] = useState('');
  const [AddressSelectData, setAddressSelectData] = useState('');
  const [hasBonafideCertificate, setHasBonafideCertificate] = useState(null);
  const [showBonafideUpload, setShowBonafideUpload] = useState(false);
  const [Transferphoto, setTransferphoto] = useState(null);
  const [TCNotAvailableData, setTCNotAvailableData] = useState(false);
  const [Castephoto, setCastephoto] = useState(null);
  const [autoFillAadhar, setAutoFillAadhar] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [Fatherphoto, setFatherphoto] = useState(null);
  const [Motherphoto, setMotherphoto] = useState(null);
  const authtoken = localStorage.getItem("token");
  const [Guardianphoto, setGuardianphoto] = useState(null);
  const [GuardianAadharphoto, setGuardianAadharphoto] = useState(null);
  const [Medicalphoto, setMedicalphoto] = useState(null);
  const [Characterphoto, setCharacterphoto] = useState(null);
  const [Domicilephoto, setDomicilephoto] = useState(null);
  const [IDProofphoto, setIDProofphoto] = useState(null);
  const [DOBphoto, setDOBphoto] = useState(null);
  const [StudentAadharphoto, setStudentAadharphoto] = useState(null);
  const [FatherAadharphoto, setFatherAadharphoto] = useState(null);
  const [MotherAadharphoto, setMotherAadharphoto] = useState(null);
  const [PENphoto, setPENphoto] = useState(null);
  const [Bonafidephoto, setBonafidephoto] = useState(null);
  const [inPersonDocs, setInPersonDocs] = useState(() =>
    DOCUMENT_CONFIG_KEYS.reduce((acc, key) => {
      acc[key] = { isSelected: false, notes: '' };
      return acc;
    }, {})
  );
  const [formData, setFormData] = useState({
    student_full_name: '',
    session: '',
    gender: '',
    date_of_birth: '',
    select_class: '',
    aadhar_no: '',
    select_religion: '',
    student_cast_category: '',
    transfer_certificate_no: '',
    registration_fee: '',
    payment_mode: 'Online',
    registration_fee_status: '',
    contact_address: '',
    pincode: '',
    permanent_address: '',
    city_state: '',
    last_school_name: '',
    last_school_class: '',
    last_school_board: '',
    last_school_address: '',
    father_full_name: '',
    father_mobile_no: '',
    father_qualification: '',
    father_occupation: '',
    father_email: '',
    father_aadhar_no: '',
    father_company_name: '',
    father_company_address: '',
    mother_full_name: '',
    mother_qualification: '',
    mother_occupation: '',
    mother_mobile_no: '',
    mother_email: '',
    mother_aadhar_no: '',
    sibling_admission_numbers: '',
    pen_number: '',
    mother_company_name: '',
    mother_company_address: '',
    guardian_name: '',
    guardian_relation: '',
    guardian_mobile_no: '',
    guardian_occupation: '',
    guardian_qualification: '',
    guardian_aadhar_no: '',
    guardian_company_name: '',
    guardian_company_address: '',
    guardian_aadhar_address: '',
    guardian_date_of_birth: '',
    is_father_mobile_verified: false,
    is_mother_mobile_verified: false,
    is_guardian_mobile_verified: false,
    is_father_email_verified: false,
    is_mother_email_verified: false,
    is_guardian_email_verified: false,
    pri_application_status: 'Created',
    pri_application_rmk: '',
    enquery_id: id,
    stoppage_id: '',
    father_address: null,
    mother_address: null,
    student_address: null,
    blood_group: '',
    student_family_id: '',
    select_fee_type: 'Monthly',
    income_category: 'Middle Class',
    tc_number: '',
    father_date_of_birth: '',
    mother_date_of_birth: '',
    father_aadhar_address: '',
    mother_aadhar_address: '',
    student_aadhar_name: '',
    student_aadhar_address: '',
    aadhar_date_of_birth: '',
    emergency_mobile_no: '',
    consentMessage: '',
    is_ref: false,
    ref_name: '',
    ref_role: '',
    ref_year_of_leaving: '',
    ref_contact_no: '',
    ref_note: '',
    ref_admission_no: '',
    ref_employee_code: '',
    is_single_parent: false,
    single_parent: '',
    leaving_date: '',
    reason_for_leaving: '',
    leaving_type: '',
    created_by_student: true,
    is_bonafide:'',
    is_child_adhaar:'',
    is_child_adhaar_applied:'',
    is_minority:'',
    is_curr_address:'',
  });

  const [RegistrationData, setRegistrationData] = useState(null);
  const registrationId = RegistrationData?.data?.id || null;
  const selectedClassId = Number(formData.select_class || RegistrationData?.data?.class || 0);
  const [consentModalState, setConsentModalState] = useState({ visible: false, items: [] });
  const [existingConsentsByKey, setExistingConsentsByKey] = useState({});
  const [selectedConsentKeys, setSelectedConsentKeys] = useState({});
  const [consentModalSubmitting, setConsentModalSubmitting] = useState(false);
  const [consentModalError, setConsentModalError] = useState('');
  const consentModalResolverRef = useRef(null);
  const [ContactNumberData, setContactNumberData] = useState('Primary');
  const [showOtherBoardInput, setShowOtherBoardInput] = useState(false);
  const [otherBoardName, setOtherBoardName] = useState("");
  const [classes, setClasses] = useState([]);
  const [GenderData, setGenderData] = useState('');
  const [ClassData, setClassData] = useState('');
  const [selected, setSelected] = useState('');
  const [ReligionData, setReligionData] = useState('');
  const [CasteData, setCasteData] = useState('');
  const [BloodGroupData, setBloodGroupData] = useState('');
  const [isSelected, setSelection] = useState(false);
  const [IsSelectedFatherAadhar, setIsSelectedFatherAadhar] = useState(false);
  const [IsSelectedMotherAAdhar, setIsSelectedMotherAAdhar] = useState(false);
  const [IsSelectedPENNumber, setIsSelectedPENNumber] = useState(false);
  const [isSelectedTCNotAvailable, setSelectionTCNotAvailable] = useState(false);
  const [FatherOccupationData, setFatherOccupationData] = useState('');
  const [MotherOccupationData, setMotherOccupationData] = useState('');
  const [isConsentSubmitted, setIsConsentSubmitted] = useState(false);
  const [isConsentSubmitted1, setIsConsentSubmitted1] = useState(false);
  const [isConsentSubmitted2, setIsConsentSubmitted2] = useState(false);
  const [isConsentSubmitted3, setIsConsentSubmitted3] = useState(false);
  const [isConsentSubmitted4, setIsConsentSubmitted4] = useState(false);
  const [isConsentSubmitted5, setIsConsentSubmitted5] = useState(false);
  const [isConsentSubmitted6, setIsConsentSubmitted6] = useState(false);
  const [isConsentSubmitted7, setIsConsentSubmitted7] = useState(false);
  const [isConsentSubmitted8, setIsConsentSubmitted8] = useState(false);
  const [isAadharVerified, setisAadharVerified] = useState(false);
  const [isAadharOTPSent, setisAadharOTPSent] = useState(false);
  const [AadharOtp, setAadharOtp] = useState('');
  const [clientId, setClientId] = useState('');
  const [referrals, setReferrals] = useState([]);
  const [deletedReferralIds, setDeletedReferralIds] = useState([]);
  const [IsSelectedGuardianAadhar, setIsSelectedGuardianAadhar] = useState(false);
  const [GuardianAadharNotAvailable, setGuardianAadharNotAvailable] = useState(false);
  const [isVerifyingContact, setIsVerifyingContact] = useState(false);
  const [isVerifyingEmail, setIsVerifyingEmail] = useState(false);
  const [isClassAgeAppropriate, setIsClassAgeAppropriate] = useState(false);
  const [isNurseryClass, setIsNurseryClass] = useState(false);
  const [primarySelectionsInitialized, setPrimarySelectionsInitialized] = useState(false);
  const [isPermanentSameAsCurrent, setIsPermanentSameAsCurrent] = useState(false);
  const [enqDob, setEnqDob] = useState(null);
  const lastSchoolClassOptions = useMemo(() => {
    const baseClasses = [
      { value: 'Nursery', label: 'Nursery' },
      { value: 'LKG', label: 'LKG' },
      { value: 'UKG', label: 'UKG' },
    ];

    const romanNumerals = [
      'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII',
    ];

    const gradeClasses = romanNumerals.map((roman, index) => ({
      value: roman,
      label: roman,
    }));

    return [...baseClasses, ...gradeClasses];
  }, []);
  const [verifiedNumbers, setVerifiedNumbers] = useState({
    father_mobile_no: '',
    mother_mobile_no: '',
    guardian_mobile_no: '',
  });

  const lastSchoolBoardOptions = useMemo(
    () => [
      { value: 'CBSE', label: 'CBSE' },
      { value: 'ICSE', label: 'ICSE' },
      { value: 'State Board', label: 'State Board' },
      { value: 'IB', label: 'IB' },
      { value: 'Cambridge', label: 'Cambridge' },
      { value: 'Other', label: 'Other' },
    ],
    []
  );

  console.log(Session, Class, "Session,Class");


  const ContactNumberData2 = formData.is_single_parent && formData.single_parent === "guardian"
    ? [{ label: "Guardian", value: "Guardian" }]
    : formData.is_single_parent && formData.single_parent === "father"
      ? [{ label: "Father", value: "Father" }]
      : formData.is_single_parent && formData.single_parent === "mother"
        ? [{ label: "Mother", value: "Mother" }]
        : [
          { label: "Father", value: "Father" },
          { label: "Mother", value: "Mother" },
        ];

  const EmailData2 = formData.is_single_parent && formData.single_parent === "guardian"
    ? [{ label: "Guardian", value: "Guardian" }]
    : formData.is_single_parent && formData.single_parent === "father"
      ? [{ label: "Father", value: "Father" }]
      : formData.is_single_parent && formData.single_parent === "mother"
        ? [{ label: "Mother", value: "Mother" }]
        : [
          { label: "Father", value: "Father" },
          { label: "Mother", value: "Mother" },
          { label: "Guardian", value: "Guardian" },
        ];

  const preApplicationStatusOptions = [
    { value: "Created", label: "Created" },
    { value: "Validate", label: "Validated" },
    { value: "Action_Required", label: "Action Required" },
    { value: "Visit", label: "Visit Required" },
  ];

  const activeReferrals = useMemo(
    () =>
      referrals
        .map((referral, index) => ({ referral, originalIndex: index }))
        .filter(({ referral }) => !referral.is_deleted),
    [referrals]
  );
  const [isEditingContact, setIsEditingContact] = useState({
    father_mobile_no: false,
    mother_mobile_no: false,
    guardian_mobile_no: false
  });

  const [tempContactNumbers, setTempContactNumbers] = useState({
    father_mobile_no: '',
    mother_mobile_no: '',
    guardian_mobile_no: ''
  });
  // Add this state near other state declarations
  const [existingDocumentUrls, setExistingDocumentUrls] = useState({
    upload_photo: null,
    father_photo: null,
    mother_photo_upload: null,
    father_aadhar_file: null,
    mother_aadhar_file: null,
    dob_certificate: null,
    aadhar_file: null,
    cast_certificate: null,
    tc: null,
    pen_certificate: null,
    bonafide_certificate: null,
    guardian_aadhar_file: null,
    upload_guardian_photo: null,
  });

  const hydrateInPersonDocsFromApi = useCallback((documents = []) => {
    if (!Array.isArray(documents)) {
      return;
    }

    setInPersonDocs((prev) => {
      const next = { ...prev };

      DOCUMENT_CONFIG_KEYS.forEach((docKey) => {
        const apiDocument = documents?.find((doc) => {
          if (!doc?.doc_type) {
            return false;
          }
          const normalizedKey = DOC_TYPE_TO_KEY_MAP[doc.doc_type] || doc.doc_type;
          return normalizedKey === docKey;
        });

        if (!apiDocument) {
          return;
        }

        const metadata = apiDocument.metadata && typeof apiDocument.metadata === 'object'
          ? apiDocument.metadata
          : {};

        const noteValue =
          metadata.notes ||
          metadata.note ||
          metadata.remarks ||
          metadata.comment ||
          '';

        next[docKey] = {
          isSelected: Boolean(apiDocument.is_in_person),
          notes: noteValue || prev[docKey]?.notes || '',
        };
      });

      return next;
    });
  }, []);

  const fetchInPersonDocuments = useCallback(async (registrationId) => {
    if (!registrationId) {
      return;
    }

    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/register/${registrationId}/inperson-documents`,
        {
          method: "GET",
          headers: {
            "x-auth": authtoken,
            "Accept": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch in-person documents: ${response.status}`);
      }

      const payload = await response.json();
      const documents =
        payload?.data?.documents ||
        payload?.data ||
        payload?.documents ||
        [];

      if (Array.isArray(documents)) {
        hydrateInPersonDocsFromApi(documents);
      }
    } catch (error) {
      console.error("Error fetching in-person documents:", error);
    }
  }, [authtoken, hydrateInPersonDocsFromApi]);
  // Add this function to handle edit button click
  const handleEditContact = (field) => {
    setIsEditingContact(prev => ({
      ...prev,
      [field]: true
    }));

    setTempContactNumbers(prev => ({
      ...prev,
      [field]: sanitizeContactInput(formData[field] || '')
    }));

    setVerifiedContacts(prev => ({
      ...prev,
      [field]: isAlreadyVerifiedContact(formData[field], field, verifiedNumbers, prev),
    }));
  };

  // Add this function to handle contact number change during edit
  const handleTempContactChange = (field, value) => {
    const sanitized = sanitizeContactInput(value);
    setTempContactNumbers(prev => ({
      ...prev,
      [field]: sanitized
    }));

    const normalized = normalizePhone(sanitized);
    const alreadyVerified = isAlreadyVerifiedContact(normalized, field, verifiedNumbers, verifiedContacts);

    setVerifiedContacts(prev => ({
      ...prev,
      [field]: alreadyVerified,
    }));

    setVerifiedNumbers(prev => ({
      ...prev,
      [field]: alreadyVerified ? normalized : prev[field],
    }));
  };

  const handleSaveContact = (field) => {
    const nextValueRaw = tempContactNumbers[field] || '';
    const sanitized = sanitizeContactInput(nextValueRaw);
    const normalized = normalizePhone(sanitized);

    handleChange(field, sanitized);
    setIsEditingContact(prev => ({
      ...prev,
      [field]: false
    }));

    const alreadyVerified = isAlreadyVerifiedContact(normalized, field, verifiedNumbers, verifiedContacts);

    setVerifiedContacts(prev => ({
      ...prev,
      [field]: alreadyVerified,
    }));

    setVerifiedNumbers(prev => ({
      ...prev,
      [field]: alreadyVerified ? normalized : prev[field],
    }));
  };

  // Add this function to cancel editing
  // Update the handleCancelEdit function
  const handleCancelEdit = (field) => {
    // Reset temp value
    setTempContactNumbers(prev => ({
      ...prev,
      [field]: sanitizeContactInput(formData[field] || '')
    }));

    // Exit edit mode
    setIsEditingContact(prev => ({
      ...prev,
      [field]: false
    }));

    setVerifiedContacts(prev => ({
      ...prev,
      [field]: isAlreadyVerifiedContact(formData[field], field, verifiedNumbers, prev),
    }));
  };
  const handleChange = (field, value) => {
    // If the value is a file (from an input[type="file"])
    if (value instanceof File) {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));

      // Update preview if it's an image
      if (field === 'upload_photo' || field === 'father_photo' || field === 'mother_photo_upload') {
        setPreviews((prev) => ({
          ...prev,
          [field]: URL.createObjectURL(value),
        }));
      }
    } else {
      // For non-file inputs
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };
  const [isEditingEmail, setIsEditingEmail] = useState({
    father_email: false,
    mother_email: false,
    guardian_email: false
  });

  const [tempEmailValues, setTempEmailValues] = useState({
    father_email: '',
    mother_email: '',
    guardian_email: ''
  });

  const [verifiedEmails, setVerifiedEmails] = useState({
    father_email: false,
    mother_email: false,
    guardian_email: false,
  });
  const hasGuardianEmail = useMemo(
    () => Boolean((formData.guardian_email || "").trim()),
    [formData.guardian_email]
  );
  const [verifiedEmailValues, setVerifiedEmailValues] = useState({
    father_email: '',
    mother_email: '',
    guardian_email: '',
  });
  const [emailInfoMessages, setEmailInfoMessages] = useState({
    father_email: '',
    mother_email: '',
    guardian_email: '',
  });

  const primaryContactSummary = useMemo(() => {
    const map = {
      Father: {
        label: "Father",
        number: formData.father_mobile_no,
        verified: Boolean(verifiedContacts.father_mobile_no),
      },
      Mother: {
        label: "Mother",
        number: formData.mother_mobile_no,
        verified: Boolean(verifiedContacts.mother_mobile_no),
      },
      Guardian: {
        label: "Guardian",
        number: formData.guardian_mobile_no,
        verified: Boolean(verifiedContacts.guardian_mobile_no),
      },
    };

    if (ContactNumberData && map[ContactNumberData]) {
      const entry = map[ContactNumberData];
      if (entry.number) {
        return entry;
      }
    }

    const fallbackNumber =
      formData.contact_phone ||
      formData.father_mobile_no ||
      formData.mother_mobile_no ||
      formData.guardian_mobile_no ||
      '';

    let fallbackLabel = 'Primary Contact';
    let fallbackVerified = false;

    if (fallbackNumber) {
      const normalized = normalizePhone(fallbackNumber);
      if (normalized && normalizePhone(formData.father_mobile_no) === normalized) {
        fallbackLabel = 'Father';
        fallbackVerified = Boolean(verifiedContacts.father_mobile_no);
      } else if (normalized && normalizePhone(formData.mother_mobile_no) === normalized) {
        fallbackLabel = 'Mother';
        fallbackVerified = Boolean(verifiedContacts.mother_mobile_no);
      } else if (normalized && normalizePhone(formData.guardian_mobile_no) === normalized) {
        fallbackLabel = 'Guardian';
        fallbackVerified = Boolean(verifiedContacts.guardian_mobile_no);
      }
    }

    return {
      label: fallbackLabel,
      number: fallbackNumber,
      verified: fallbackVerified,
    };
  }, [
    ContactNumberData,
    formData.contact_phone,
    formData.father_mobile_no,
    formData.mother_mobile_no,
    formData.guardian_mobile_no,
    verifiedContacts,
  ]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      is_father_email_verified: Boolean(verifiedEmails.father_email),
      is_mother_email_verified: Boolean(verifiedEmails.mother_email),
      is_guardian_email_verified: Boolean(verifiedEmails.guardian_email),
    }));
  }, [verifiedEmails]);

  // Update handleEditEmail function to reset verification for the field
  const handleEditEmail = (field) => {
    setIsEditingEmail(prev => ({
      ...prev,
      [field]: true
    }));

    setTempEmailValues(prev => ({
      ...prev,
      [field]: formData[field] || ''
    }));

    setVerifiedEmails(prev => ({
      ...prev,
      [field]: isAlreadyVerifiedEmail(formData[field], field, verifiedEmailValues, prev)
    }));

    const normalized = normalizeEmail(formData[field]);
    const alreadyVerified = isAlreadyVerifiedEmail(normalized, field, verifiedEmailValues, verifiedEmails);
    setEmailInfoMessages(prev => ({
      ...prev,
      [field]: alreadyVerified ? 'This email is already verified.' : ''
    }));
  };

  const handleSaveEmail = (field) => {
    const nextValue = tempEmailValues[field] || '';
    const normalized = normalizeEmail(nextValue);

    handleChange(field, nextValue);
    setIsEditingEmail(prev => ({
      ...prev,
      [field]: false
    }));

    const alreadyVerified = isAlreadyVerifiedEmail(normalized, field, verifiedEmailValues, verifiedEmails);

    setVerifiedEmails(prev => ({
      ...prev,
      [field]: alreadyVerified
    }));

    setVerifiedEmailValues(prev => ({
      ...prev,
      [field]: alreadyVerified ? normalized : ''
    }));

    setEmailInfoMessages(prev => ({
      ...prev,
      [field]: alreadyVerified ? 'This email is already verified.' : ''
    }));
  };

  const handleTempEmailChange = (field, value) => {
    const normalized = normalizeEmail(value);
    setTempEmailValues(prev => ({
      ...prev,
      [field]: value
    }));

    const alreadyVerified = isAlreadyVerifiedEmail(normalized, field, verifiedEmailValues, verifiedEmails);

    setVerifiedEmails(prev => ({
      ...prev,
      [field]: alreadyVerified
    }));

    if (alreadyVerified) {
      setVerifiedEmailValues(prev => ({
        ...prev,
        [field]: normalized
      }));

      if (parentEmailTarget === field) {
        setParentEmailSent(false);
        setParentEmailOTP('');
        setParentEmailTargetValue('');
      }
    }

    setEmailInfoMessages(prev => ({
      ...prev,
      [field]: alreadyVerified ? 'This email is already verified.' : ''
    }));
  };



  const handleCancelEditEmail = (field) => {
    // Reset temp value
    setTempEmailValues(prev => ({
      ...prev,
      [field]: formData[field] || ''
    }));

    // Exit edit mode
    setIsEditingEmail(prev => ({
      ...prev,
      [field]: false
    }));

    setVerifiedEmails(prev => ({
      ...prev,
      [field]: isAlreadyVerifiedEmail(formData[field], field, verifiedEmailValues, prev)
    }));

    const normalized = normalizeEmail(formData[field]);
    const alreadyVerified = isAlreadyVerifiedEmail(normalized, field, verifiedEmailValues, verifiedEmails);

    setVerifiedEmailValues(prev => ({
      ...prev,
      [field]: alreadyVerified ? normalized : prev[field]
    }));

    setEmailInfoMessages(prev => ({
      ...prev,
      [field]: ''
    }));
  };
  const formatAddress = (addressObj) => {
    if (!addressObj) return '';

    const parts = [
      addressObj.house,
      addressObj.street,
      addressObj.loc,
      addressObj.state,
      addressObj.pin ? `- ${addressObj.pin}` : ''
    ].filter(part => part && part.trim() !== '');

    return parts.join(', ').replace(/, -/g, ' -');
  };
  useEffect(() => {
    if (isPermanentSameAsCurrent) {
      handleChange("permanent_address", formData.contact_address || '');
    }
  }, [formData.contact_address, isPermanentSameAsCurrent]);

  useEffect(() => {
    if (formData.permanent_address && formData.permanent_address === formData.contact_address) {
      if (!isPermanentSameAsCurrent) {
        setIsPermanentSameAsCurrent(true);
      }
    } else if (isPermanentSameAsCurrent && formData.permanent_address !== formData.contact_address) {
      setIsPermanentSameAsCurrent(false);
    }
  }, [formData.contact_address, formData.permanent_address, isPermanentSameAsCurrent]);
  // Filter Address Type dropdown based on Aadhar permissions


  const AddressSelectData2 = formData.is_single_parent && formData.single_parent === "guardian"
    ? [
      { value: "Guardian Address", label: "Guardian Address (as per aadhar card)" },
      { value: "Student Address", label: "Student Address (as per aadhar card)" },
      { value: "Other", label: "Other" },
    ]

    : formData.is_single_parent && formData.single_parent === "father"
      ? [
        { value: "Father Address", label: "Father Address (as per aadhar card)" },
        { value: "Student Address", label: "Student Address (as per aadhar card)" },
        { value: "Other", label: "Other" },
      ]
      : formData.is_single_parent && formData.single_parent === "mother"
        ? [
          { value: "Mother Address", label: "Mother Address (as per aadhar card)" },
          { value: "Student Address", label: "Student Address (as per aadhar card)" },
          { value: "Other", label: "Other" },
        ]
        : [
          { value: "Father Address", label: "Father Address (as per aadhar card)" },
          { value: "Mother Address", label: "Mother Address (as per aadhar card)" },
          { value: "Student Address", label: "Student Address (as per aadhar card)" },
          { value: "Other", label: "Other" },
        ];
  const [selectedDate, setSelectedDate] = useState(
    formData.date_of_birth || '',
  );
  useEffect(() => {
    fetchCasteCategory();
  }, []);

  const defaultMinorityValue = formData?.cast_certificate ? "Yes" : "No";
  const defaulStudentAadharValue = formData?.aadhar_no ? "Yes" : "No";

  const [ConsentTypeData, setConsentTypeData] = useState([]);
  const [Error, setError] = useState([]);
  const [servicePermissions, setServicePermissions] = useState({
    studentAadhar: false,
    fatherAadhar: false,
    motherAadhar: false,
    guardianAadhar: false,
    studentMobileVerify: false, // Add this
    motherMobileVerify: false,  // Add this
    emailVerify: false,         // Add this
  });
  // Add this useEffect to fetch registration data

  const fetchRegistrationData = async () => {
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/register/user-registration`,
        {
          method: "GET",
          headers: {
            "x-auth": authtoken,
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch registration: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.data) {
        const registration = data?.data;

        // console.log("=== API RESPONSE DATA ===");
        // console.log("Contact Phone:", registration.contact_phone);
        // console.log("Contact Email:", registration.contact_email);
        // console.log("Father Mobile:", registration.father_mobile_no);
        // console.log("Mother Mobile:", registration.mother_mobile_no);
        // console.log("Father Email:", registration.father_email);
        // console.log("Mother Email:", registration.mother_email);
        // console.log("Aadhar No:", registration.aadhar_no);
        // console.log("TC Document:", registration.tc);
        // console.log("TC Number:", registration.tc_number);
        // console.log(
        //   "Transfer Certificate No:",
        //   registration.transfer_certificate_no
        // );
        // console.log("==========================");

        // Convert select_class from string to number
        const selectClassValue = registration.select_class
          ? parseInt(registration.select_class, 10)
          : "";

        // Update formData with registration data
        const updatedFormData = {
          // Personal Information
          student_full_name: registration.student_full_name || "",
          session: registration.session || "",
          gender: registration.gender || "",
          date_of_birth: registration.date_of_birth
            ? registration.date_of_birth.split("T")[0]
            : "",
          select_class: selectClassValue,
          aadhar_no: registration.aadhar_no || "",
          select_religion: registration.select_religion || "",
          registration_fee_status:registration?.registration_fee_status,
          blood_group: registration.blood_group || "",
          student_cast_category: registration.student_cast_category || "",
          transfer_certificate_no: registration.transfer_certificate_no || "",
          student_family_id: registration.student_family_id || "",
          select_fee_type: registration.select_fee_type || "Monthly",
          registration_fee: registration.registration_fee || "",
          payment_mode: registration.payment_mode || "Online",
          income_category: registration.income_category || "Middle Class",
          contact_address: registration.contact_address || "",
          pincode: registration.pincode || "",
          permanent_address: registration.permanent_address || "",
          city_state: registration.city_state || "",
          last_school_name: registration.last_school_name || "",
          last_school_class: registration.last_school_class || "",
          last_school_board: registration.last_school_board || "",
          last_school_address: registration.last_school_address || "",
          pen_number: registration.pen_number || "",
          tc_number: registration.tc_number || "",
          sibling_admission_numbers:
            registration.sibling_admission_numbers || "",
          student_aadhar_name: registration.student_aadhar_name || "",
          student_aadhar_address: registration.student_aadhar_address || "",
          aadhar_date_of_birth: registration.aadhar_date_of_birth
            ? registration.aadhar_date_of_birth.split("T")[0]
            : "",
          emergency_mobile_no: registration.emergency_mobile_no || "",
          enquery_id: registration.enquery_id || "",
          username: registration.username || "",
          stoppage_id: registration.stoppage_id || "",
          contact_phone: registration.contact_phone || "", // This should be "9340926124"
          contact_email: registration.contact_email || "",
          cast_certificate: registration?.cast_certificate,
          // Father's Information
          father_full_name: registration.father_full_name || "",
          father_mobile_no: registration.father_mobile_no || "",
          father_qualification: registration.father_qualification || "",
          father_occupation: registration.father_occupation || "",
          father_email: registration.father_email || "",
          father_aadhar_no: registration.father_aadhar_no || "",
          father_company_name: registration.father_company_name || "",
          father_company_address: registration.father_company_address || "",
          father_date_of_birth: registration.father_date_of_birth
            ? registration.father_date_of_birth.split("T")[0]
            : "",
          father_aadhar_address: registration.father_aadhar_address || "",

          // Mother's Information
          mother_full_name: registration.mother_full_name || "",
          mother_qualification: registration.mother_qualification || "",
          mother_occupation: registration.mother_occupation || "",
          mother_mobile_no: registration.mother_mobile_no || "",
          mother_email: registration.mother_email || "",
          mother_aadhar_no: registration.mother_aadhar_no || "",
          mother_company_name: registration.mother_company_name || "",
          mother_company_address: registration.mother_company_address || "",
          mother_date_of_birth: registration.mother_date_of_birth
            ? registration.mother_date_of_birth.split("T")[0]
            : "",
          mother_aadhar_address: registration.mother_aadhar_address || "",

          // Guardian Information
          guardian_name: registration.guardian_name || "",
          guardian_relation: registration.guardian_relation || "",
          guardian_mobile_no: registration.guardian_mobile_no || "",
          guardian_occupation: registration.guardian_occupation || "",
          guardian_qualification: registration.guardian_qualification || "",
          guardian_aadhar_no: registration.guardian_aadhar_no || "",
          guardian_company_name: registration.guardian_company_name || "",
          guardian_company_address: registration.guardian_company_address || "",
          guardian_aadhar_address: registration.guardian_aadhar_address || "",
          guardian_date_of_birth: registration.guardian_date_of_birth
            ? registration.guardian_date_of_birth.split("T")[0]
            : "",

          // Other fields
          is_ref: registration.is_ref || false,
          is_single_parent: registration.is_single_parent || false,
          single_parent: registration.single_parent || "",
          pri_application_status:
            registration.pri_application_status || "Created",
          pri_application_rmk: registration.pri_application_rmk || "",
          minority_status: registration.minority_status || "",
          is_father_mobile_verified: Boolean(
            registration.is_father_mobile_verified
          ),
          is_mother_mobile_verified: Boolean(
            registration.is_mother_mobile_verified
          ),
          is_guardian_mobile_verified: Boolean(
            registration.is_guardian_mobile_verified
          ),
          is_father_email_verified: Boolean(
            registration.is_father_email_verified
          ),
          is_mother_email_verified: Boolean(
            registration.is_mother_email_verified
          ),
          is_bonafide: Boolean(
            registration.is_bonafide
          ),

          is_child_adhaar: Boolean(
            registration.is_child_adhaar
          ),
          is_child_adhaar_applied: Boolean(
            registration.is_child_adhaar_applied
          ),
          is_minority: Boolean(
            registration.is_minority
          ),
          is_curr_address: Boolean(
            registration.is_curr_address
          ),
          


        };

        setFormData(updatedFormData);
        setRegistrationData(data);

        setVerifiedContacts({
          father_mobile_no: Boolean(registration.is_father_mobile_verified),
          mother_mobile_no: Boolean(registration.is_mother_mobile_verified),
          guardian_mobile_no: Boolean(registration.is_guardian_mobile_verified),
        });

        setVerifiedNumbers({
          father_mobile_no: registration.is_father_mobile_verified
            ? normalizePhone(registration.father_mobile_no)
            : "",
          mother_mobile_no: registration.is_mother_mobile_verified
            ? normalizePhone(registration.mother_mobile_no)
            : "",
          guardian_mobile_no: registration.is_guardian_mobile_verified
            ? normalizePhone(registration.guardian_mobile_no)
            : "",
        });

        setVerifiedEmails({
          father_email: Boolean(registration.is_father_email_verified),
          mother_email: Boolean(registration.is_mother_email_verified),
          guardian_email: Boolean(registration.is_guardian_email_verified),
        });

        setVerifiedEmailValues({
          father_email: registration.is_father_email_verified
            ? normalizeEmail(registration.father_email)
            : "",
          mother_email: registration.is_mother_email_verified
            ? normalizeEmail(registration.mother_email)
            : "",
          guardian_email: registration.is_guardian_email_verified
            ? normalizeEmail(registration.guardian_email)
            : "",
        });

        // AUTO-SET DROPDOWN VALUES BASED ON API DATA

        // 1. Auto-set Contact Number dropdown based on contact_phone
        let contactNumberValue = "";
        if (registration.contact_phone) {
          if (registration.contact_phone === registration.father_mobile_no) {
            contactNumberValue = "Father";
          } else if (
            registration.contact_phone === registration.mother_mobile_no
          ) {
            contactNumberValue = "Mother";
          } else if (
            registration.contact_phone === registration.guardian_mobile_no
          ) {
            contactNumberValue = "Guardian";
          } else {
            // Fallback: Use the first available contact
            if (registration.father_mobile_no) {
              contactNumberValue = "Father";
            } else if (registration.mother_mobile_no) {
              contactNumberValue = "Mother";
            } else if (registration.guardian_mobile_no) {
              contactNumberValue = "Guardian";
            }
          }
        }
        setContactNumberData(contactNumberValue);
        console.log("Setting ContactNumberData to:", contactNumberValue);

        // 2. Auto-set Email dropdown based on contact_email
        let emailValue = "";
        if (registration.contact_email) {
          if (registration.contact_email === registration.father_email) {
            emailValue = "Father";
          } else if (registration.contact_email === registration.mother_email) {
            emailValue = "Mother";
          } else if (
            registration.contact_email === registration.guardian_email
          ) {
            emailValue = "Guardian";
          } else {
            // Fallback: Use the first available email
            if (registration.father_email) {
              emailValue = "Father";
            } else if (registration.mother_email) {
              emailValue = "Mother";
            } else if (registration.guardian_email) {
              emailValue = "Guardian";
            }
          }
        }
        setEmailData(emailValue);
        console.log("Setting EmailData to:", emailValue);

        // 3. Auto-set "Do you have Child's Aadhar" to "Yes" if aadhar_no exists
        if (registration.aadhar_no && registration.aadhar_no.trim() !== "") {
          setAadharOptionData("Yes");
          console.log("Setting AadharOptionData to: Yes");
        } else {
          setAadharOptionData("");
          console.log("Setting AadharOptionData to: empty");
        }

        // 4. Auto-set "Do you have TC" based on TC document or TC number
        const hasTC =
          registration.tc ||
          (registration.transfer_certificate_no &&
            registration.transfer_certificate_no.trim() !== "") ||
          (registration.tc_number && registration.tc_number.trim() !== "");

        if (hasTC) {
          setTCOptionData("Yes");
          console.log("Setting TCOptionData to: Yes");
        } else {
          setTCOptionData("");
          console.log("Setting TCOptionData to: empty");
        }

        // 5. Auto-set "Have you applied for Aadhar?" if needed
        if (!registration.aadhar_no || registration.aadhar_no.trim() === "") {
          setAppliedData("");
        }

        // 6. Auto-set Sibling selection if sibling admission numbers exist
        if (
          registration.sibling_admission_numbers &&
          registration.sibling_admission_numbers.trim() !== ""
        ) {
          setSiblingSelectData("Yes");
          setAdmissionNumber(registration.sibling_admission_numbers);
        } else {
          setSiblingSelectData("No");
          setAdmissionNumber("");
        }

        // 7. Auto-set Address Type based on existing address data
        if (registration.contact_address) {
          let addressType = "Other";
          if (
            registration.contact_address === registration.student_aadhar_address
          ) {
            addressType = "Student Address";
          } else if (
            registration.contact_address === registration.father_aadhar_address
          ) {
            addressType = "Father Address";
          } else if (
            registration.contact_address === registration.mother_aadhar_address
          ) {
            addressType = "Mother Address";
          } else if (
            registration.contact_address ===
            registration.guardian_aadhar_address
          ) {
            addressType = "Guardian Address";
          }
          setSelectedAddressType(addressType);
        }

        // 8. Auto-set PEN/Bonafide certificate status based on class and existing data
        // This will be re-evaluated after class is set

        // Store existing document URLs
        setExistingDocumentUrls({
          upload_photo: registration.upload_photo,
          father_photo: registration.father_photo,
          mother_photo_upload: registration.mother_photo_upload,
          father_aadhar_file: registration.father_aadhar_file,
          mother_aadhar_file: registration.mother_aadhar_file,
          guardian_aadhar_file: registration.guardian_aadhar_file,
          upload_guardian_photo: registration.upload_guardian_photo,
          dob_certificate: registration.dob_certificate,
          aadhar_file: registration.aadhar_file,
          cast_certificate: registration.cast_certificate,
          tc: registration.tc,
          pen_certificate: registration.pen_certificate,
          bonafide_certificate: registration.bonafide_certificate,
        });

        // Set referrals from registration data
        if (registration.referrals && Array.isArray(registration.referrals)) {
          setReferrals(
            registration.referrals.map((ref) => ({
              id: ref.id,
              ref_name: ref.ref_name || "",
              ref_role: ref.ref_role || "",
              ref_admission_no: ref.ref_admission_no || "",
              ref_employee_code: ref.ref_employee_code || "",
              ref_year_of_leaving: ref.ref_year_of_leaving || "",
              ref_contact_no: ref.ref_contact_no || "",
              ref_note: ref.ref_note || "",
              ref_is_current: ref.ref_is_current || false,
              ref_relation: ref.ref_relation || "",
              is_deleted: ref.is_deleted || false,
            }))
          );
        }

        // Set Aadhar verification status
        setAadharVerification((prev) => ({
          ...prev,
          student: {
            ...prev.student,
            verified: !!(
              registration.aadhar_no && registration.aadhar_no.trim() !== ""
            ),
          },
          father: {
            ...prev.father,
            verified: !!(
              registration.father_aadhar_no &&
              registration.father_aadhar_no.trim() !== ""
            ),
          },
          mother: {
            ...prev.mother,
            verified: !!(
              registration.mother_aadhar_no &&
              registration.mother_aadhar_no.trim() !== ""
            ),
          },
          guardian: {
            ...prev.guardian,
            verified: !!(
              registration.guardian_aadhar_no &&
              registration.guardian_aadhar_no.trim() !== ""
            ),
          },
        }));

        if (registration.enquery_id) {
          try {
            const consentResponse = await fetch(
              `https://api.mirai.healthcare/api/register/consent/${registration.enquery_id}`,
              {
                method: "GET",
                headers: {
                  "x-auth": authtoken,
                  Accept: "application/json",
                },
              }
            );

            if (!consentResponse.ok) {
              throw new Error(
                `Failed to fetch consents: ${consentResponse.status}`
              );
            }

            const consentJson = await consentResponse.json();

            if (consentJson?.success && Array.isArray(consentJson.data)) {
              const consentKeyMap = {};

              consentJson.data.forEach((entry) => {
                entry?.consent_types?.forEach((consentType) => {
                  const key = consentType?.type?.key;
                  if (key) {
                    consentKeyMap[key] = true;
                  }
                });
              });

              setExistingConsentsByKey(consentKeyMap);

              if (consentKeyMap.tc_not_available_applied && !hasTC) {
                setTCOptionData((prev) => (prev === "Yes" ? prev : "No"));
                setTCNotAvailableData(true);
              }

              const hasPenDocument = Boolean(
                registration.pen_certificate || registration.pen_number
              );
              if (consentKeyMap.pen_not_available_applied && !hasPenDocument) {
                setHasPENNumber(false);
                setShowPENUpload(false);
                setPenNotAvailableApplied(true);
              }

              if (
                consentKeyMap.aadhar_already_applied &&
                !(registration.aadhar_no && registration.aadhar_no.trim())
              ) {
                setAadharOptionData("No");
                setAppliedData("Yes");
                setIsAadharAppliedConsentSubmitted(true);
              }
            } else {
              setExistingConsentsByKey({});
            }
          } catch (consentError) {
            console.error("Error fetching existing consents:", consentError);
            setExistingConsentsByKey({});
          }
        } else {
          setExistingConsentsByKey({});
        }

        // Reset file states to null initially (user can upload new files)
        setPhoto(null);
        setFatherphoto(null);
        setMotherphoto(null);
        setGuardianphoto(null);
        setFatherAadharphoto(null);
        setMotherAadharphoto(null);
        setGuardianAadharphoto(null);
        setDOBphoto(null);
        setStudentAadharphoto(null);
        setCastephoto(null);
        setTransferphoto(null);
        setPENphoto(null);
        setBonafidephoto(null);
      } else {
        throw new Error("No registration data found");
      }
    } catch (error) {
      console.error("Error fetching registration data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load registration data. Please try again.",
      });
    }
  };

  useEffect(() => {
      fetchRegistrationData();
  }, []);

  console.log(formData?.is_child_adhaar_applied, "is_child_adhaar_applied");

  useEffect(() => {
    if (registrationId) {
      fetchInPersonDocuments(registrationId);
    }
  }, [registrationId, fetchInPersonDocuments]);

  useEffect(() => {
    const hasCastCertificate = Boolean(Castephoto || existingDocumentUrls.cast_certificate);
    if (!hasCastCertificate) {
      setFormData((prev) => {
        if (prev.minority_status === 'No') {
          return prev;
        }
        return {
          ...prev,
          minority_status: 'No',
        };
      });
    }
  }, [Castephoto, existingDocumentUrls.cast_certificate]);

  const [showPENUpload, setShowPENUpload] = useState(false);
  useEffect(() => {
    if (formData.select_class && formData.date_of_birth) {
      // Re-evaluate PEN/Bonafide questions when class or DOB changes
      const showPENQuestion = selectedClassId >= 5 && !isClassAgeAppropriate;
      const showBonafideQuestion = selectedClassId > 0 && selectedClassId <= 4 && !isClassAgeAppropriate;

      console.log("Re-evaluating certificate questions:");
      console.log("Class ID:", selectedClassId);
      console.log("Age Appropriate:", isClassAgeAppropriate);
      console.log("Show PEN Question:", showPENQuestion);
      console.log("Show Bonafide Question:", showBonafideQuestion);

      if (!showPENQuestion) {
        setHasPENNumber(null);
        setShowPENUpload(false);
      }

      if (!showBonafideQuestion) {
        setHasBonafideCertificate(null);
        setShowBonafideUpload(false);
      }
    }
  }, [formData.select_class, formData.date_of_birth, selectedClassId, isClassAgeAppropriate]);
  const getDocumentDisplay = (docKey, currentFile, existingUrl) => {
    // If user uploaded a new file, show preview
    if (currentFile) {
      return URL.createObjectURL(currentFile);
    }
    // If no new file but existing URL, show existing document
    if (existingUrl) {
      return existingUrl;
    }
    // Default placeholder
    return null;
  };
  // Add this to debug guardian photo consent

  useEffect(() => {
    const fetchSchoolAutomation = async () => {
      try {
        const response = await fetch(
          "https://api.mirai.healthcare/api/head/school-rule/school-automation",
          {
            headers: {
              "x-auth": authtoken,
              Accept: "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch school automation: ${response.status}`);
        }

        const payload = await response.json();
        const record = Array.isArray(payload) ? payload[0] : payload;

        if (record?.enq_session_id) {
          setFormData((prev) => ({
            ...prev,
            session: record.enq_session_id.toString(),
          }));
        }

        if (record?.enq_dob) {
          setEnqDob(record.enq_dob);
        }
      } catch (error) {
        console.error("Error fetching school automation:", error);
      }
    };

    fetchSchoolAutomation();
  }, [authtoken]);

  // ✅ Fetch service permissions and filter address dropdown
  useEffect(() => {
    const fetchServicePermissions = async () => {
      try {
        const response = await fetch(
          "https://api.mirai.healthcare/api/user/service-permission/student-reg",
          {
            headers: {
              "x-auth": `${authtoken}`,
            },
          }
        );
        const data = await response.json();

        if (data.success) {
          const permissions = {
            studentAadhar:
              data.message.returnService?.find(
                (service) => service.module_code === "STUDENT-AADHAR"
              )?.active || false,
            fatherAadhar:
              data.message.returnService?.find(
                (service) => service.module_code === "STUDENT-FATHER-AADHAR"
              )?.active || false,
            motherAadhar:
              data.message.returnService?.find(
                (service) => service.module_code === "STUDENT-MOTHER-AADHAR"
              )?.active || false,
            guardianAadhar:
              data.message.returnService?.find(
                (service) => service.module_code === "STUDENT-GUARDIAN-AADHAR"
              )?.active || false,
            studentMobileVerify:
              data.message.returnService?.find(
                (service) => service.module_code === "STUDENT-MOB-VERIFY"
              )?.active || false,
            motherMobileVerify:
              data.message.returnService.find(
                (service) => service.module_code === "STUDENT-MOTHER-MOB-VERIFY"
              )?.active || false,
            emailVerify:
              data.message.returnService?.find(
                (service) => service.module_code === "STUDENT-EMAIL-VERIFY"
              )?.active || false,
          };

          setServicePermissions(permissions);

          // ✅ Build allowed address options based on permissions
          const allowedAddresses = [];

          if (permissions.fatherAadhar) {
            allowedAddresses.push({
              value: "Father Address",
              label: "Father Address (as per aadhar card)",
            });
          }
          if (permissions.motherAadhar) {
            allowedAddresses.push({
              value: "Mother Address",
              label: "Mother Address (as per aadhar card)",
            });
          }
          if (permissions.guardianAadhar) {
            allowedAddresses.push({
              value: "Guardian Address",
              label: "Guardian Address (as per aadhar card)",
            });
          }

          // Always include student & other options
          allowedAddresses.push({
            value: "Student Address",
            label: "Student Address (as per aadhar card)",
          });
          allowedAddresses.push({ value: "Other", label: "Other" });

          // ✅ Update dropdown state
          setAddressSelectData(allowedAddresses);
        }
      } catch (error) {
        console.error("Error fetching service permissions:", error);
      }
    };

    fetchServicePermissions();
  }, [authtoken]);
  useEffect(() => {
    if (autoFillAadhar) {
      // Auto-fill Aadhar name with birth certificate name
      handleChange('student_aadhar_name', formData.student_full_name);
      // Auto-fill Aadhar DOB with birth certificate DOB
      handleChange('aadhar_date_of_birth', formData.date_of_birth);
    }
  }, [autoFillAadhar, formData.student_full_name, formData.date_of_birth]);
  const [showOfflinePayment, setShowOfflinePayment] = useState(false);
  const [banks, setBanks] = useState([]);
  const [createdRegistrationId, setCreatedRegistrationId] = useState(null);
  
  const [staffOptions, setStaffOptions] = useState([]);

 

  // Add this useEffect to fetch banks when component mounts
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await fetch("https://api.mirai.healthcare/api/fee-service/bank?is_school_bank=true", {
          headers: {
            "x-auth": authtoken,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch banks');

        const data = await response.json();
        if (data.success) {
          setBanks(data.message || []);
        }
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };

    fetchBanks();
  }, [authtoken]);

  useEffect(() => {
    const fetchRegistrationFee = async () => {
      try {
        const headers = {
          "x-auth": authtoken,
          Accept: 'application/json',
        };
        const response = await fetch("https://api.mirai.healthcare/api/head/school-rule/school-automation", {
          headers,
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch registration fee: ${response.status}`);
        }

        const payload = await response.json();
        const record = Array.isArray(payload)
          ? payload[0]
          : Array.isArray(payload?.data)
            ? payload.data[0]
            : payload?.data || payload;

        const feeValue = record?.registration_fee;

        if (feeValue !== undefined && feeValue !== null) {
          setFormData((prev) => {
            const feeAsString = feeValue.toString();
            if (prev.registration_fee === feeAsString) {
              return prev;
            }
            return {
              ...prev,
              registration_fee: feeAsString,
            };
          });
        }
      } catch (error) {
        console.error('Error fetching registration fee:', error);
      }
    };

    fetchRegistrationFee();
  }, [authtoken]);

  useEffect(() => {
    const fetchStaffMembers = async () => {
      try {
        const headers = {
          "x-auth": authtoken,
          Accept: 'application/json',
        };
        const response = await fetch("https://api.mirai.healthcare/api/staff-Registration", {
          method: 'GET',
          headers,
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch staff list: ${response.status}`);
        }

        const payload = await response.json();
        const staffList = payload?.data?.data || payload?.data || [];

        setStaffOptions(
          Array.isArray(staffList)
            ? staffList
              .filter((staff) => !staff.is_deleted)
              .map((staff) => ({
                value: staff.id,
                label: staff.staff_full_name || staff.first_name || `Staff #${staff.id}`,
              }))
            : []
        );
      } catch (error) {
        console.error('Error fetching staff list:', error);
      }
    };

    fetchStaffMembers();
  }, [authtoken]);

  // Add this useEffect to update payment_submited_by_id when userData changes
 

 
  const fetchConsentTypeData = async () => {
    try {
      const response = await axios.get(`https://api.mirai.healthcare/api/register/consent/types`, {
        headers: {
          "x-auth": `${authtoken}`,
          'Content-Type': 'application/json',
        },
      });
      setConsentTypeData(response?.data);
      const aadharAppliedConsent = response?.data?.data?.find(
        item => item.key === 'aadhar_already_applied'
      );
      setAadharAlreadyAppliedConsent(aadharAppliedConsent);
    } catch (err) {
      console.error('API error Profile:', err);
      setError(err);
      if (err.response && err.response.status === 401) {
        console.log('navigate to login due to 401');
        window.location.href = '/login';
      }
    }
  };

  useEffect(() => {
    fetchConsentTypeData();
  }, []);

  const StudentnameMismatchItem = ConsentTypeData?.data?.find(
    item => item.key === 'student_name_mismatch'
  );

  const StudentDOBMismatch = ConsentTypeData?.data?.find(
    item => item.key === 'student_dob_mismatch'
  );
  const StudentDataUsageConsent = ConsentTypeData?.data?.find(
    item => item.key === 'student_data_usage_consent',
  );
  const StudentAadharNotConsent = ConsentTypeData?.data?.find(
    item => item.key === 'student_aadhar_later',
  );
  const StudentAadharNotAppliedConsent = ConsentTypeData?.data?.find(
    item => item.key === 'aadhar_not_applied'
  );
  const FatherAadharMismatchItem = ConsentTypeData?.data?.find(
    item => item.key === 'father_aadhar_mismatch'
  );
  const MotherAadharMismatchItem = ConsentTypeData?.data?.find(
    item => item.key === 'mother_aadhar_mismatch'
  );
  const TCNotAvailable = ConsentTypeData?.data?.find(
    item => item.key === 'tc_not_available_applied'
  );
  const PENNumberMismatchItem = ConsentTypeData?.data?.find(
    item => item.key === 'pen_not_available_applied'
  );
  const BonafideMismatchItem = ConsentTypeData?.data?.find(
    item => item.key === 'bonafide_not_available_applied'
  );

  const [IsSelectedStudentAadhar, setIsSelectedStudentAadhar] = useState(false);
  const [StudentDOBMismatchItem, setStudentDOBMismatchItem] = useState(false);
  const [StudentDataUsageConsentItem, setStudentDataUsageConsentItem] = useState(false);
  const [StudentAadharNotAvailable, setStudentAadharNotAvailable] = useState(false);
  const [isAadharNotAppliedConsentAccepted, setIsAadharNotAppliedConsentAccepted] = useState(false);
  const [MotherAadharData, setMotherAadharData] = useState(false);
  const [PenNotAvailableApplied, setPenNotAvailableApplied] = useState(false);
  const [BonafideNotAvailableApplied, setBonafideNotAvailableApplied] = useState(false);
  const [useFatherAddress, setUseFatherAddress] = useState(false);
  const [useMotherAddress, setUseMotherAddress] = useState(false);




  const handleFileChange = (e) => {
    setTransferphoto(e.target.files[0]);
  };


  const getDocumentFile = useCallback(
    (docKey) => {
      switch (docKey) {
        case 'dob_certificate':
          return DOBphoto;
        case 'aadhar_file':
          return StudentAadharphoto;
        case 'cast_certificate':
          return Castephoto;
        case 'tc':
          return Transferphoto;
        case 'pen_certificate':
          return PENphoto;
        case 'bonafide_certificate':
          return Bonafidephoto;
        case 'father_aadhar_file':
          return FatherAadharphoto;
        case 'mother_aadhar_file':
          return MotherAadharphoto;
        case 'guardian_aadhar_file':
          return GuardianAadharphoto;
        case 'upload_photo':
          return photo;
        case 'father_photo':
          return Fatherphoto;
        case 'mother_photo_upload':
          return Motherphoto;
        case 'guardian_photo': // Add guardian photo case
          return Guardianphoto;
        default:
          return null;
      }
    },
    [
      DOBphoto,
      StudentAadharphoto,
      Castephoto,
      Transferphoto,
      FatherAadharphoto,
      MotherAadharphoto,
      GuardianAadharphoto,
      photo,
      Fatherphoto,
      Motherphoto,
      Guardianphoto, // Add Guardianphoto
    ]
  );

  const updateDocumentFile = useCallback(
    (docKey, file) => {
      switch (docKey) {
        case 'dob_certificate':
          setDOBphoto(file);
          break;
        case 'aadhar_file':
          setStudentAadharphoto(file);
          break;
        case 'cast_certificate':
          setCastephoto(file);
          break;
        case 'tc':
          setTransferphoto(file);
          break;
        case 'pen_certificate':
          setPENphoto(file);
          break;
        case 'bonafide_certificate':
          setBonafidephoto(file);
          break;
        case 'father_aadhar_file':
          setFatherAadharphoto(file);
          break;
        case 'mother_aadhar_file':
          setMotherAadharphoto(file);
          break;
        case 'guardian_aadhar_file':
          setGuardianAadharphoto(file);
          break;
        case 'upload_photo':
          setPhoto(file);
          break;
        case 'father_photo':
          setFatherphoto(file);
          break;
        case 'mother_photo_upload':
          setMotherphoto(file);
          break;
        case 'guardian_photo':
          setGuardianphoto(file);
          break;
        default:
          break;
      }

      handleChange(docKey, file || null);
    },
    [handleChange]
  );

  const clearDocumentFile = useCallback(
    (docKey) => {
      updateDocumentFile(docKey, null);
    },
    [updateDocumentFile]
  );

  const handleDocumentFileUpload = useCallback(
    (docKey, file) => {
      if (!file) {
        clearDocumentFile(docKey);
        return;
      }

      updateDocumentFile(docKey, file);

      setInPersonDocs((prev) => ({
        ...prev,
        [docKey]: {
          ...prev[docKey],
          isSelected: prev[docKey]?.isSelected || false,
        },
      }));
    },
    [clearDocumentFile, updateDocumentFile]
  );

  const getExistingDocumentUrl = useCallback(
    (docKey) => {
      if (!existingDocumentUrls) {
        return null;
      }

      const keyMap = {
        guardian_photo: 'upload_guardian_photo',
      };

      const resolvedKey = keyMap[docKey] || docKey;
      return existingDocumentUrls[resolvedKey] || null;
    },
    [existingDocumentUrls]
  );

  const handleViewDocument = useCallback(
    (docKey) => {
      const file = getDocumentFile(docKey);
      const existingUrl = getExistingDocumentUrl(docKey);

      if (file) {
        const objectUrl = URL.createObjectURL(file);
        const newWindow = window.open(objectUrl, '_blank', 'noopener,noreferrer');

        // if (!newWindow) {
        //   Swal.fire({
        //     icon: 'info',
        //     title: 'Unable to Open',
        //     text: 'Please allow pop-ups to view the document.',
        //   });
        // }

        setTimeout(() => {
          URL.revokeObjectURL(objectUrl);
        }, 1000);
        return;
      }

      if (existingUrl) {
        const newWindow = window.open(existingUrl, '_blank', 'noopener,noreferrer');

        // if (!newWindow) {
        //   Swal.fire({
        //     icon: 'info',
        //     title: 'Unable to Open',
        //     text: 'Please allow pop-ups to view the document.',
        //   });
        // }
        return;
      }

      Swal.fire({
        icon: 'info',
        title: 'No Document Found',
        text: 'No document is available to view.',
      });
    },
    [getDocumentFile, getExistingDocumentUrl]
  );

  const renderViewButton = useCallback(
    (docKey) => {
      const file = getDocumentFile(docKey);
      const existingUrl = getExistingDocumentUrl(docKey);

      if (!file && !existingUrl) {
        return null;
      }

      return (
        <button
          type="button"
          className="btn btn-sm btn-outline-primary ms-2"
          onClick={() => handleViewDocument(docKey)}
        >
          <i className="ti ti-eye me-1"></i>
          View
        </button>
      );
    },
    [getDocumentFile, getExistingDocumentUrl, handleViewDocument]
  );

  const toggleInPersonDocument = useCallback(
    (docKey) => {
      setInPersonDocs((prev) => {
        const current = prev[docKey] || { isSelected: false, notes: '' };
        const nextIsSelected = !current.isSelected;
        return {
          ...prev,
          [docKey]: {
            isSelected: nextIsSelected,
            notes: nextIsSelected ? current.notes : '',
          },
        };
      });
    },
    []
  );

  const updateInPersonNotes = useCallback((docKey, notes) => {
    setInPersonDocs((prev) => ({
      ...prev,
      [docKey]: {
        ...prev[docKey],
        notes,
      },
    }));
  }, []);


  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  console.log(selectedClassId, "selectedClassId")
  const [previews, setPreviews] = useState({
    father_photo: null,
    mother_photo_upload: null,
    upload_guardian_photo: null,
    upload_photo: null
  });
  const [referenceData, setReferenceData] = useState({
    ref_name: '',
    ref_role: '',
    ref_year_of_leaving: '',
    ref_contact_no: '',
    ref_note: '',
    ref_admission_no: '',
    ref_employee_code: '',
    is_ref: false
  });
  const [isReferenceVerified, setIsReferenceVerified] = useState({});
  const [referenceVerificationData, setReferenceVerificationData] = useState({});

  useEffect(() => {
    const clsId = Number(selectedClassId);
    const classList = Array.isArray(Class)
      ? Class
      : Array.isArray(Class?.data)
        ? Class.data
        : [];

    const matchedClass = classList?.find((cls) => Number(cls.id) === clsId);

    setIsNurseryClass(Boolean(matchedClass && typeof matchedClass.Classes === 'string' && matchedClass.Classes.trim().toLowerCase() === 'nursery'));

    if (!matchedClass || !matchedClass.Age_Group || !formData.date_of_birth) {
      setIsClassAgeAppropriate(false);
      return;
    }

    // Use enq_dob for age calculation if available
    let referenceDate = dayjs();
    if (enqDob) {
      referenceDate = dayjs(enqDob);
    }

    const [minAgeRaw, maxAgeRaw] = matchedClass.Age_Group.split('-').map((part) => parseFloat(part.trim()));
    if (Number.isNaN(minAgeRaw) || Number.isNaN(maxAgeRaw)) {
      setIsClassAgeAppropriate(false);
      return;
    }

    const dob = dayjs(formData.date_of_birth);
    if (!dob.isValid()) {
      setIsClassAgeAppropriate(false);
      return;
    }

    const ageInYears = referenceDate.diff(dob, 'month', true) / 12;
    const minAgeAdjusted = Math.max(0, minAgeRaw - 0.5);
    const maxAgeAdjusted = maxAgeRaw + 0.5;
    setIsClassAgeAppropriate(ageInYears >= minAgeAdjusted && ageInYears <= maxAgeAdjusted);
  }, [Class, formData.date_of_birth, selectedClassId, enqDob]);


  useEffect(() => {
    const showPENQuestion = selectedClassId >= 5 && !isClassAgeAppropriate;

    // Additional check: Don't show PEN question for 4-year-olds in LKG/Nursery (edge case extension)
    if (selectedClassId > 0 && selectedClassId <= 4 && formData.date_of_birth) {
      let referenceDate = dayjs();
      if (enqDob) {
        referenceDate = dayjs(enqDob);
      }

      const dob = dayjs(formData.date_of_birth);
      if (dob.isValid()) {
        const ageInYears = referenceDate.diff(dob, 'year', true);

        const classList = Array.isArray(Class?.data) ? Class.data : [];
        const matchedClass = classList?.find((cls) => Number(cls.id) === selectedClassId);

        if (matchedClass && (matchedClass.Classes === "Nursery" || matchedClass.Classes === "LKG")) {
          const isExactlyFourYearsOld = ageInYears >= 3.5 && ageInYears <= 4.5;

          if (isExactlyFourYearsOld) {
            console.log('Hiding PEN question: 4-year-old in', matchedClass.Classes);
            setHasPENNumber(null);
            setShowPENUpload(false);
            setPenNotAvailableApplied(false);
            setPENphoto(null);
            setFormData((prev) => ({ ...prev, pen_number: '' }));
            handleChange('pen_certificate', null);
            return;
          }
        }
      }
    }

    if (!showPENQuestion) {
      setHasPENNumber(null);
      setShowPENUpload(false);
      setPenNotAvailableApplied(false);
      setPENphoto(null);
      setFormData((prev) => ({ ...prev, pen_number: '' }));
      handleChange('pen_certificate', null);
    }
  }, [isClassAgeAppropriate, selectedClassId, formData.date_of_birth, Class, enqDob]);

  // Replace the current Bonafide question useEffect with this
  useEffect(() => {
    const showBonafideQuestion = selectedClassId > 0 && selectedClassId <= 4 && !isClassAgeAppropriate;

    // Additional check: Don't show Bonafide question for 4-year-olds in LKG/Nursery
    if (selectedClassId > 0 && selectedClassId <= 4 && formData.date_of_birth) {
      // Use enq_dob for age calculation
      let referenceDate = dayjs();
      if (enqDob) {
        referenceDate = dayjs(enqDob);
      }

      const dob = dayjs(formData.date_of_birth);
      if (dob.isValid()) {
        const ageInYears = referenceDate.diff(dob, 'year', true);

        // Get class details
        const classList = Array.isArray(Class?.data) ? Class.data : [];
        const matchedClass = classList?.find((cls) => Number(cls.id) === selectedClassId);

        // If student is exactly 4 years old and class is Nursery or LKG, hide Bonafide question
        if (matchedClass && (matchedClass.Classes === "Nursery" || matchedClass.Classes === "LKG")) {
          const isExactlyFourYearsOld = ageInYears >= 3.5 && ageInYears <= 4.5; // Allow some margin

          if (isExactlyFourYearsOld) {
            console.log('Hiding Bonafide question: 4-year-old in', matchedClass.Classes);
            setHasBonafideCertificate(null);
            setShowBonafideUpload(false);
            setBonafideNotAvailableApplied(false);
            setBonafidephoto(null);
            handleChange('bonafide_certificate', null);
            return;
          }
        }
      }
    }

    // Original logic for other cases
    if (!showBonafideQuestion) {
      setHasBonafideCertificate(null);
      setShowBonafideUpload(false);
      setBonafideNotAvailableApplied(false);
      setBonafidephoto(null);
      handleChange('bonafide_certificate', null);
    }
  }, [isClassAgeAppropriate, selectedClassId, formData.date_of_birth, Class, enqDob]);

  useEffect(() => {
    if (!isNurseryClass) {
      return;
    }

    setTCOptionData('');
    setTCNotAvailableData(false);
    setTransferphoto(null);
    setFormData((prev) => ({
      ...prev,
      transfer_certificate_no: '',
      last_school_name: '',
    }));
    handleChange('tc', null);
  }, [isNurseryClass]);
  const addNewReferral = () => {
    const newIndex = referrals.length;

    setReferrals([
      ...referrals,
      {
        ref_name: "",
        ref_role: "",
        ref_admission_no: "",
        ref_employee_code: "",
        ref_year_of_leaving: "",
        ref_contact_no: "",
        ref_note: "",
        ref_is_current: false,
        ref_relation: "",
        is_deleted: false,
      },
    ]);

    // Initialize verification states for the new referral
    setIsReferenceVerified((prev) => ({ ...prev, [newIndex]: false }));
    setReferenceVerificationData((prev) => ({ ...prev, [newIndex]: null }));
    setSelectedVerificationFields((prev) => ({ ...prev, [newIndex]: [] }));

    // Ensure referral flag is enabled so verification controls are visible for new entries
    setFormData((prev) => (prev.is_ref ? prev : { ...prev, is_ref: true }));
  };

  const updateReferral = (index, field, value) => {
    setReferrals((prev) =>
      prev.map((referral, i) =>
        i === index ? { ...referral, [field]: value } : referral
      )
    );
  };
  const deleteReferral = (index) => {
    const referral = referrals[index];
    if (referral.id) {
      const updatedReferrals = referrals.map((ref, i) =>
        i === index ? { ...ref, is_deleted: true } : ref
      );
      setReferrals(updatedReferrals);
      setDeletedReferralIds((prev) => [...prev, referral.id]);
      const hasActive = updatedReferrals.some((ref) => !ref.is_deleted);
      setFormData((prev) => ({ ...prev, is_ref: hasActive }));
    } else {
      const updatedReferrals = referrals.filter((_, i) => i !== index);
      setReferrals(updatedReferrals);
      setIsReferenceVerified((prev) => {
        const { [index]: _, ...rest } = prev;
        return rest;
      });
      setReferenceVerificationData((prev) => {
        const { [index]: _, ...rest } = prev;
        if (prev?.currentIndex === index) {
          return { ...rest, currentIndex: undefined };
        }
        return rest;
      });
      setSelectedVerificationFields((prev) => {
        const { [index]: _, ...rest } = prev;
        return rest;
      });
      const hasActive = updatedReferrals.some((ref) => !ref.is_deleted);
      setFormData((prev) => ({ ...prev, is_ref: hasActive }));
    }
  };

  const [hasPENNumber, setHasPENNumber] = useState(null);

  const [AppliedData, setAppliedData] = useState('');
  const ContactEmailId = RegistrationData?.data?.emailid;
  const ContactNumberMobile = RegistrationData?.data?.contactno;
  const EnquiryId = RegistrationData?.data?.id;
  const formattedCastCategory = Array.isArray(CastCategory?.data)
    ? CastCategory.data.map((cls) => ({
      value: cls.id,
      label: cls.category,
    }))
    : [];
  const selectedCasteLabel = useMemo(() => {
    const selectedOption = formattedCastCategory?.find(
      (caste) => caste.value === formData.student_cast_category
    );
    return selectedOption?.label || '';
  }, [formattedCastCategory, formData.student_cast_category]);
  const isDocumentInScope = useCallback(
    (docKey) => {
      switch (docKey) {
        case 'cast_certificate':
          return Boolean(formData.student_cast_category) && selectedCasteLabel !== 'General' && formData.minority_status === 'Yes';

        case 'tc':
          return !isNurseryClass;

        case 'pen_certificate':
          return Boolean(showPENUpload);

        case 'bonafide_certificate':
          return Boolean(showBonafideUpload);

        case 'father_aadhar_file':
          if (formData.is_single_parent) {
            return formData.single_parent === 'father';
          }
          return true;

        case 'mother_aadhar_file':
          if (formData.is_single_parent) {
            return formData.single_parent === 'mother';
          }
          return true;

        case 'guardian_aadhar_file':
          return formData.is_single_parent && formData.single_parent === 'guardian';

        case 'guardian_photo':
          // Guardian photo consent only required when single parent is guardian
          return formData.is_single_parent && formData.single_parent === 'guardian';

        default:
          return true;
      }
    },
    [
      formData.is_single_parent,
      formData.single_parent,
      formData.minority_status,
      formData.student_cast_category,
      isNurseryClass,
      showPENUpload,
      showBonafideUpload,
      selectedCasteLabel,
    ]
  );
  // Auto-fill contact numbers when component loads
  useEffect(() => {
    if (!RegistrationData?.data) return;

    const primaryIndicator = RegistrationData.data.primary_contact_no || "";
    const primaryNumber = RegistrationData.data.contactno || "";
    const sanitizedPrimaryNumber = sanitizeContactInput(primaryNumber);

    if (formData.is_single_parent) {
      if (formData.single_parent === "father" && !formData.father_mobile_no && sanitizedPrimaryNumber) {
        handleChange("father_mobile_no", sanitizedPrimaryNumber);
      }
      if (formData.single_parent === "mother" && !formData.mother_contact_no && sanitizedPrimaryNumber) {
        handleChange("mother_contact_no", sanitizedPrimaryNumber);
      }
      if (formData.single_parent === "guardian" && !formData.guardian_mobile_no && sanitizedPrimaryNumber) {
        handleChange("guardian_mobile_no", sanitizedPrimaryNumber);
      }
    } else if (primaryIndicator && sanitizedPrimaryNumber) {
      const indicator = primaryIndicator.toLowerCase();
      if (indicator === "father" && !formData.father_mobile_no) {
        handleChange("father_mobile_no", sanitizedPrimaryNumber);
      }
      if (indicator === "mother" && !formData.mother_contact_no) {
        handleChange("mother_contact_no", sanitizedPrimaryNumber);
      }
    }
  }, [RegistrationData, formData.is_single_parent, formData.single_parent, formData.father_mobile_no, formData.mother_contact_no, formData.guardian_mobile_no, handleChange]);
  const isDocumentSatisfied = useCallback(
    (docKey) => {
      if (!isDocumentInScope(docKey)) {
        return true;
      }

      const hasFile = Boolean(getDocumentFile(docKey));
      const inPersonSelected = Boolean(inPersonDocs[docKey]?.isSelected);
      const hasExistingDocument = Boolean(existingDocumentUrls[docKey]); // Check if document already exists in API

      // Document is satisfied if:
      // - User uploaded a new file, OR
      // - User selected in-person submission, OR  
      // - Document already exists in API (already uploaded)
      return hasFile || inPersonSelected || hasExistingDocument;
    },
    [getDocumentFile, inPersonDocs, isDocumentInScope, existingDocumentUrls] // Add existingDocumentUrls to dependencies
  );
  useEffect(() => {
    console.log("=== GUARDIAN PHOTO CONSENT DEBUG ===");
    console.log("Is Single Parent:", formData.is_single_parent);
    console.log("Single Parent Role:", formData.single_parent);
    console.log("Is Guardian Photo in scope:", isDocumentInScope('guardian_photo'));
    console.log("Has Guardian Photo file:", Boolean(getDocumentFile('guardian_photo')));
    console.log("Has existing Guardian Photo:", Boolean(existingDocumentUrls.upload_guardian_photo));
    console.log("Is Guardian Photo satisfied:", isDocumentSatisfied('guardian_photo'));
    console.log("Requires Guardian Photo consent:",
      isDocumentInScope('guardian_photo') && !isDocumentSatisfied('guardian_photo'));
    console.log("=== END GUARDIAN DEBUG ===");
  }, [
    formData.is_single_parent,
    formData.single_parent,
    isDocumentInScope,
    getDocumentFile,
    existingDocumentUrls.upload_guardian_photo,
    isDocumentSatisfied
  ]);
  useEffect(() => {
    setPrimarySelectionsInitialized(false);
  }, [formData.is_single_parent, formData.single_parent]);

  useEffect(() => {
    if (!RegistrationData?.data) return;
    if (primarySelectionsInitialized) return;

    const indicator = (RegistrationData.data.primary_contact_no || "").toLowerCase();
    const isSingle = formData.is_single_parent;
    const singleParentRole = (formData.single_parent || "").toLowerCase();

    const availableContacts = new Set(ContactNumberData2.map((opt) => opt.value));

    let defaultContact = "Primary";
    if (isSingle) {
      if (singleParentRole === "father") defaultContact = "Father";
      else if (singleParentRole === "mother") defaultContact = "Mother";
      else if (singleParentRole === "guardian") defaultContact = "Guardian";
    } else if (indicator === "father" || indicator === "mother" || indicator === "guardian") {
      defaultContact = indicator.charAt(0).toUpperCase() + indicator.slice(1);
    }
    if (!availableContacts.has(defaultContact)) {
      defaultContact = ContactNumberData2[0]?.value || defaultContact;
    }
    setContactNumberData(defaultContact);

    let defaultEmail = defaultContact;
    if (defaultEmail === "Primary") {
      if (indicator === "mother") defaultEmail = "Mother";
      else if (indicator === "father") defaultEmail = "Father";
      else if (indicator === "guardian") defaultEmail = "Guardian";
      else if (isSingle && singleParentRole) {
        defaultEmail = singleParentRole.charAt(0).toUpperCase() + singleParentRole.slice(1);
      }
    }
    if (!EmailData2.some((opt) => opt.value === defaultEmail)) {
      defaultEmail = EmailData2[0]?.value || "";
    }
    setEmailData(defaultEmail);
    const emailFieldMap = {
      Father: "father_email",
      Mother: "mother_email",
      Guardian: "guardian_email",
    };
    const resolvedEmailField = emailFieldMap[defaultEmail] || "father_email";
    setParentEmailTarget(resolvedEmailField);
    setParentEmailTargetValue(formData[resolvedEmailField] || "");

    let defaultAddressValue = "";
    if (isSingle) {
      if (singleParentRole === "father") defaultAddressValue = "Father Address";
      else if (singleParentRole === "mother") defaultAddressValue = "Mother Address";
      else if (singleParentRole === "guardian") defaultAddressValue = "Guardian Address";
    } else {
      if (indicator === "father") defaultAddressValue = "Father Address";
      else if (indicator === "mother") defaultAddressValue = "Mother Address";
    }
    if (!defaultAddressValue) {
      defaultAddressValue = AddressSelectData2[0]?.value || "";
    }
    const addressOption = AddressSelectData2?.find((opt) => opt.value === defaultAddressValue) || AddressSelectData2[0];
    if (addressOption) {
      const { value } = addressOption;
      setSelectedAddressType(value);
      setFormData((prev) => {
        if (value === "Student Address" && prev.student_address) {
          const addr = prev.student_address;
          return {
            ...prev,
            contact_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
            city_state: addr.state,
            pincode: addr.pin,
            permanent_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
          };
        }
        if (value === "Father Address" && prev.father_address) {
          const addr = prev.father_address;
          return {
            ...prev,
            contact_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
            city_state: addr.state,
            pincode: addr.pin,
            permanent_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
          };
        }
        if (value === "Mother Address" && prev.mother_address) {
          const addr = prev.mother_address;
          return {
            ...prev,
            contact_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
            city_state: addr.state,
            pincode: addr.pin,
            permanent_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
          };
        }
        if (value === "Guardian Address" && prev.guardian_address) {
          const addr = prev.guardian_address;
          return {
            ...prev,
            contact_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
            city_state: addr.state,
            pincode: addr.pin,
            permanent_address: `${addr.house}, ${addr.street}, ${addr.loc}`,
          };
        }
        if (value === "Other") {
          return {
            ...prev,
            contact_address: "",
            city_state: "",
            pincode: "",
            permanent_address: "",
          };
        }
        return prev;
      });
    }

    setPrimarySelectionsInitialized(true);
  }, [
    RegistrationData,
    formData.is_single_parent,
    formData.single_parent,
    ContactNumberData2,
    EmailData2,
    AddressSelectData2,
    primarySelectionsInitialized,
  ]);

  useEffect(() => {
    setPrimarySelectionsInitialized(false);
  }, [RegistrationData?.data?.id]);
  useEffect(() => {
    if (RegistrationData?.data?.is_ref) {
      setReferenceData({
        ref_name: RegistrationData.data.ref_name || '',
        ref_role: RegistrationData.data.ref_role || '',
        ref_year_of_leaving: RegistrationData.data.ref_year_of_leaving || '',
        ref_contact_no: RegistrationData.data.ref_contact_no || '',
        ref_note: RegistrationData.data.ref_note || '',
        ref_admission_no: RegistrationData.data.ref_admission_no || '',
        ref_employee_code: RegistrationData.data.ref_employee_code || '',
        is_ref: RegistrationData.data.is_ref || false
      });
    }
  }, [RegistrationData]);
  // const [selectedVerificationFields, setSelectedVerificationFields] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleView360 = (index) => {
    console.log("Opening 360 view for index:", index);
    console.log("Reference verification data:", referenceVerificationData[index]);
    if (referenceVerificationData && referenceVerificationData[index]) {
      setReferenceVerificationData((prev) => ({
        ...prev,
        currentIndex: index,
      }));
      setIsModalVisible(true);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No verified reference data available for this referral.",
      });
    }
  };

  const [otpSent, setOtpSent] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");


  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      is_father_mobile_verified: Boolean(verifiedContacts.father_mobile_no),
      is_mother_mobile_verified: Boolean(verifiedContacts.mother_mobile_no),
      is_guardian_mobile_verified: Boolean(verifiedContacts.guardian_mobile_no),
    }));
  }, [verifiedContacts]);
  const [otpState, setOtpState] = useState({
    sent: false,
    verifying: false,
    verified: false,
    uuid: null,
    targetField: null,
    targetNumber: ''
  });
  const [otpUuid, setOtpUuid] = useState(null);
  const [otpTargetField, setOtpTargetField] = useState(null);
  const [otpTargetNumber, setOtpTargetNumber] = useState("");
  const [isSubmittingOtp, setIsSubmittingOtp] = useState(false);

  const isFatherTempAlreadyVerified = useMemo(() => {
    if (!isEditingContact.father_mobile_no) {
      return false;
    }
    return isAlreadyVerifiedContact(
      tempContactNumbers.father_mobile_no,
      'father_mobile_no',
      verifiedNumbers,
      verifiedContacts
    );
  }, [
    isEditingContact.father_mobile_no,
    tempContactNumbers.father_mobile_no,
    verifiedNumbers,
    verifiedContacts,
  ]);

  const isMotherTempAlreadyVerified = useMemo(() => {
    if (!isEditingContact.mother_mobile_no) {
      return false;
    }
    return isAlreadyVerifiedContact(
      tempContactNumbers.mother_mobile_no,
      'mother_mobile_no',
      verifiedNumbers,
      verifiedContacts
    );
  }, [
    isEditingContact.mother_mobile_no,
    tempContactNumbers.mother_mobile_no,
    verifiedNumbers,
    verifiedContacts,
  ]);

  const isGuardianTempAlreadyVerified = useMemo(() => {
    if (!isEditingContact.guardian_mobile_no) {
      return false;
    }
    return isAlreadyVerifiedContact(
      tempContactNumbers.guardian_mobile_no,
      'guardian_mobile_no',
      verifiedNumbers,
      verifiedContacts
    );
  }, [
    isEditingContact.guardian_mobile_no,
    tempContactNumbers.guardian_mobile_no,
    verifiedNumbers,
    verifiedContacts,
  ]);

  const isFatherTempEmailAlreadyVerified = useMemo(() => {
    if (!isEditingEmail.father_email) {
      return false;
    }
    return isAlreadyVerifiedEmail(
      tempEmailValues.father_email,
      'father_email',
      verifiedEmailValues,
      verifiedEmails
    );
  }, [
    isEditingEmail.father_email,
    tempEmailValues.father_email,
    verifiedEmailValues,
    verifiedEmails,
  ]);

  const isMotherTempEmailAlreadyVerified = useMemo(() => {
    if (!isEditingEmail.mother_email) {
      return false;
    }
    return isAlreadyVerifiedEmail(
      tempEmailValues.mother_email,
      'mother_email',
      verifiedEmailValues,
      verifiedEmails
    );
  }, [
    isEditingEmail.mother_email,
    tempEmailValues.mother_email,
    verifiedEmailValues,
    verifiedEmails,
  ]);

  const isGuardianTempEmailAlreadyVerified = useMemo(() => {
    if (!isEditingEmail.guardian_email) {
      return false;
    }
    return isAlreadyVerifiedEmail(
      tempEmailValues.guardian_email,
      'guardian_email',
      verifiedEmailValues,
      verifiedEmails
    );
  }, [
    isEditingEmail.guardian_email,
    tempEmailValues.guardian_email,
    verifiedEmailValues,
    verifiedEmails,
  ]);

  const getContactNumberByField = (field) => {
    switch (field) {
      case "father_mobile_no":
        return formData.father_mobile_no;
      case "mother_mobile_no":
        return formData.mother_mobile_no;
      case "guardian_mobile_no":
        return formData.guardian_mobile_no;
      default:
        return "";
    }
  };

  const sendContactOtp = async (targetField) => {
    let contactNumber;

    if (isEditingContact[targetField]) {
      contactNumber = tempContactNumbers[targetField];
    } else {
      contactNumber = getContactNumberByField(targetField);
    }

    if (!contactNumber || !/^\d{10}$/.test(contactNumber)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Contact Number",
        text: "Please enter a valid 10-digit contact number before requesting an OTP.",
      });
      return;
    }

    const normalizedContact = normalizePhone(contactNumber);
    if (isAlreadyVerifiedContact(normalizedContact, targetField, verifiedNumbers, verifiedContacts)) {
      setVerifiedContacts((prev) => ({
        ...prev,
        [targetField]: true,
      }));
      setVerifiedNumbers((prev) => ({
        ...prev,
        [targetField]: normalizedContact,
      }));
      Swal.fire({
        icon: "info",
        title: "Already Verified",
        text: "This contact number is already verified.",
      });
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      "x-auth": authtoken || "",
    };

    setIsVerifyingContact(true);
    try {
      const response = await fetch("https://api.mirai.healthcare/api/sms/airtel/send-otp", {
        method: "POST",
        headers,
        body: JSON.stringify({
          mobile_no: contactNumber,
        }),
      });

      const data = await response.json();
      console.log("Send OTP Response:", data);

      if (response.ok && data.success) {
        const uuid = data.message?.data?.uuid || data.data?.uuid || data.uuid;

        if (!uuid) {
          throw new Error("OTP session reference not received. Please try again.");
        }

        // OTP state update karen
        setOtpState({
          sent: true,
          verifying: false,
          verified: false,
          uuid: uuid,
          targetField: targetField,
          targetNumber: normalizedContact
        });

        setVerifiedContacts((prev) => ({
          ...prev,
          [targetField]: false,
        }));
        setEnteredOtp("");

        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: `An OTP has been sent to ${contactNumber}. Please enter it below to verify the contact number.`,
        });
      } else {
        throw new Error(data.message || data.message?.message || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("Send OTP Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to send OTP. Please try again.",
      });
    } finally {
      setIsVerifyingContact(false);
    }
  };

  const verifyContactOtp = async () => {
    const sanitizedOtp = enteredOtp.trim();

    if (!otpState.sent || !otpState.uuid) {
      Swal.fire({
        icon: "warning",
        title: "OTP Required",
        text: "Please request an OTP before attempting verification.",
      });
      return;
    }

    if (!/^\d{4,6}$/.test(sanitizedOtp)) {
      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
        text: "Please enter the 4 to 6 digit OTP received on your mobile.",
      });
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      "x-auth": authtoken || "",
    };

    setIsSubmittingOtp(true);
    try {
      const response = await fetch("https://api.mirai.healthcare/api/sms/airtel/verify-otp", {
        method: "POST",
        headers,
        body: JSON.stringify({
          otp: parseInt(sanitizedOtp, 10),
          uuid: otpState.uuid,
        }),
      });

      const data = await response.json();
      console.log("Verify OTP Response:", data);

      if (response.ok && data.success) {
        if (otpState.targetField) {
          setVerifiedContacts((prev) => ({
            ...prev,
            [otpState.targetField]: true,
          }));
          setVerifiedNumbers((prev) => ({
            ...prev,
            [otpState.targetField]: normalizePhone(otpState.targetNumber),
          }));

          // Auto-save verified number to formData if in edit mode
          if (isEditingContact[otpState.targetField]) {
            handleChange(otpState.targetField, otpState.targetNumber);
            setIsEditingContact(prev => ({
              ...prev,
              [otpState.targetField]: false
            }));
            setTempContactNumbers(prev => ({
              ...prev,
              [otpState.targetField]: otpState.targetNumber
            }));
          }
        }

        // OTP state reset karen
        setOtpState({
          sent: false,
          verifying: false,
          verified: true,
          uuid: null,
          targetField: null,
          targetNumber: ''
        });

        setEnteredOtp("");

        Swal.fire({
          icon: "success",
          title: "Verified",
          text: "Contact number verified successfully.",
        });
      } else {
        throw new Error(data.message || data.message?.message || "Failed to verify OTP. Please try again.");
      }
    } catch (error) {
      console.error("Verify OTP Error:", error);
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: error.message || "Invalid OTP. Please request a new OTP and try again.",
      });
    } finally {
      setIsSubmittingOtp(false);
    }
  };

  useEffect(() => {
    if (!otpTargetField) return;
    const currentNumber =
      otpTargetField === "father_mobile_no"
        ? formData.father_mobile_no
        : otpTargetField === "mother_mobile_no"
          ? formData.mother_mobile_no
          : otpTargetField === "guardian_mobile_no"
            ? formData.guardian_mobile_no
            : "";

    if (currentNumber !== otpTargetNumber) {
      setOtpSent(false);
      setOtpUuid(null);
      setEnteredOtp("");
      setVerifiedContacts((prev) => ({
        ...prev,
        [otpTargetField]: false,
      }));
    }
  }, [formData.father_mobile_no, formData.mother_mobile_no, formData.guardian_mobile_no, otpTargetField, otpTargetNumber]);


  // Add this useEffect after existing useEffects
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await fetch("https://api.mirai.healthcare/api/masters/classes", {
          headers: {
            "x-auth": authtoken,
          },
        });
        if (!response.ok) {
          throw new Error(`Classes API failed with status ${response.status}`);
        }
        const data = await response.json();
        if (data.success) {
          setClasses(data.data || []);
        } else {
          throw new Error("Classes API returned success: false.");
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClasses();
  }, []);

  // Add this function before the return statement
  const calculateAgeMatch = (dob, classId) => {
    if (!dob || !classId) return false;

    // Use enq_dob for age calculation if available, otherwise use current date
    let referenceDate = new Date();
    if (enqDob) {
      referenceDate = new Date(enqDob);
    }

    const birthDate = new Date(dob);

    // Calculate age in years using Math.floor()
    const ageInMilliseconds = referenceDate - birthDate;
    const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25));

    const selectedClass = classes?.find(cls => cls.id === parseInt(classId));
    if (!selectedClass || !selectedClass.Age_Group) return false;

    const [minAge, maxAge] = selectedClass.Age_Group.split("-").map(Number);
    return ageInYears >= minAge && ageInYears <= maxAge;
  };




  const [parentEmailOTP, setParentEmailOTP] = useState("");
  const [parentEmailSent, setParentEmailSent] = useState(false);
  const [parentEmailVerified, setParentEmailVerified] = useState(false);
  const [isSendingParentOTP, setIsSendingParentOTP] = useState(false);
  const [isVerifyingParentOTP, setIsVerifyingParentOTP] = useState(false);
  const [parentEmailTarget, setParentEmailTarget] = useState("father_email");
  const [parentEmailTargetValue, setParentEmailTargetValue] = useState("");

  const sendParentEmailOTP = async (targetField = "father_email") => {
    let email;

    if (isEditingEmail[targetField]) {
      email = tempEmailValues[targetField];
    } else {
      email = formData[targetField];
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      Swal.fire("Invalid Email", "Please enter a valid email address.", "error");
      return;
    }

    const normalizedEmail = normalizeEmail(email);

    if (isAlreadyVerifiedEmail(normalizedEmail, targetField, verifiedEmailValues, verifiedEmails)) {
      setVerifiedEmails(prev => ({
        ...prev,
        [targetField]: true
      }));

      setVerifiedEmailValues(prev => ({
        ...prev,
        [targetField]: normalizedEmail
      }));

      Swal.fire("Already Verified", "This email address is already verified.", "info");
      return;
    }

    setParentEmailTarget(targetField);
    setIsSendingParentOTP(true);
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      // Add auth token if available
      if (authtoken) {
        headers["x-auth"] = authtoken;
      }

      const response = await fetch("https://api.mirai.healthcare/api/enquiry/send-otp", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (response.ok) {
        setParentEmailSent(true);
        setParentEmailTargetValue(normalizedEmail);
        setParentEmailOTP("");
        setParentEmailVerified(false);
        Swal.fire("OTP Sent", `An OTP has been sent to ${email}.`, "success");
      } else {
        throw new Error(data.message || "Failed to send OTP.");
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setIsSendingParentOTP(false);
    }
  };

  const verifyParentEmailOTP = async () => {
    const emailField = parentEmailTarget || "father_email";
    let email;

    if (isEditingEmail[emailField]) {
      email = tempEmailValues[emailField];
    } else {
      email = formData[emailField];
    }

    if (!/^\d{6}$/.test(parentEmailOTP)) {
      Swal.fire("Invalid OTP", "Enter a valid 6-digit OTP.", "error");
      return;
    }

    const normalizedCurrent = normalizeEmail(email);
    if (!normalizedCurrent || normalizedCurrent !== parentEmailTargetValue) {
      Swal.fire("Email Changed", "The email address has changed since the OTP was sent. Please request a new OTP.", "warning");
      return;
    }

    setIsVerifyingParentOTP(true);
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      // Add auth token if available
      if (authtoken) {
        headers["x-auth"] = authtoken;
      }

      const response = await fetch("https://api.mirai.healthcare/api/enquiry/verify-otp", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          email,
          otp: parseInt(parentEmailOTP, 10),
          // Remove userData reference or make it optional
          verified_by: userData?.currentUser?.id || null
        }),
      });

      const data = await response.json();
      if (response.ok) {
        // Set per-field verification
        setVerifiedEmails(prev => ({
          ...prev,
          [emailField]: true
        }));

        setVerifiedEmailValues(prev => ({
          ...prev,
          [emailField]: normalizeEmail(email)
        }));

        // Auto-save verified email to formData if in edit mode
        if (isEditingEmail[emailField]) {
          handleChange(emailField, email);
          setIsEditingEmail(prev => ({
            ...prev,
            [emailField]: false
          }));
          setTempEmailValues(prev => ({
            ...prev,
            [emailField]: email
          }));
        }

        // Update the main email verification status
        setParentEmailSent(false);
        setParentEmailOTP("");
        setParentEmailTargetValue("");
        setEmailInfoMessages(prev => ({
          ...prev,
          [emailField]: 'This email is already verified.'
        }));
        Swal.fire("Verified", "Email verified successfully.", "success");
      } else {
        throw new Error(data.message || "Invalid OTP.");
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setIsVerifyingParentOTP(false);
    }
  };

  // Update useEffect for email change detection to include temp values if editing
  useEffect(() => {
    if (!parentEmailSent) return;
    const currentEmailField = parentEmailTarget || 'father_email';
    let currentEmail = formData[currentEmailField] || "";
    if (isEditingEmail[currentEmailField]) {
      currentEmail = tempEmailValues[currentEmailField] || "";
    }
    const normalizedCurrent = normalizeEmail(currentEmail);
    if (normalizedCurrent !== parentEmailTargetValue) {
      setParentEmailSent(false);
      setParentEmailOTP("");

      const alreadyVerified = isAlreadyVerifiedEmail(
        normalizedCurrent,
        currentEmailField,
        verifiedEmailValues,
        verifiedEmails
      );

      setVerifiedEmails(prev => ({
        ...prev,
        [currentEmailField]: alreadyVerified
      }));

      setVerifiedEmailValues(prev => ({
        ...prev,
        [currentEmailField]: alreadyVerified ? normalizedCurrent : ''
      }));
    }
  }, [
    formData.father_email,
    formData.mother_email,
    formData.guardian_email,
    tempEmailValues.father_email,
    tempEmailValues.mother_email,
    tempEmailValues.guardian_email,
    parentEmailSent,
    parentEmailTarget,
    parentEmailTargetValue,
    isEditingEmail,
    verifiedEmailValues,
    verifiedEmails
  ]);

  // Add guardian_email to formData if not present
  useEffect(() => {
    if (!formData.guardian_email !== undefined) {
      handleChange('guardian_email', '');
    }
  }, []);


  // Updated verifyReference function
  const [selectedVerificationFields, setSelectedVerificationFields] = useState({});

  const buildReferenceSummary = (refData, role) => {
    const rows = [];
    const addRow = (label, value) => {
      const safeValue = value === undefined || value === null || value === "" ? "N/A" : value;
      rows.push(`<p><strong>${label}:</strong> ${safeValue}</p>`);
    };

    addRow("Name", refData.student_full_name || refData.staff_full_name || refData.full_name);

    if (role === "student") {
      addRow("Admission No", refData.admission_num);
      const className = refData.cls_sec?.cls?.Classes || refData.select_class;
      const sectionName = refData.cls_sec?.section?.section || refData.section_id;
      addRow("Class & Section", [className, sectionName].filter(Boolean).join(" ").trim());
      addRow("Roll Number", refData.roll_num);
    } else {
      addRow("Employee Code", refData.employee_code);
      addRow("Department", refData.department);
      addRow("Designation", refData.designation);
    }

    const leavingDate = refData.leaving_date || refData.reliving_date;
    if (leavingDate) {
      addRow("Year of Leaving", new Date(leavingDate).getFullYear());
    } else {
      addRow("Year of Leaving", "N/A");
    }

    addRow("Currently Active", refData.is_active ? "Yes" : "No");
    addRow("Contact", refData.mobile_no);

    return `<div class="text-start">${rows.join("")}</div>`;
  };

  const confirmReferenceDetails = async (refData, role) => {
    const result = await Swal.fire({
      title: "Confirm Reference Details",
      html: buildReferenceSummary(refData, role),
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, correct",
      cancelButtonText: "No",
      focusConfirm: false,
    });
    return result.isConfirmed;
  };

  const applyReferenceData = (index, refData, role) => {
    const currentReferral = referrals[index] || {};

    const resolvedName = refData.student_full_name || refData.staff_full_name || refData.full_name || currentReferral.ref_name || "";
    updateReferral(index, "ref_name", resolvedName);
    updateReferral(index, "ref_role", role || currentReferral.ref_role || "");

    if (role === "student") {
      updateReferral(index, "ref_admission_no", refData.admission_num || currentReferral.ref_admission_no || "");
      updateReferral(index, "ref_employee_code", currentReferral.ref_employee_code || "");
    } else {
      updateReferral(index, "ref_employee_code", refData.employee_code || currentReferral.ref_employee_code || "");
      updateReferral(index, "ref_admission_no", currentReferral.ref_admission_no || "");
    }

    const leavingDate = refData.leaving_date || refData.reliving_date;
    const resolvedYear = leavingDate ? new Date(leavingDate).getFullYear().toString() : currentReferral.ref_year_of_leaving || "";
    updateReferral(index, "ref_year_of_leaving", resolvedYear);

    updateReferral(index, "ref_contact_no", refData.mobile_no || currentReferral.ref_contact_no || "");
    updateReferral(index, "ref_note", currentReferral.ref_note || "");
    updateReferral(index, "ref_is_current", refData.is_active ?? currentReferral.ref_is_current ?? false);

    setIsReferenceVerified((prev) => ({ ...prev, [index]: true }));
    setReferenceVerificationData((prev) => ({ ...prev, [index]: refData, currentIndex: index }));
    setSelectedVerificationFields((prev) => ({ ...prev, [index]: [] }));
    setFormData((prev) => ({ ...prev, is_ref: true }));

    Swal.fire({
      icon: "success",
      title: "Reference Verified",
      text: "The reference details have been confirmed and locked.",
    });
  };

  const confirmAndApplyReference = async (index, refData, role) => {
    const isConfirmed = await confirmReferenceDetails(refData, role);
    if (!isConfirmed) {
      return;
    }

    applyReferenceData(index, refData, role);
  };

  const verifyReference = async (index) => {
    const referral = referrals[index];
    try {
      let url = "";
      const queryParams = [];
      if (referral.ref_role === "student") {
        url = `https://api.mirai.healthcare/api/student/ref-student`;
      } else if (referral.ref_role === "staff") {
        url = `https://api.mirai.healthcare/api/staff-Registration`;
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Invalid reference role",
        });
        return;
      }

      const fields = selectedVerificationFields[index] || [];
      if (fields.includes("ref_name")) {
        queryParams.push(
          referral.ref_role === "student"
            ? `student_full_name=${encodeURIComponent(referral.ref_name)}`
            : `name=${encodeURIComponent(referral.ref_name)}`
        );
      }
      if (fields.includes("ref_year_of_leaving")) {
        queryParams.push(`year_of_leaving=${encodeURIComponent(referral.ref_year_of_leaving)}`);
      }
      if (fields.includes("ref_admission_no")) {
        queryParams.push(
          referral.ref_role === "student"
            ? `admission_num=${encodeURIComponent(referral.ref_admission_no)}`
            : `employee_code=${encodeURIComponent(referral.ref_employee_code)}`
        );
      }
      if (fields.includes("is_active")) {
        queryParams.push(`is_active=${referral.ref_is_current}`);
      }

      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please select at least one field to verify",
        });
        return;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "x-auth": `${authtoken}`,
        },
      });

      const data = await response.json();
      console.log("API Response for verifyReference:", JSON.stringify(data, null, 2));

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const results = referral.ref_role === "student" ? data.message : data.data?.data;
      console.log("Parsed results:", JSON.stringify(results, null, 2));

      if (data.success && Array.isArray(results) && results.length > 0) {
        if (results.length > 1) {
          const selectionResult = await Swal.fire({
            title: "Multiple References Found",
            html: `
            <div class="text-start">
              <p>Please select the correct reference:</p>
              <select id="reference-select" class="form-select">
                ${results
                .map(
                  (ref, i) => `
                      <option value="${i}">
                        ${ref.student_full_name || ref.staff_full_name || ref.full_name || "Unknown"}
                        (${ref.admission_num || ref.employee_code || "N/A"},
                        ${ref.leaving_date || ref.reliving_date
                      ? new Date(ref.leaving_date || ref.reliving_date).getFullYear()
                      : "N/A"})
                      </option>
                    `
                )
                .join("")}
              </select>
            </div>
          `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Select",
            cancelButtonText: "Cancel",
            preConfirm: () => document.getElementById("reference-select").value,
          });

          if (selectionResult.isConfirmed) {
            const selectedIndex = parseInt(selectionResult.value, 10);
            const refData = results[selectedIndex];
            await confirmAndApplyReference(index, refData, referral.ref_role);
          }
        } else {
          const refData = results[0];
          await confirmAndApplyReference(index, refData, referral.ref_role);
        }
      } else {
        console.error("No valid data found in response:", data);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No reference data found.",
        });
      }
    } catch (error) {
      console.error("Reference verification error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not verify reference. Please try again.",
      });
    }
  };
  const GuardianAadharMismatchItem = ConsentTypeData?.data?.find(
    item => item.key === 'guardian_aadhar_mismatch'
  );
  const GuardianAadharNotConsent = ConsentTypeData?.data?.find(
    item => item.key === 'guardian_aadhar_later'
  );
  const handleCheckboxGuardianAadhar = () => {
    const newValue = !IsSelectedGuardianAadhar;
    setIsSelectedGuardianAadhar(newValue);

    if (newValue) {
      postConsentData(GuardianAadharMismatchItem?.key);
    }
  };

  // Guardian Aadhar Not Available Checkbox
  const handleCheckboxGuardianAadharNotAvailablePress = () => {
    const newValue = !GuardianAadharNotAvailable;
    setGuardianAadharNotAvailable(newValue);

    if (newValue) {
      postConsentData(GuardianAadharNotConsent?.key);
    }
  };
  // const handleDropdownContactNumberDataChange = item => {
  //     setContactNumberData(item.value);
  //     // setFormData(prev => ({...prev, gender: item.value})); 
  //   };

  const handleDropdownContactNumberDataChange = (item) => {
    setContactNumberData(item.value);
  };

  useEffect(() => {
    if (!ContactNumberData) return;
    const sanitizedContactNumber = sanitizeContactInput(ContactNumberMobile || '');
    // Ensure current selection uses existing form values; do not clear other contacts.
    if (ContactNumberData === "Father" && !formData.father_mobile_no && sanitizedContactNumber) {
      handleChange("father_mobile_no", sanitizedContactNumber);
    }
    if (ContactNumberData === "Mother" && !formData.mother_mobile_no && sanitizedContactNumber) {
      handleChange("mother_mobile_no", sanitizedContactNumber);
    }
    if (ContactNumberData === "Guardian" && !formData.guardian_mobile_no && sanitizedContactNumber) {
      handleChange("guardian_mobile_no", sanitizedContactNumber);
    }
  }, [ContactNumberData, ContactNumberMobile, formData.father_mobile_no, formData.mother_mobile_no, formData.guardian_mobile_no]);
  useEffect(() => {
    if (useFatherAddress && formData.father_aadhar_address) {
      handleChange('student_aadhar_address', formData.father_aadhar_address);
      setUseMotherAddress(false); // Ensure Mother's address is unchecked
    }
  }, [useFatherAddress, formData.father_aadhar_address]);

  useEffect(() => {
    if (useMotherAddress && formData.mother_aadhar_address) {
      handleChange('student_aadhar_address', formData.mother_aadhar_address);
      setUseFatherAddress(false); // Ensure Father's address is unchecked
    }
  }, [useMotherAddress, formData.mother_aadhar_address]);
  // const [EmailData, setEmailData] = useState('');
  const [contactEmailId, setContactEmailId] = useState('');

  const handleDropdownEmailDataChange = (selectedOption) => {
    if (!selectedOption) return;
    setEmailData(selectedOption.value);
    const fieldMap = {
      Father: "father_email",
      Mother: "mother_email",
      Guardian: "guardian_email",
    };
    const targetField = fieldMap[selectedOption.value] || "father_email";
    setParentEmailTarget(targetField);
    setParentEmailTargetValue(formData[targetField] || "");
    setParentEmailSent(false);
    setParentEmailOTP("");
  };

  useEffect(() => {
    if (!emailData || !contactEmailId) {
      return;
    }

    const fieldMap = {
      Father: "father_email",
      Mother: "mother_email",
      Guardian: "guardian_email",
    };

    const targetField = fieldMap[emailData];
    if (!targetField) {
      return;
    }

    setFormData((prev) => {
      if (prev[targetField]) {
        return prev;
      }

      const normalizedContact = normalizeEmail(contactEmailId);
      if (!normalizedContact) {
        return prev;
      }

      return {
        ...prev,
        [targetField]: contactEmailId,
      };
    });
  }, [emailData, contactEmailId]);

  // useEffect(() => {
  //   if (emailData === 'Father') {
  //     handleChange('father_email', contactEmailId || '');
  //     handleChange('mother_email', '');
  //   } else if (emailData === 'Mother') {
  //     handleChange('mother_email', contactEmailId || '');
  //     handleChange('father_email', '');
  //   }
  // }, [emailData, contactEmailId]);

  useEffect(() => {
    const registration = RegistrationData?.data;
    if (!registration) {
      return;
    }

    const nextContactEmail = registration.contact_email || registration.emailid || "";
    if (nextContactEmail) {
      setContactEmailId(nextContactEmail);
    }
  }, [RegistrationData]);


  const [selectedAddressType, setSelectedAddressType] = useState('');


  // const AddressSelectData2 = [
  //   {label: 'Student Address', value: 'Student Address'},
  //   {label: 'Father Address', value: 'Father Address'},
  //   {label: 'Mother Address', value: 'Mother Address'},
  //   {label: 'Other', value: 'Other'},
  // ];

  const handleDropdownAddressSelectDataChange = (val) => {
    setAddressSelectData(val);
  };

  // const handleAddressSelect = (selected) => {
  //   const value = selected.value;
  //   setSelectedAddressType(value);

  //   if (value === 'Student Address') {
  //     setFormData({
  //       ...formData,
  //       contact_address: 'A-50 Sector 50, Noida 201301',
  //       city_state: 'Noida',
  //       pincode: '201301',
  //       permanent_address: 'A-50 Sector 50, Noida 201301',
  //     });
  //   } else if (value === 'Father Address') {
  //     setFormData({
  //       ...formData,
  //       contact_address: 'Father Address 1',
  //       city_state: 'Noida',
  //       pincode: '201301',
  //       permanent_address: 'Father Address 1',
  //     });
  //   } else if (value === 'Mother Address') {
  //     setFormData({
  //       ...formData,
  //       contact_address: 'Mother Address 1',
  //       city_state: 'Noida',
  //       pincode: '201301',
  //       permanent_address: 'Mother Address 1',
  //     });
  //   } else {
  //     // Clear fields for "Other"
  //     setFormData({
  //       ...formData,
  //       contact_address: '',
  //       city_state: '',
  //       pincode: '',
  //       permanent_address: '',
  //     });
  //   }
  // };


  // Student Aadhar Checkbox

  const handleAddressSelect = useCallback((selected) => {
    const value = selected.value;
    setSelectedAddressType(value);

    setFormData((prev) => {
      const fallback = (addressString) => ({
        ...prev,
        contact_address: addressString,
        city_state: prev.city_state || '',
        pincode: prev.pincode || '',
        permanent_address: prev.permanent_address === prev.contact_address ? addressString : prev.permanent_address,
      });

      const buildFromObject = (addr) => {
        const parts = [addr.house, addr.street, addr.loc].filter(Boolean).join(', ');
        return {
          ...prev,
          contact_address: parts,
          city_state: addr.state || '',
          pincode: addr.pin || '',
          permanent_address: prev.permanent_address === prev.contact_address ? parts : prev.permanent_address,
        };
      };

      if (value === "Student Address") {
        if (prev.student_address) {
          return buildFromObject(prev.student_address);
        }
        if (prev.student_aadhar_address) {
          return fallback(prev.student_aadhar_address);
        }
      } else if (value === "Father Address") {
        if (prev.father_address) {
          return buildFromObject(prev.father_address);
        }
        if (prev.father_aadhar_address) {
          return fallback(prev.father_aadhar_address);
        }
      } else if (value === "Mother Address") {
        if (prev.mother_address) {
          return buildFromObject(prev.mother_address);
        }
        if (prev.mother_aadhar_address) {
          return fallback(prev.mother_aadhar_address);
        }
      } else if (value === "Guardian Address") {
        if (prev.guardian_address) {
          return buildFromObject(prev.guardian_address);
        }
        if (prev.guardian_aadhar_address) {
          return fallback(prev.guardian_aadhar_address);
        }
      } else if (value === "Other") {
        return {
          ...prev,
          contact_address: '',
          city_state: '',
          pincode: '',
          permanent_address: prev.permanent_address === prev.contact_address ? '' : prev.permanent_address,
        };
      }

      return prev;
    });
  }, []);

  const [siblingSelectData, setSiblingSelectData] = useState('');
  const [admissionNumber, setAdmissionNumber] = useState('');
  const [siblingAdmissionData, setSiblingAdmissionData] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [useMotherAddressForStudent, setUseMotherAddressForStudent] = useState(false);
  const [useStudentAddressForMother, setUseStudentAddressForMother] = useState(false);
  const [useFatherAddressForMother, setUseFatherAddressForMother] = useState(false);
  const [useMotherAddressForFather, setUseMotherAddressForFather] = useState(false);
  const [useFatherAddressForStudent, setUseFatherAddressForStudent] = useState(false);
  const [useStudentAddressForFather, setUseStudentAddressForFather] = useState(false);
  const [parentInfoMatched, setParentInfoMatched] = useState(true);

  const evaluateParentMatch = (referenceValues = {}, siblingData = {}, { showAlert = false } = {}) => {
    const normalize = (value) => (value || "").toString().trim();
    const normalizeEmail = (value) => normalize(value).toLowerCase();

    const fatherMobileReference = normalize(referenceValues.father_mobile_no);
    const fatherEmailReference = normalizeEmail(referenceValues.father_email);
    const motherMobileReference = normalize(referenceValues.mother_mobile_no);
    const motherEmailReference = normalizeEmail(referenceValues.mother_email);

    const siblingFatherMobile = normalize(siblingData.father_mobile_no);
    const siblingFatherEmail = normalizeEmail(siblingData.father_email);
    const siblingMotherMobile = normalize(siblingData.mother_mobile_no);
    const siblingMotherEmail = normalizeEmail(siblingData.mother_email);

    const isFatherMobileMatch = fatherMobileReference === siblingFatherMobile;
    const isFatherEmailMatch = fatherEmailReference === siblingFatherEmail;
    const isMotherMobileMatch = motherMobileReference === siblingMotherMobile;
    const isMotherEmailMatch = motherEmailReference === siblingMotherEmail;

    const allMatched = isFatherMobileMatch && isFatherEmailMatch && isMotherMobileMatch && isMotherEmailMatch;

    setParentInfoMatched(allMatched);

    if (!allMatched && showAlert) {
      const mismatchRows = [];
      if (!isFatherMobileMatch) {
        mismatchRows.push(`• Father Mobile: Data has <strong>${siblingData.father_mobile_no || 'N/A'}</strong>, you entered <strong>${referenceValues.father_mobile_no || 'N/A'}</strong>`);
      }
      if (!isFatherEmailMatch) {
        mismatchRows.push(`• Father Email: Data has <strong>${siblingData.father_email || 'N/A'}</strong>, you entered <strong>${referenceValues.father_email || 'N/A'}</strong>`);
      }
      if (!isMotherMobileMatch) {
        mismatchRows.push(`• Mother Mobile: Data has <strong>${siblingData.mother_mobile_no || 'N/A'}</strong>, you entered <strong>${referenceValues.mother_mobile_no || 'N/A'}</strong>`);
      }
      if (!isMotherEmailMatch) {
        mismatchRows.push(`• Mother Email: Data has <strong>${siblingData.mother_email || 'N/A'}</strong>, you entered <strong>${referenceValues.mother_email || 'N/A'}</strong>`);
      }

      if (mismatchRows.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Parent Information Mismatch',
          html: `
            <div class="text-start">
              <p>Some parent information doesn't match our records:</p>
              ${mismatchRows.map((row) => `<p>${row}</p>`).join('')}
            </div>
          `,
          confirmButtonText: 'OK'
        });
      }
    }

    return allMatched;
  };

  const fetchSiblingAdmissionData = async (
    admissionNum,
    { showAlert = false, referenceValues = formData } = {}
  ) => {
    if (!admissionNum) {
      setSiblingAdmissionData([]);
      setParentInfoMatched(true);
      return;
    }

    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/student/admission?admission_num=${admissionNum}`,
        {
          method: 'GET',
          headers: {
            "x-auth": `${authtoken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch sibling data');
      }

      const data = await response.json();
      const records = Array.isArray(data?.message) ? data.message : [];

      setSiblingAdmissionData(records);
      setHasFetched(true);

      if (!records.length) {
        setParentInfoMatched(true);
        if (showAlert) {
          Swal.fire({
            icon: 'info',
            title: 'No Data',
            text: 'No sibling record found for the provided admission number.'
          });
        }
        return;
      }

      evaluateParentMatch(referenceValues, records[0], { showAlert });
    } catch (error) {
      console.error('Error:', error);
      setSiblingAdmissionData([]);
      setParentInfoMatched(true);
      setHasFetched(true);

      if (showAlert) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Could not fetch sibling details. Please check the admission number and try again.'
        });
      }
    }
  };

  const handleSiblingSearch = async () => {
    await fetchSiblingAdmissionData(admissionNumber, {
      showAlert: true,
      referenceValues: formData,
    });
  };
  const handleFatherAddressCheckbox = (e) => {
    const isChecked = e.target.checked;
    setUseFatherAddress(isChecked);
    setUseMotherAddress(false);

    if (isChecked && formData.father_aadhar_address) {
      handleChange('student_aadhar_address', formData.father_aadhar_address);
    } else if (!isChecked && !useMotherAddress) {
      handleChange('student_aadhar_address', '');
    }
  };

  const handleMotherAddressCheckbox = (e) => {
    const isChecked = e.target.checked;
    setUseMotherAddress(isChecked);
    setUseFatherAddress(false);
    if (isChecked && formData.mother_aadhar_address) {
      handleChange('student_aadhar_address', formData.mother_aadhar_address);
    } else if (!isChecked && !useFatherAddress) {
      handleChange('student_aadhar_address', '');
    }
  };
  const SiblingSelectData2 = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];

  const handleDropdownSiblingSelectDataChange = (item) => {
    setSiblingSelectData(item.value);
    setHasFetched(false);

    if (item.value === 'No') {
      setSiblingAdmissionData([]);
      setAdmissionNumber('');
      setParentInfoMatched(true);
    }
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sibling_admission_numbers: admissionNumber || '',
    }));

    if (!admissionNumber) {
      setHasFetched(false);
      setSiblingAdmissionData([]);
      setParentInfoMatched(true);
    }
  }, [admissionNumber]);



  const handleCheckboxStudentPress = () => {
    const newValue = !IsSelectedStudentAadhar;
    setIsSelectedStudentAadhar(newValue);

    if (newValue) {
      postConsentData(StudentnameMismatchItem?.key);
    }
  };


  // Student DOB Checkbox
  const handleCheckboxStudentDOBPress = () => {
    const newValue = !StudentDOBMismatchItem;
    setStudentDOBMismatchItem(newValue);

    if (newValue) {
      postConsentData(StudentDOBMismatch?.key);
    }
  };

  // Father Aadhar Checkbox
  const handleCheckboxFatherAadhar = () => {
    const newValue = !IsSelectedFatherAadhar;
    setIsSelectedFatherAadhar(newValue);

    if (newValue) {
      postConsentData(FatherAadharMismatchItem?.key);
    }
  };
  // Mother Aadhar Checkbox
  const handleCheckMotherAadharData = () => {
    const newValue = !MotherAadharData;
    setMotherAadharData(newValue);

    if (newValue) {
      postConsentData(MotherAadharMismatchItem?.key);
    }
  };

  // TC Not Available
  const handleCheckTCNotAvailableData = () => {
    const newValue = !TCNotAvailableData;
    setTCNotAvailableData(newValue);

    if (newValue) {
      postConsentData(TCNotAvailable?.key);
    }
  };

  // PEN Not Available
  const handleCheckPenNotAvailableApplied = () => {
    const newValue = !PenNotAvailableApplied;
    setPenNotAvailableApplied(newValue);

    if (newValue) {
      postConsentData(PENNumberMismatchItem?.key);
    }
  };

  // Bonafide Not Available Checkbox
  const handleCheckBonafideNotAvailableApplied = () => {
    const newValue = !BonafideNotAvailableApplied;
    setBonafideNotAvailableApplied(newValue);

    if (newValue) {
      postConsentData(BonafideMismatchItem?.key);
    }
  };

  // Student Data Usage Checkbox
  const handleCheckboxStudentDataUsagePress = () => {
    const newValue = !StudentDataUsageConsentItem;
    setStudentDataUsageConsentItem(newValue);

    if (newValue) {
      postConsentData(StudentDataUsageConsent?.key);
    }
  };

  // Student Aadhar Not Available Checkbox
  const handleCheckboxStudentAadharNotAvailablePress = () => {
    const newValue = !StudentAadharNotAvailable;
    setStudentAadharNotAvailable(newValue);

    if (newValue) {
      postConsentData(StudentAadharNotConsent?.key);
    }
  };

  // Aadhar Applied Consent Checkbox
  const handleAadharAppliedConsent = () => {
    const newValue = !isAadharAppliedConsentSubmitted;
    setIsAadharAppliedConsentSubmitted(newValue);

    if (newValue) {
      postConsentData(AadharAlreadyAppliedConsent?.key);
    }
  };

  const postConsentData = async (key, onSuccessDisableCheckbox, options = {}) => {
    const { silent = false } = options;

    if (!key) {
      return { success: false, message: 'Consent key is missing.' };
    }

    // Use enquery_id from registration data instead of the registration ID
    const enquiryId = RegistrationData?.data?.enquery_id || id;

    if (!enquiryId) {
      if (!silent) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Enquiry ID not found. Cannot submit consent.'
        });
      }
      return { success: false, message: 'Enquiry ID not found.' };
    }

    try {
      const response = await fetch('https://api.mirai.healthcare/api/register/consent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "x-auth": `${authtoken}`,
        },
        body: JSON.stringify({
          enquiry_id: parseInt(enquiryId), // Use enquiry_id instead of registration ID
          signed_by_name: '',
          reason: '',
          consent_type_keys: [key],
        }),
      });

      const json = await response.json();
      const isSuccess = response.ok && json?.success !== false;
      const message = json?.message || (isSuccess ? 'Consent submitted successfully.' : 'Failed to submit consent. Please try again.');
      const alreadyExists = message?.toLowerCase?.().includes('already exists');

      if (isSuccess || alreadyExists) {
        setExistingConsentsByKey((prev) => ({
          ...prev,
          [key]: true,
        }));

        if (onSuccessDisableCheckbox) onSuccessDisableCheckbox();

        if (!silent && isSuccess) {
          Swal.fire({ icon: 'success', title: 'Success', text: message });
        }

        return {
          success: true,
          message: alreadyExists ? (json?.message || 'Consent already recorded.') : message,
        };
      }

      if (!silent) {
        Swal.fire({ icon: 'error', title: 'Error', text: message });
      }
      return { success: false, message };
    } catch (error) {
      console.error('❌ Error:', error);
      const fallbackMessage = error?.message || 'Failed to submit consent. Please try again.';

      if (!silent) {
        Swal.fire({ icon: 'error', title: 'Error', text: fallbackMessage });
      }

      return { success: false, message: fallbackMessage };
    }
  };





  const validateForm = () => {
    const newErrors = {};
    const requiresFatherInfo = !formData.is_single_parent || formData.single_parent === 'father';
    const requiresMotherInfo = !formData.is_single_parent || formData.single_parent === 'mother';
    const requiresGuardianInfo = formData.is_single_parent && formData.single_parent === 'guardian';
    const showPENQuestion = selectedClassId >= 5 && !isClassAgeAppropriate;
    const showBonafideQuestion = selectedClassId > 0 && selectedClassId <= 4 && !isClassAgeAppropriate;
    const showTCSection = !isNurseryClass;

    // if (!photo) {
    //   newErrors.photo = 'Upload student photo.';
    // }

    if (!formData.session) {
      newErrors.session = 'Select academic year.';
    }

    if (!formData.student_full_name || formData.student_full_name.trim() === '') {
      newErrors.student_full_name = 'Student full name is required.';
    } else if (formData.student_full_name.trim().length < 2) {
      newErrors.student_full_name = 'Student name must be at least 2 characters long.';
    }

    if (!formData.date_of_birth) {
      newErrors.date_of_birth = 'Select date of birth.';
    }

    // if (!formData.father_mobile_no || formData.father_mobile_no.trim() === '') {
    //   newErrors.father_mobile_no = 'Contact number is required.';
    // }

    if (!formData.father_email || formData.father_email.trim() === '') {
      newErrors.father_email = 'Email is required.';
    }

    if (!formData.gender) {
      newErrors.gender = 'Select gender.';
    }

    if (!formData.select_class) {
      newErrors.select_class = 'Select class.';
    }

    if (showPENQuestion && hasPENNumber === true && (!formData.pen_number || formData.pen_number.trim() === '')) {
      newErrors.pen_number = 'Enter PEN number.';
    }

    if (!AadharOptionData) {
      newErrors.aadhar_option = 'Select Aadhaar availability.';
    }

    if (AadharOptionData === 'Yes') {
      if (!formData.aadhar_no || formData.aadhar_no.trim() === '') {
        newErrors.aadhar_no = 'Enter Aadhaar number.';
      }

      if (!formData.student_aadhar_name || formData.student_aadhar_name.trim() === '') {
        newErrors.student_aadhar_name = 'Enter name as per Aadhaar.';
      }

      if (!formData.aadhar_date_of_birth) {
        newErrors.aadhar_date_of_birth = 'Select Aadhaar date of birth.';
      }

      if (!formData.student_aadhar_address || formData.student_aadhar_address.trim() === '') {
        newErrors.student_aadhar_address = 'Enter Aadhaar address.';
      }
    }

    if (!formData.select_religion) {
      newErrors.select_religion = 'Select religion.';
    }

    if (!formData.student_cast_category) {
      newErrors.student_cast_category = 'Select caste.';
    }

    if (selectedCasteLabel !== 'd' && !formData.minority_status) {
      newErrors.minority_status = 'Select minority status.';
    }

    if (showTCSection && !TCOptionData) {
      newErrors.tc_option = 'Select TC availability.';
    }

    if (!isNurseryClass) {
      if (!formData.last_school_name || formData.last_school_name.trim() === '') {
        newErrors.last_school_name = 'Enter last school name.';
      }

      // if (!formData.last_school_class || formData.last_school_class.trim() === '') {
      //   newErrors.last_school_class = 'Enter last school class.';
      // }

      // if (!formData.last_school_board || formData.last_school_board.trim() === '') {
      //   newErrors.last_school_board = 'Enter last school board.';
      // }

      // if (!formData.last_school_address || formData.last_school_address.trim() === '') {
      //   newErrors.last_school_address = 'Enter last school address.';
      // }
    }

    if (requiresFatherInfo) {
      // if (!Fatherphoto) {
      //   newErrors.father_photo = 'Upload father photo.';
      // }

      if (!formData.father_full_name || formData.father_full_name.trim() === '') {
        newErrors.father_full_name = "Enter father's full name.";
      }

      // if (!formData.father_qualification || formData.father_qualification.trim() === '') {
      //   newErrors.father_qualification = "Enter father's qualification.";
      // }

      if (!formData.father_aadhar_no || formData.father_aadhar_no.trim() === '') {
        newErrors.father_aadhar_no = "Enter father's Aadhaar number.";
      }

      // if (!formData.father_aadhar_address || formData.father_aadhar_address.trim() === '') {
      //   newErrors.father_aadhar_address = "Enter father's Aadhaar address.";
      // }
    }

    if (requiresMotherInfo) {
      // if (!Motherphoto) {
      //   newErrors.mother_photo = 'Upload mother photo.';
      // }

      if (!formData.mother_full_name || formData.mother_full_name.trim() === '') {
        newErrors.mother_full_name = "Enter mother's full name.";
      }

      // if (!formData.mother_qualification || formData.mother_qualification.trim() === '') {
      //   newErrors.mother_qualification = "Enter mother's qualification.";
      // }

      if (!formData.mother_aadhar_no || formData.mother_aadhar_no.trim() === '') {
        newErrors.mother_aadhar_no = "Enter mother's Aadhaar number.";
      }

      // if (!formData.mother_aadhar_address || formData.mother_aadhar_address.trim() === '') {
      //   newErrors.mother_aadhar_address = "Enter mother's Aadhaar address.";
      // }
    }

    if (requiresGuardianInfo) {
      // if (!Guardianphoto) {
      //   newErrors.guardian_photo = 'Upload guardian photo.';
      // }

      if (!formData.guardian_name || formData.guardian_name.trim() === '') {
        newErrors.guardian_name = 'Enter guardian name.';
      }

      // if (!formData.guardian_qualification || formData.guardian_qualification.trim() === '') {
      //   newErrors.guardian_qualification = 'Enter guardian qualification.';
      // }

      if (!formData.guardian_aadhar_no || formData.guardian_aadhar_no.trim() === '') {
        newErrors.guardian_aadhar_no = 'Enter guardian Aadhaar number.';
      }

      // if (!formData.guardian_aadhar_address || formData.guardian_aadhar_address.trim() === '') {
      //   newErrors.guardian_aadhar_address = 'Enter guardian Aadhaar address.';
      // }
    }

    if (!siblingSelectData) {
      newErrors.siblingSelectData = 'Select sibling availability.';
    }

    // if (showBonafideQuestion) {
    //   if (hasBonafideCertificate === null) {
    //     newErrors.hasBonafideCertificate = 'Select bonafide certificate availability.';
    //   }

    //   if (
    //     hasBonafideCertificate === true &&
    //     !Bonafidephoto &&
    //     !inPersonDocs.bonafide_certificate?.isSelected
    //   ) {
    //     newErrors.bonafide_certificate = 'Upload bonafide certificate or mark in-person submission.';
    //   }
    // }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const formattedReligion = Array.isArray(Religion?.data)
    ? Religion.data.map((cls) => ({
      value: cls.id,
      label: cls.name,
    }))
    : [];


  const consentByKey = useMemo(() => {
    const map = {};

    if (Array.isArray(ConsentTypeData?.data)) {
      ConsentTypeData.data.forEach((item) => {
        if (item?.key) {
          map[item.key] = item;
        }
      });
    }

    return map;
  }, [ConsentTypeData]);







  const gatherMissingDocumentConsents = useCallback(() => {
    return DOCUMENT_CONFIG_KEYS.reduce((acc, docKey) => {
      if (isDocumentSatisfied(docKey)) {
        return acc;
      }

      const consentKey = DOCUMENT_CONSENT_KEY_MAP[docKey];
      const consent = consentByKey[consentKey];

      if (!consent) {
        return acc;
      }

      if (existingConsentsByKey[consent.key]) {
        return acc;
      }

      acc.push({ docKey, consent });
      return acc;
    }, []);
  }, [consentByKey, existingConsentsByKey, isDocumentSatisfied]);
  useEffect(() => {
    console.log("=== DOCUMENT CONSENT DEBUG ===");
    DOCUMENT_CONFIG_KEYS.forEach(docKey => {
      const hasFile = Boolean(getDocumentFile(docKey));
      const inPersonSelected = Boolean(inPersonDocs[docKey]?.isSelected);
      const hasExistingDocument = Boolean(existingDocumentUrls[docKey]);
      const isInScope = isDocumentInScope(docKey);
      const isSatisfied = isDocumentSatisfied(docKey);

      console.log(`${docKey}:`, {
        hasFile,
        inPersonSelected,
        hasExistingDocument,
        isInScope,
        isSatisfied,
        requiresConsent: !isSatisfied && isInScope
      });
    });
    console.log("Missing consents:", gatherMissingDocumentConsents());
    console.log("=== END DEBUG ===");
  }, [getDocumentFile, inPersonDocs, existingDocumentUrls, isDocumentInScope, isDocumentSatisfied, gatherMissingDocumentConsents]);
  const openConsentModal = useCallback((items, resolve) => {
    const initialSelections = {};

    (items || []).forEach(({ consent }) => {
      const key = consent?.key;
      if (key && existingConsentsByKey[key]) {
        initialSelections[key] = true;
      }
    });

    setSelectedConsentKeys(initialSelections);
    setConsentModalError('');
    setConsentModalState({ visible: true, items });
    consentModalResolverRef.current = resolve;
  }, [existingConsentsByKey]);

  const closeConsentModal = useCallback(
    (result = false) => {
      if (consentModalSubmitting) {
        return;
      }

      setConsentModalState({ visible: false, items: [] });

      const resolver = consentModalResolverRef.current;
      consentModalResolverRef.current = null;
      if (resolver) {
        resolver(result);
      }
    },
    [consentModalSubmitting]
  );

  const ensureDocumentConsents = useCallback(() => {
    const missingItems = gatherMissingDocumentConsents();

    if (!missingItems.length) {
      return Promise.resolve(true);
    }

    if (missingItems.some(({ consent }) => !consent)) {
      Swal.fire({
        icon: 'error',
        title: 'Consent Types Missing',
        text: 'Unable to load required consent types. Please try again later.',
      });
      return Promise.resolve(false);
    }

    return new Promise((resolve) => {
      openConsentModal(missingItems, resolve);
    });
  }, [gatherMissingDocumentConsents, openConsentModal]);

  const handleConsentModalClose = useCallback(() => {
    closeConsentModal(false);
  }, [closeConsentModal]);

  const handleConsentCheckboxToggle = useCallback((key) => {
    setSelectedConsentKeys((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  }, []);

  const handleConsentModalConfirm = useCallback(async () => {
    if (consentModalSubmitting) {
      return;
    }

    const items = consentModalState.items || [];
    const allSelected = items.every(({ consent }) => selectedConsentKeys[consent.key]);

    if (!allSelected) {
      setConsentModalError('Please accept all required consents to continue.');
      return;
    }

    setConsentModalError('');
    setConsentModalSubmitting(true);

    try {
      for (const { consent } of items) {
        const result = await postConsentData(consent.key, undefined, { silent: true });
        if (!result?.success) {
          throw new Error(result?.message || 'Failed to submit consent.');
        }
      }

      closeConsentModal(true);
    } catch (error) {
      console.error('Consent submission error:', error);
      setConsentModalError(error?.message || 'Failed to submit consent. Please try again.');
    } finally {
      setConsentModalSubmitting(false);
    }
  }, [
    closeConsentModal,
    consentModalState.items,
    consentModalSubmitting,
    postConsentData,
    selectedConsentKeys,
  ]);

  const allConsentSelected = useMemo(() => {
    if (!consentModalState.visible) {
      return false;
    }

    const items = consentModalState.items || [];
    return items.length > 0 && items.every(({ consent }) => selectedConsentKeys[consent.key]);
  }, [consentModalState, selectedConsentKeys]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation - add your required fields check here
    const requiredFields = [
      'student_full_name', 'session', 'gender', 'date_of_birth', 'select_class',
      'father_full_name', 'father_mobile_no', 'mother_full_name', 'student_aadhar_address', 'select_religion',
      'student_cast_category', 'minority_status', 'last_school_name',
      'registration_fee', 'payment_mode', 'father_aadhar_no', 'AadharOptionData2',
    ];

    const newErrors = {};
    requiredFields.forEach(field => {
      if (!formData[field] || String(formData[field]).trim() === '') {
        newErrors[field] = `${field.replace(/_/g, ' ').toUpperCase()} is required`;
      }
    });
    if (!AadharOptionData) {
      newErrors.aadhar_option = "Please select whether you have Child's Aadhar";
    }
    // // Validate phone numbers
    // if (formData.father_mobile_no && !/^\d{10}$/.test(String(formData.father_mobile_no))) {
    //   newErrors.father_mobile_no = 'Father mobile must be 10 digits';
    // }
    // if (formData.mother_mobile_no && !/^\d{10}$/.test(String(formData.mother_mobile_no))) {
    //   newErrors.mother_mobile_no = 'Mother mobile must be 10 digits';
    // }

    // Validate email if provided
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.father_email && !emailRegex.test(String(formData.father_email))) {
      newErrors.father_email = 'Invalid father email';
    }
    if (formData.mother_email && !emailRegex.test(String(formData.mother_email))) {
      newErrors.mother_email = 'Invalid mother email';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please fix the errors below.',
      });
      return;
    }

    setLoading(true);
    try {
      // const submitData = { ...formData };
      const submitData = {
  ...formData,
  is_bonafide:
    formData.is_bonafide === true
      ? "true"
      : formData.is_bonafide === false
      ? "false"
      : "",
};

      // Handle file uploads - append to FormData if needed
      const formDataToSend = new FormData();
      Object.keys(submitData).forEach(key => {
        if (submitData[key] instanceof File) {
          formDataToSend.append(key, submitData[key]);
        } else if (key !== 'upload_photo' && key !== 'father_photo' && key !== 'mother_photo_upload') {
          formDataToSend.append(key, submitData[key]);
        }
      });

      // Handle referrals
      if (activeReferrals.length > 0) {
        formDataToSend.append('referrals', JSON.stringify(activeReferrals.map(r => ({ ...r.referral, id: r.referral.id || null }))));
      }

      // Handle deleted referrals
      if (deletedReferralIds.length > 0) {
        formDataToSend.append('deleted_referral_ids', JSON.stringify(deletedReferralIds));
      }

      const headers = {
        'x-auth': authtoken,
      };
      // For file uploads, don't set Content-Type
      const config = { headers };

      const response = await fetch('https://api.mirai.healthcare/api/register', {
        method: 'POST',
        headers,
        body: formDataToSend,
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setCreatedRegistrationId(result.message?.id || result.data?.id);
        setSuccess(true);

        if (formData.payment_mode === 'Online') {
          Swal.fire({
            icon: 'success',
            title: 'Registration Created!',
            text: 'Redirecting to payment...',
          });
          // Handle online payment redirect if needed
          navigate('/payment-success'); // Adjust route as needed
        } else {
          setShowOfflinePayment(true);
          Swal.fire({
            icon: 'success',
            title: 'Registration Created!',
            text: `Registration ID: ${result.message?.id}. Please provide offline payment details below.`,
          });
        }
      } else {
        throw new Error(result.message || 'Failed to create registration');
      }
    } catch (error) {
      console.error('Registration error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to create registration. Please try again.',
      });
      setErrors({ submit: error.message || 'Submission failed' });
    } finally {
      setLoading(false);
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    // if (!validateForm()) {
    //   return;
    // }

    const consentReady = await ensureDocumentConsents();
    if (!consentReady) {
      return;
    }

    setLoading(true);

    const primaryContactEmail =
      emailData === "Father"
        ? formData.father_email
        : emailData === "Mother"
          ? formData.mother_email
          : emailData === "Guardian"
            ? formData.guardian_email
            : formData.father_email || formData.mother_email || formData.guardian_email || "";

    const primaryContactPhone =
      ContactNumberData === "Father"
        ? formData.father_mobile_no
        : ContactNumberData === "Mother"
          ? formData.mother_mobile_no
          : ContactNumberData === "Guardian"
            ? formData.guardian_mobile_no
            : formData.father_mobile_no || formData.mother_mobile_no || formData.guardian_mobile_no || "";

    const data = new FormData();

    // Core fields
    data.append("student_full_name", formData.student_full_name);
    data.append("session", formData.session);
    data.append("gender", formData.gender);
    data.append("date_of_birth", formData.date_of_birth);
    data.append("select_class", formData.select_class);
    data.append("aadhar_no", formData.aadhar_no);
    data.append("select_religion", formData.select_religion);
    data.append("blood_group", formData.blood_group);
    data.append("student_cast_category", formData.student_cast_category);
    data.append("transfer_certificate_no", formData.transfer_certificate_no);
    data.append("student_family_id", formData.student_family_id);
    data.append("select_fee_type", formData.select_fee_type);
    
      data.append("registration_fee", formData.registration_fee);
      data.append("registration_fee_status", formData.registration_fee_status);
      data.append("payment_mode", formData.payment_mode);
    
    data.append("income_category", formData.income_category);
    data.append("contact_address", formData.contact_address);
    data.append("pincode", formData.pincode);
    data.append("permanent_address", formData.permanent_address);
    data.append("city_state", formData.city_state);
    data.append("last_school_name", formData.last_school_name);
    data.append("last_school_class", formData.last_school_class);
    data.append("last_school_board", formData.last_school_board);
    data.append("last_school_address", formData.last_school_address);
    data.append("pen_number", formData.pen_number);
    data.append("tc_number", formData.tc_number);
    data.append("sibling_admission_numbers", formData.sibling_admission_numbers);
    data.append("student_aadhar_name", formData.student_aadhar_name);
    data.append("student_aadhar_address", formData.student_aadhar_address);
    data.append("aadhar_date_of_birth", formData.aadhar_date_of_birth);
    data.append("emergency_mobile_no", formData.emergency_mobile_no);
    data.append("contact_email", primaryContactEmail || "");
    data.append("contact_phone", primaryContactPhone || "");
    data.append("updated_by", userData?.currentUser?.id || "");
    data.append("created_by_student", "true");
    // Parent or Guardian Information
    if (formData.is_single_parent) {
      if (formData.single_parent === "father") {
        data.append("father_full_name", formData.father_full_name);
        data.append("father_mobile_no", formData.father_mobile_no);
        data.append("father_qualification", formData.father_qualification);
        data.append("father_occupation", formData.father_occupation);
        data.append("father_email", formData.father_email);
        data.append("father_aadhar_no", formData.father_aadhar_no);
        data.append("father_company_name", formData.father_company_name);
        data.append("father_company_address", formData.father_company_address);
        data.append("father_date_of_birth", formData.father_date_of_birth);
        data.append("father_aadhar_address", formData.father_aadhar_address);
      } else if (formData.single_parent === "mother") {
        data.append("mother_full_name", formData.mother_full_name);
        data.append("mother_qualification", formData.mother_qualification);
        data.append("mother_occupation", formData.mother_occupation);
        data.append("mother_company_name", formData.mother_company_name);
        data.append("mother_company_address", formData.mother_company_address);
        data.append("mother_mobile_no", formData.mother_mobile_no);
        data.append("mother_email", formData.mother_email);
        data.append("mother_aadhar_no", formData.mother_aadhar_no);
        data.append("mother_date_of_birth", formData.mother_date_of_birth);
        data.append("mother_aadhar_address", formData.mother_aadhar_address);
      } else if (formData.single_parent === "guardian") {
        data.append("guardian_name", formData.guardian_name);
        data.append("guardian_relation", formData.guardian_relation);
        data.append("guardian_mobile_no", formData.guardian_mobile_no);
        data.append("guardian_occupation", formData.guardian_occupation);
        data.append("guardian_qualification", formData.guardian_qualification);
        data.append("guardian_aadhar_no", formData.guardian_aadhar_no);
        data.append("guardian_company_name", formData.guardian_company_name);
        data.append("guardian_company_address", formData.guardian_company_address);
        data.append("guardian_aadhar_address", formData.guardian_aadhar_address);
        data.append("guardian_date_of_birth", formData.guardian_date_of_birth);
      }
    } else {
      data.append("father_full_name", formData.father_full_name);
      data.append("father_mobile_no", formData.father_mobile_no);
      data.append("father_qualification", formData.father_qualification);
      data.append("father_occupation", formData.father_occupation);
      data.append("father_email", formData.father_email);
      data.append("father_aadhar_no", formData.father_aadhar_no);
      data.append("father_company_name", formData.father_company_name);
      data.append("father_company_address", formData.father_company_address);
      data.append("father_date_of_birth", formData.father_date_of_birth);
      data.append("father_aadhar_address", formData.father_aadhar_address);
      data.append("mother_full_name", formData.mother_full_name);
      data.append("mother_qualification", formData.mother_qualification);
      data.append("mother_occupation", formData.mother_occupation);
      data.append("mother_company_name", formData.mother_company_name);
      data.append("mother_company_address", formData.mother_company_address);
      data.append("mother_mobile_no", formData.mother_mobile_no);
      data.append("mother_email", formData.mother_email);
      data.append("mother_aadhar_no", formData.mother_aadhar_no);
      data.append("mother_date_of_birth", formData.mother_date_of_birth);
      data.append("mother_aadhar_address", formData.mother_aadhar_address);
    }

    data.append("is_father_mobile_verified", String(!!formData.is_father_mobile_verified));
    data.append("is_mother_mobile_verified", String(!!formData.is_mother_mobile_verified));
    data.append("is_guardian_mobile_verified", String(!!formData.is_guardian_mobile_verified));
    data.append("is_father_email_verified", String(!!formData.is_father_email_verified));
    data.append("is_mother_email_verified", String(!!formData.is_mother_email_verified));
    data.append("is_guardian_email_verified", String(!!formData.is_guardian_email_verified));

    data.append("pri_application_status", formData.pri_application_status || 'Created');
    data.append("pri_application_rmk", formData.pri_application_rmk || '');
    data.append("is_bonafide", Boolean(formData.is_bonafide));

    // data.append("is_child_adhaar", Boolean(formData.is_child_adhaar));
    // data.append("is_child_adhaar_applied", Boolean(AppliedData));
    data.append("is_minority", Boolean(formData.minority_status));
    data.append("is_curr_address", Boolean(formData.is_curr_address));

  //   data.append("is_child_adhaar", AadharOptionData ? "true" : "false");
  // data.append("is_child_adhaar_applied", AppliedData ? "true" : "false");

  data.append("is_child_adhaar", AadharOptionData === "Yes" ? "true" : "false");
data.append("is_child_adhaar_applied", AppliedData === "Yes" ? "true" : "false");


    

    // File Uploads - only append if new files are selected
    if (photo) data.append("upload_photo", photo);
    if (Fatherphoto) data.append("father_photo", Fatherphoto);
    if (Motherphoto) data.append("mother_photo_upload", Motherphoto);
    if (Guardianphoto) data.append("upload_guardian_photo", Guardianphoto);
    if (IDProofphoto) data.append("id_proof", IDProofphoto);
    if (DOBphoto) data.append("dob_certificate", DOBphoto);
    if (Transferphoto) data.append("tc", Transferphoto);
    if (StudentAadharphoto) data.append("aadhar_file", StudentAadharphoto);
    if (Castephoto) data.append("cast_certificate", Castephoto);
    if (FatherAadharphoto) data.append("father_aadhar_file", FatherAadharphoto);
    if (MotherAadharphoto) data.append("mother_aadhar_file", MotherAadharphoto);
    if (Bonafidephoto) data.append("bonafide_certificate", Bonafidephoto);
    if (GuardianAadharphoto) data.append("guardian_aadhar_file", GuardianAadharphoto);

    // In-person documents
    const selectedInPersonDocs = DOCUMENT_CONFIG_KEYS.filter(
      (key) => inPersonDocs[key]?.isSelected && isDocumentInScope(key)
    );

    if (selectedInPersonDocs.length) {
      data.append('in_person_docs', JSON.stringify(selectedInPersonDocs));

      const metaPayload = selectedInPersonDocs.reduce((acc, key) => {
        const note = inPersonDocs[key]?.notes?.trim();
        if (note) {
          acc[key] = { notes: note };
        }
        return acc;
      }, {});

      if (Object.keys(metaPayload).length) {
        data.append('in_person_docs_meta', JSON.stringify(metaPayload));
      }
    }

    // Referrals
    const referralsToSend = referrals
      .filter((referral) => !referral.is_deleted)
      .map((referral) => ({
        id: referral.id || undefined,
        ref_name: referral.ref_name || "",
        ref_role: referral.ref_role || "",
        ref_admission_no: referral.ref_role === "student" ? referral.ref_admission_no || "" : undefined,
        ref_employee_code: referral.ref_role === "staff" ? referral.ref_employee_code || "" : undefined,
        ref_year_of_leaving: referral.ref_year_of_leaving || undefined,
        ref_contact_no: referral.ref_contact_no || "",
        ref_note: referral.ref_note || "",
        ref_is_current: referral.ref_is_current || false,
        ref_relation: referral.ref_relation || "",
        is_deleted: false,
      }));

    data.append("referrals", JSON.stringify(referralsToSend));

    try {
      // Use PUT or PATCH for update
      const response = await fetch(`https://api.mirai.healthcare/api/register/${id}`, {
        method: "PUT", // or "PATCH" depending on your API
        headers: {
          "x-auth": authtoken,
        },
        body: data,
      });

      const result = await response.json();

      if (!response.ok) {
        let errorMessage = result.message || "Failed to update registration";
        if (result.error) {
          errorMessage += `: ${result.error}`;
        }
        await Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: errorMessage,
        });
        return;
      }

      await Swal.fire({
        icon: "success",
        title: "Registration Updated",
        text: "The registration has been successfully updated.",
      });
      navigate("/registration");

    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "An unexpected error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Reset createdRegistrationId when payment mode changes
    if (formData.payment_mode === "Offline") {
      setCreatedRegistrationId(null);
      setShowOfflinePayment(false);
    } else {
      setShowOfflinePayment(false);
    }
  }, [formData.payment_mode]);


  const formattedSession = useMemo(() => {
    if (Array.isArray(Session?.data)) {
      return Session.data.map((cls) => ({
        value: cls.id,
        label: cls.Name,
      }));
    }

    // If no session data available, check if we have school automation data
    const schoolAutomationData = Array.isArray(Session) ? Session[0] : Session;
    if (schoolAutomationData?.enq_session_id) {
      return [{
        value: schoolAutomationData.enq_session_id,
        label: `Session ${schoolAutomationData.enq_session_id}`,
      }];
    }

    return [];
  }, [Session]);

  // Add this useEffect to set the session from enq_session_id
  useEffect(() => {
    if (Array.isArray(Session) && Session.length > 0) {
      const schoolData = Session[0];
      if (schoolData?.enq_session_id && !formData.session) {
        handleChange("session", schoolData.enq_session_id.toString());
      }
    }
  }, [Session, formData.session]);
  const formattedClasses = Array.isArray(Class?.data) // Check if 'Class.data' is an array
    ? Class.data.map((cls) => ({
      value: cls.id, // Use 'id' as the value
      label: cls.Classes, // Use 'Classes' as the label
    }))
    : [];



  const [otpLoading, setOtpLoading] = useState(false);
  const [TCOptionData, setTCOptionData] = useState('');
  const [AadharOptionData, setAadharOptionData] = useState('');


  // Add these states at the top of your component
  // Aadhar Verification States
  // In your initial state declaration, make sure it includes:
  const [aadharVerification, setAadharVerification] = useState({
    student: {
      otpSent: false,
      verified: false,
      clientId: '',
      loading: false,
      verifying: false
    },
    father: {
      otpSent: false,
      verified: false,
      clientId: '',
      loading: false,
      verifying: false
    },
    mother: {
      otpSent: false,
      verified: false,
      clientId: '',
      loading: false,
      verifying: false
    },
    guardian: { // Make sure this exists
      otpSent: false,
      verified: false,
      clientId: '',
      loading: false,
      verifying: false
    }
  });
  const hasStudentNameMismatch = useMemo(() => {
    const studentFullName = (formData.student_full_name || '').trim();
    const studentAadharName = (formData.student_aadhar_name || '').trim();

    return Boolean(
      AadharOptionData === 'Yes' &&
      studentFullName &&
      studentAadharName &&
      studentFullName !== studentAadharName
    );
  }, [AadharOptionData, formData.student_full_name, formData.student_aadhar_name]);

  const hasStudentDobMismatch = useMemo(
    () =>
      Boolean(
        AadharOptionData === 'Yes' &&
        formData.date_of_birth &&
        formData.aadhar_date_of_birth &&
        formData.date_of_birth !== formData.aadhar_date_of_birth
      ),
    [AadharOptionData, formData.date_of_birth, formData.aadhar_date_of_birth]
  );
  useEffect(() => {
    if (!hasStudentNameMismatch && IsSelectedStudentAadhar) {
      setIsSelectedStudentAadhar(false);
    }
  }, [hasStudentNameMismatch, IsSelectedStudentAadhar]);

  useEffect(() => {
    if (!hasStudentDobMismatch && StudentDOBMismatchItem) {
      setStudentDOBMismatchItem(false);
    }
  }, [hasStudentDobMismatch, StudentDOBMismatchItem]);
  const [activeAadharField, setActiveAadharField] = useState(''); // 'student', 'father', or 'mother'
  const [aadharOTP, setAadharOTP] = useState('');
  const handleContactSendOTP = async (field) => {
    const aadharField = field === 'student' ? 'aadhar_no' : `${field}_aadhar_no`;
    const aadharNo = formData[aadharField];

    if (!aadharNo || aadharNo.length !== 12) {
      alert('Invalid Aadhaar', 'Please enter a valid 12-digit Aadhaar number');
      return;
    }

    try {
      setActiveAadharField(field);
      setAadharVerification(prev => ({
        ...prev,
        [field]: {
          ...prev[field],
          loading: true,
          otpSent: false
        }
      }));

      const response = await fetch('https://api.mirai.healthcare/api/register/aadhaar/send-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "x-auth": `${authtoken}`,
        },
        body: JSON.stringify({
          id_number: aadharNo,
          dob: formData.date_of_birth,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setAadharVerification(prev => ({
          ...prev,
          [field]: {
            ...prev[field],
            otpSent: true,
            clientId: data.data.client_id, // Store the client_id from response
            loading: false
          }
        }));
        alert('OTP Sent', `OTP has been sent to ${field}'s Aadhaar registered mobile number.`);
      } else {
        alert('Error', data?.message || 'Failed to send OTP');
        setAadharVerification(prev => ({
          ...prev,
          [field]: {
            ...prev[field],
            loading: false
          }
        }));
      }
    } catch (error) {
      console.error('Send OTP Error:', error);
      alert('Network Error', 'Something went wrong. Please try again.');
      setAadharVerification(prev => ({
        ...prev,
        [field]: {
          ...prev[field],
          loading: false
        }
      }));
    }
  };

  const handleVerifyContactOTP = async () => {
    if (!activeAadharField || aadharOTP.length !== 6) {
      alert('Invalid OTP', 'Please enter a 6-digit OTP');
      return;
    }

    try {
      setAadharVerification(prev => ({
        ...prev,
        [activeAadharField]: {
          ...prev[activeAadharField],
          verifying: true
        }
      }));

      const { clientId } = aadharVerification[activeAadharField];
      const aadharNo = formData[activeAadharField === 'student' ? 'aadhar_no' : `${activeAadharField}_aadhar_no`];

      const response = await fetch('https://api.mirai.healthcare/api/register/aadhaar/verify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "x-auth": `${authtoken}`,
        },
        body: JSON.stringify({
          id_number: aadharNo,
          client_id: clientId, // Using the stored client_id
          otp: aadharOTP,
        }),
      });

      const data = await response.json();


      if (response.ok && data.success) {
        // Update form data based on verified Aadhar details
        if (activeAadharField === 'father') {
          setFormData(prev => ({
            ...prev,
            father_aadhar_name: data.data.full_name,  // Set separate Aadhaar name field
            father_aadhar_no: aadharNo,
            father_address: data.data.address || prev.father_address,
            father_aadhar_address: data.data.address
              ? `${data.data.address.house}, ${data.data.address.street}, ${data.data.address.loc}, ${data.data.address.state} - ${data.data.address.pin}`
              : prev.father_aadhar_address,
            father_date_of_birth: data.data.dob,
          }));
        } else if (activeAadharField === 'mother') {
          setFormData(prev => ({
            ...prev,
            mother_aadhar_name: data.data.full_name, // Set Aadhaar name in separate field
            mother_aadhar_no: aadharNo,
            mother_address: data.data.address,
            mother_aadhar_address: data.data.address
              ? `${data.data.address.house}, ${data.data.address.street}, ${data.data.address.loc}, ${data.data.address.state} - ${data.data.address.pin}`
              : prev.mother_aadhar_address,
            mother_date_of_birth: data.data.dob,
          }));
        } else if (activeAadharField === 'student') {
          const aadharData = data.data;
          setFormData(prev => ({
            ...prev,
            student_aadhar_name: aadharData.full_name || prev.student_full_name,
            aadhar_no: aadharNo,
            student_address: aadharData.address,
            aadhar_date_of_birth: aadharData.dob || prev.date_of_birth,
            // Format address if needed
            student_aadhar_address: aadharData.address
              ? `${aadharData.address.house}, ${aadharData.address.street}, ${aadharData.address.loc}, ${aadharData.address.state} - ${aadharData.address.pin}`
              : prev.student_aadhar_address
          }));
        } else if (activeAadharField === 'guardian') {
          setFormData(prev => ({
            ...prev,
            guardian_aadhar_name: data.data.full_name,
            guardian_aadhar_no: aadharNo,
            guardian_address: data.data.address,
            guardian_aadhar_address: data.data.address
              ? `${data.data.address.house}, ${data.data.address.street}, ${data.data.address.loc}, ${data.data.address.state} - ${data.data.address.pin}`
              : prev.guardian_aadhar_address,
            guardian_date_of_birth: data.data.dob,
          }));
        }

        setAadharVerification(prev => ({
          ...prev,
          [activeAadharField]: {
            ...prev[activeAadharField],
            verified: true,
            otpSent: false,
            verifying: false
          }
        }));

        alert('Verified', `${activeAadharField}'s Aadhaar number successfully verified.`);
        setAadharOTP('');
        setActiveAadharField('');
      } else {
        alert('Verification Failed', data?.message || 'Incorrect OTP or client ID');
        setAadharVerification(prev => ({
          ...prev,
          [activeAadharField]: {
            ...prev[activeAadharField],
            verifying: false
          }
        }));
      }
    } catch (error) {
      console.error('Verify OTP Error:', error);
      alert('Network Error', 'Could not verify OTP. Try again.');
      setAadharVerification(prev => ({
        ...prev,
        [activeAadharField]: {
          ...prev[activeAadharField],
          verifying: false
        }
      }));
    }
  };
  //   const [TCOptionData, setTCOptionData] = useState('');
  // const [Transferphoto, setTransferphoto] = useState(null);
  // const [TCNotAvailableData, setTCNotAvailableData] = useState(false);
  // const [isConsentSubmitted6, setIsConsentSubmitted6] = useState(false); // assume you have this
  // const [TCNotAvailable, setTCNotAvailable] = useState({
  //   message: 'I do not have my Transfer Certificate at the moment.',
  // });


  // const handleDropdownTCOptionDataChange = item => {
  //     setTCOptionData(item.value);
  //   };

  const handleDropdownTCOptionDataChange = (selected) => {
    setTCOptionData(selected.value);
  };
  const handleDropdownAadharOptionDataChange = (selected) => {
    setAadharOptionData(selected.value);
  };



  const handleFinalConsentCheck = () => {
    const missing = [];
    const showPENQuestion = selectedClassId >= 5 && !isClassAgeAppropriate;
    const showBonafideQuestion = selectedClassId > 0 && selectedClassId <= 4 && !isClassAgeAppropriate;
    const showTCSection = !isNurseryClass;

    if (hasStudentNameMismatch && !IsSelectedStudentAadhar) missing.push('Student Name Mismatch');
    if (hasStudentDobMismatch && !StudentDOBMismatchItem) missing.push('Student DOB Mismatch');
    if (!IsSelectedFatherAadhar) missing.push('Father Aadhar Mismatch');
    if (!MotherAadharData) missing.push('Mother Aadhar Mismatch');
    if (!IsSelectedGuardianAadhar) missing.push('Guardian Aadhar Mismatch');
    if (
      AadharOptionData === 'No' &&
      AppliedData === 'No' &&
      !isAadharNotAppliedConsentAccepted
    ) {
      missing.push('Student Aadhaar Not Applied');
    }
    if (showTCSection && TCOptionData === 'No') {
      if (!TCNotAvailableData) missing.push('TC Not Available');
    }
    if (showPENQuestion) {
      if (!PenNotAvailableApplied) missing.push('PEN Number Not Available');
    }

    if (showBonafideQuestion) {
      if (!BonafideNotAvailableApplied) missing.push('Bonafide Not Available');
    }

    if (missing.length > 0) {
      alert(
        'Missing Consent',
        `\n\n${missing.join('\n')}`
      );
    } else {
      // If all are selected, validate all keys
      const keysToValidate = [
        hasStudentNameMismatch ? StudentnameMismatchItem?.key : null,
        hasStudentDobMismatch ? StudentDOBMismatch?.key : null,
        FatherAadharMismatchItem?.key,
        MotherAadharMismatchItem?.key,
        showTCSection ? TCNotAvailable?.key : null,
      ];

      if (AadharOptionData === 'No' && AppliedData === 'No') {
        keysToValidate.push(StudentAadharNotAppliedConsent?.key);
      }

      // Add class-specific keys conditionally
      if (showPENQuestion) {
        keysToValidate.push(PENNumberMismatchItem?.key);
      }

      if (showBonafideQuestion) {
        keysToValidate.push(BonafideMismatchItem?.key);
      }

      // Filter out undefined/null values
      const filteredKeys = keysToValidate.filter(Boolean);

      // Make API call
      validateConsent(filteredKeys);
    }
  };

  const validateConsent = async (keys = []) => {
    // Use enquery_id from registration data
    const enquiryId = RegistrationData?.data?.enquery_id || id;

    if (!enquiryId) {
      window.alert('Enquiry ID not found for consent validation');
      return;
    }

    try {
      const response = await fetch(`https://api.mirai.healthcare/api/register/consent/validate/${enquiryId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth': `${authtoken}`,
        },
        body: JSON.stringify({
          requiredConsentKeys: keys
        })
      });

      const result = await response.json();

      if (result?.status === true) {
        window.alert(result?.message || 'Consent validated successfully');
      } else {
        window.alert(result?.message || 'Consent validation failed');
      }
    } catch (error) {
      console.error('Consent Validation Error:', error);
      window.alert('Something went wrong while validating consent.');
    }
  };



  const AppliedData2 = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];

  const handleDropdownAppliedDataChange = item => {
    setAppliedData(item.value);
  };
  const [AadharAlreadyAppliedConsent, setAadharAlreadyAppliedConsent] = useState(null);
  const [isAadharAppliedConsentSubmitted, setIsAadharAppliedConsentSubmitted] = useState(false);

  useEffect(() => {
    if (AppliedData !== 'Yes') {
      setIsAadharAppliedConsentSubmitted(false);
    }
    if (AppliedData !== 'No') {
      setIsAadharNotAppliedConsentAccepted(false);
    }
  }, [AppliedData]);

  useEffect(() => {
    if (AadharOptionData !== 'No') {
      setAppliedData('');
      setIsAadharAppliedConsentSubmitted(false);
      setIsAadharNotAppliedConsentAccepted(false);
    }
  }, [AadharOptionData]);

   useEffect(() => {
  if (formData?.is_bonafide === true) {
    setHasBonafideCertificate(true);
    setShowBonafideUpload(true);
  } else if (formData?.is_bonafide === false) {
    setHasBonafideCertificate(false);
    setShowBonafideUpload(false);
  }
}, [formData?.is_bonafide]);

useEffect(() => {
  if (formData) {
    setAadharOptionData(formData.is_child_adhaar ? "Yes" : "No");
    setAppliedData(formData.is_child_adhaar_applied ? "Yes" : "No");
  }
}, [formData]);


  return (
    <div className="page-wrapper">
      <div className="content content-two">
        <Header />
        {/* Page Header */}
        {/* In the JSX return section, update the header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mt-2">
            <h3 className="mb-1">Update Registration</h3> {/* Changed from "Add Registration" */}

          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          <div className="col-md-12">
            <form className="theme-form theme-form-2 mega-form" onSubmit={handleUpdate} noValidate>
              {/* Personal Information */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-info-square-rounded fs-16" />
                    </span>
                    <h4 className="text-dark">Personal Information</h4>
                  </div>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                        <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                          {getDocumentDisplay('upload_photo', photo, existingDocumentUrls.upload_photo) ? (
                            <img
                              src={getDocumentDisplay('upload_photo', photo, existingDocumentUrls.upload_photo)}
                              alt="Student"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <i className="ti ti-photo-plus fs-16" />
                          )}
                        </div>
                        <div className="profile-upload">
                          <div className="profile-uploader d-flex align-items-center">
                            <div className="drag-upload-btn mb-3">
                              Upload Student Photo
                              <input
                                type="file"
                                className="form-control image-sign"
                                onChange={(e) => setPhoto(e.target.files[0])}
                              />
                            </div>
                            {renderViewButton('upload_photo')}
                          </div>
                          <p className="fs-12">
                            Upload image size 4MB, Format JPG, PNG, SVG
                            {existingDocumentUrls.upload_photo && (
                              <span className="text-success ms-2">
                                <i className="ti ti-check me-1"></i>
                                Document already uploaded
                              </span>
                            )}
                          </p>

                         
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Academic Year <span className="text-danger">*</span></label>
                        <Select
                          classNamePrefix="react-select"
                          options={formattedSession} // Pass the formatted session data
                          value={
                            formattedSession?.find(
                              (session) => session.value === Number(formData.session) // Match the selected session value
                            )
                          }
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              handleChange("session", selectedOption.value); // Store the session value (ID) in formData
                            }
                          }}
                          placeholder="Select Session"
                          isDisabled={true}
                        />
                        {errors.session && (
                          <div className="text-danger small mt-1">{errors.session}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="student_full_name">
                          Student Full Name (as per birth certificate)<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.student_full_name ? 'is-invalid' : ''}`}
                          id="student_full_name"
                          placeholder="Student Full name"
                          value={formData.student_full_name}
                          onChange={(e) => handleChange("student_full_name", e.target.value)}
                        />
                        {errors.student_full_name && (
                          <div className="invalid-feedback">{errors.student_full_name}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Date of Birth <span className="text-danger">*</span>
                          <span className="SubName">(as per birth certificate)</span>
                        </label>
                        <DatePicker
                          className={`form-control ${errors.date_of_birth ? 'is-invalid' : ''}`}
                          placeholder="Select Date"
                          value={
                            formData.date_of_birth
                              ? moment(formData.date_of_birth, "YYYY-MM-DD")
                              : null
                          }
                          onFocus={() => handleChange("date_of_birth", "")}
                          onChange={(date, dateString) => {
                            if (date) {
                              handleChange("date_of_birth", date.format("YYYY-MM-DD"));
                            }
                          }}
                          disabled
                        />
                        {errors.date_of_birth && (
                          <div className="invalid-feedback">{errors.date_of_birth}</div> // Display error message
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="father_mobile_no">
                          Register Contact <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="father_mobile_no"
                          placeholder="Contact"
                          value={formData.contact_phone || ''}  // Use contact_phone instead of father_mobile_no
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            color: "#6c757d",
                            cursor: "not-allowed"
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="father_email">
                          Register Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="father_email"
                          placeholder="Email"
                          value={formData.contact_email || ''}  // Use contact_email instead of father_email
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            color: "#6c757d",
                            cursor: "not-allowed"
                          }}
                        />
                      </div>
                    </div>


                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Gender <span className="text-danger">*</span></label>
                        <Select
                          classNamePrefix="react-select"
                          options={gender}
                          value={gender?.find(
                            (g) => g.value === formData.gender
                          )}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              handleChange("gender", selectedOption.value);
                            }
                          }}
                          placeholder="Select"
                          isDisabled={true}
                        />
                        {errors.gender && (
                          <div className="text-danger small mt-1">{errors.gender}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Class <span className="text-danger">*</span></label>

                        <Select
                          classNamePrefix="react-select"
                          // className={`form-control ${errors.select_class ? 'is-invalid' : ''}`}
                          options={Class} // Pass the formatted class data
                          value={
                            Class?.find(
                              (cls) => cls.value === formData.select_class // Match the selected class value
                            )
                          }
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              handleChange(
                                "select_class", // Key to update in the formData
                                selectedOption.value // Store the selected class id
                              );
                            }
                          }}
                          placeholder="Select Class"
                          isDisabled={true}
                        />
                        {errors.select_class && (
                          <div className="text-danger small mt-1">{errors.select_class}</div>
                        )}
                      </div>
                    </div>

                    {/* ===== Birth Certificate Upload ===== */}
                    {/* <div className="col-lg-4 col-md-6 mb-3">
  <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
    <div className="avatar avatar-xxl border border-dashed me-2 text-dark frames">
      {DOBphoto ? (
        <img
          src={URL.createObjectURL(DOBphoto)}
          alt="DOB"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <i className="ti ti-photo-plus fs-16" />
      )}
    </div>
    <div className="profile-upload">
      <label className="form-label">Upload DOB Certificate</label>
      <input
        type="file"
        className="form-control"
        onChange={(e) => setDOBphoto(e.target.files[0])}
      />
      <p className="fs-12">Max size 4MB, JPG/PNG/SVG</p>
    </div>
  </div>
</div> */}
                    {/* DOB Certificate Upload */}
                    <div className="col-lg-3 col-md-6 mb-3">
                      <div className="d-flex align-items-center row-gap-3 mb-3">
                        <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                          {getDocumentDisplay('dob_certificate', DOBphoto, existingDocumentUrls.dob_certificate) ? (
                            <img
                              src={getDocumentDisplay('dob_certificate', DOBphoto, existingDocumentUrls.dob_certificate)}
                              alt="DOB Certificate"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <i className="ti ti-photo-plus fs-16" />
                          )}
                        </div>
                        <div className="profile-upload">
                          <div className="profile-uploader d-flex align-items-center">
                            <div className="drag-upload-btn mb-1">
                              Upload DOB Certificate <span className="text-danger">*</span>
                              <input
                                type="file"
                                className="form-control image-sign"
                                accept="image/*,.pdf"
                                onChange={(e) => {
                                  const file = e.target.files?.[0] || null;
                                  handleDocumentFileUpload('dob_certificate', file);
                                }}
                              />
                            </div>
                            {renderViewButton('dob_certificate')}
                           
                          </div>
                           {DOBphoto && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger ms-2"
                                onClick={() => clearDocumentFile('dob_certificate')}
                              >
                                <i className="ti ti-x me-1"></i>Clear
                              </button>
                            )}
                          <p className="fs-12">
                            Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                            {existingDocumentUrls.dob_certificate && !DOBphoto && (
                              <span className="text-success ms-2">
                                <i className="ti ti-check me-1"></i>
                                ✓ Already uploaded - No consent required
                              </span>
                            )}
                            {DOBphoto && (
                              <span className="text-warning ms-2">
                                <i className="ti ti-upload me-1"></i>
                                New file selected
                              </span>
                            )}
                            {!existingDocumentUrls.dob_certificate && !DOBphoto && (
                              <span className="text-danger ms-2">
                                <i className="ti ti-alert-triangle me-1"></i>
                                Consent required if not uploaded
                              </span>
                            )}
                          </p>

                          {/* Only show in-person option if no existing document */}
                         
                        </div>
                      </div>
                    </div>
                    {selectedClassId >= 5 && !calculateAgeMatch(formData.date_of_birth, formData.select_class) && (
                      <>
                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">Do you have PEN Number/Bonfide certificate? <span className="text-danger">*</span></label>
                          <Select
                            classNamePrefix="react-select"
                            options={[
                              { value: 'yes', label: 'Yes' },
                              { value: 'no', label: 'No' }
                            ]}
                            value={
                              hasPENNumber === null
                                ? null
                                : hasPENNumber
                                  ? { value: 'yes', label: 'Yes' }
                                  : { value: 'no', label: 'No' }
                            }
                            onChange={(selectedOption) => {
                              if (selectedOption?.value === 'yes') {
                                setHasPENNumber(true);
                                setShowPENUpload(true);
                                // Reset the "not available" consent if they select Yes
                                setPenNotAvailableApplied(false);
                              } else if (selectedOption?.value === 'no') {
                                setHasPENNumber(false);
                                setShowPENUpload(false);
                                handleCheckPenNotAvailableApplied();
                              } else {
                                // Handle null/undefined selection
                                setHasPENNumber(null);
                                setShowPENUpload(false);
                              }
                            }}
                            placeholder="Select"
                            isClearable={true}
                          />
                        </div>

                        {showPENUpload && (
                          <>
                            <div className="col-lg-3 col-md-6 mb-3">
                              <label className="form-label">PEN Number <span className="text-danger">*</span></label>
                              <input
                                type="text"
                                className={`form-control ${errors.pen_number ? 'is-invalid' : ''}`}
                                placeholder="Enter PEN Number"
                                value={formData.pen_number}
                                onChange={(e) => handleChange('pen_number', e.target.value)}
                              />
                              {errors.pen_number && (
                                <div className="invalid-feedback">{errors.pen_number}</div>
                              )}
                            </div>

                            <div className="col-lg-3 col-md-6 mb-3">
                              <div className="d-flex align-items-center row-gap-3 mb-3">
                                <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                  {getDocumentDisplay('pen_certificate', PENphoto, existingDocumentUrls.pen_certificate) ? (
                                    <img
                                      src={getDocumentDisplay('pen_certificate', PENphoto, existingDocumentUrls.pen_certificate)}
                                      alt="PEN Certificate"
                                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                  ) : (
                                    <i className="ti ti-photo-plus fs-16" />
                                  )}
                                </div>
                                <div className="profile-upload">
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn mb-1">
                                      Upload PEN/Bonafide Certificate <span className="text-danger">*</span>
                                      <input
                                        type="file"
                                        className="form-control image-sign"
                                        accept="image/*,.pdf"
                                        onChange={(e) => {
                                          const file = e.target.files?.[0] || null;
                                          handleDocumentFileUpload('pen_certificate', file);
                                        }}
                                      />
                                    </div>
                                    {renderViewButton('pen_certificate')}
                                    {PENphoto && (
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger ms-2"
                                        onClick={() => clearDocumentFile('pen_certificate')}
                                      >
                                        <i className="ti ti-x me-1"></i>Clear
                                      </button>
                                    )}
                                  </div>
                                  <p className="fs-12">
                                    Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                    {existingDocumentUrls.pen_certificate && !PENphoto && (
                                      <span className="text-success ms-2">
                                        <i className="ti ti-check me-1"></i>
                                        Document uploaded
                                      </span>
                                    )}
                                  </p>
                                  
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {hasPENNumber === false && PENNumberMismatchItem && (
                          <div className="col-12 mb-3">
                            <p className="text-danger">{PENNumberMismatchItem.description}</p>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={PenNotAvailableApplied}
                                onChange={handleCheckPenNotAvailableApplied}
                                disabled={isConsentSubmitted}
                              />
                              <label className="form-check-label">
                                {PENNumberMismatchItem.message}
                              </label>
                            </div>
                          </div>
                        )}
                      </>
                    )}


                    {selectedClassId > 0 && selectedClassId <= 4 && !calculateAgeMatch(formData.date_of_birth, formData.select_class) && (
                      <>
                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">
                            Do you have a Bonafide/PEN Certificate? <span className="text-danger">*</span>
                          </label>
                          {/* <Select
                            classNamePrefix="react-select"
                            options={[
                              { value: 'yes', label: 'Yes' },
                              { value: 'no', label: 'No' }
                            ]}
                            value={
                              hasBonafideCertificate === null
                                ? null
                                : hasBonafideCertificate
                                  ? { value: 'yes', label: 'Yes' }
                                  : { value: 'no', label: 'No' }
                            }
                            onChange={(selectedOption) => {
                              if (selectedOption?.value === 'yes') {
                                setHasBonafideCertificate(true);
                                setShowBonafideUpload(true);
                                setBonafideNotAvailableApplied(false);
                              } else if (selectedOption?.value === 'no') {
                                setHasBonafideCertificate(false);
                                setShowBonafideUpload(false);
                                handleCheckBonafideNotAvailableApplied();
                              } else {
                                setHasBonafideCertificate(null);
                                setShowBonafideUpload(false);
                              }
                            }}
                            placeholder="Select"
                            isClearable={true}
                          /> */}

                          <Select
                            classNamePrefix="react-select"
                            options={[
                              { value: "yes", label: "Yes" },
                              { value: "no", label: "No" },
                            ]}
                            value={
                              hasBonafideCertificate === null
                                ? null
                                : hasBonafideCertificate
                                ? { value: "yes", label: "Yes" }
                                : { value: "no", label: "No" }
                            }
                             onChange={(selectedOption) => {
    if (selectedOption?.value === "yes") {
      setHasBonafideCertificate(true);
      setShowBonafideUpload(true);
      setBonafideNotAvailableApplied(false);
      setFormData((prev) => ({ ...prev, is_bonafide: true }));
    } else if (selectedOption?.value === "no") {
      setHasBonafideCertificate(false);
      setShowBonafideUpload(false);
      handleCheckBonafideNotAvailableApplied();
      setFormData((prev) => ({ ...prev, is_bonafide: false }));
    } else {
      setHasBonafideCertificate(null);
      setShowBonafideUpload(false);
      setFormData((prev) => ({ ...prev, is_bonafide: "" }));
    }
  }}
                            placeholder="Select"
                            isClearable={true}
                          />
                          {errors.hasBonafideCertificate && (
                            <div className="text-danger small mt-1">{errors.hasBonafideCertificate}</div>
                          )}
                        </div>

                        {showBonafideUpload && (
                          <div className="col-lg-3 col-md-6 mb-3">
                            <div className="d-flex align-items-center row-gap-3 mb-3">
                              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                {getDocumentDisplay('bonafide_certificate', Bonafidephoto, existingDocumentUrls.bonafide_certificate) ? (
                                  <img
                                    src={getDocumentDisplay('bonafide_certificate', Bonafidephoto, existingDocumentUrls.bonafide_certificate)}
                                    alt="Bonafide Certificate"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                  />
                                ) : (
                                  <i className="ti ti-photo-plus fs-16" />
                                )}
                              </div>
                              <div className="profile-upload">
                                <div className="profile-uploader d-flex align-items-center">
                                  <div className="drag-upload-btn mb-1">
                                    Upload Bonafide/PEN Certificate <span className="text-danger">*</span>
                                    <input
                                      type="file"
                                      className="form-control image-sign"
                                      accept="image/*,.pdf"
                                      onChange={(e) => {
                                        const file = e.target.files?.[0] || null;
                                        handleDocumentFileUpload('bonafide_certificate', file);
                                      }}
                                    />
                                  </div>
                                  {renderViewButton('bonafide_certificate')}
                                  {Bonafidephoto && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger ms-2"
                                      onClick={() => clearDocumentFile('bonafide_certificate')}
                                    >
                                      <i className="ti ti-x me-1"></i>Clear
                                    </button>
                                  )}
                                </div>
                                <p className="fs-12">
                                  Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                  {existingDocumentUrls.bonafide_certificate && !Bonafidephoto && (
                                    <span className="text-success ms-2">
                                      <i className="ti ti-check me-1"></i>
                                      Document uploaded
                                    </span>
                                  )}
                                </p>
                               
                                {errors.bonafide_certificate && (
                                  <div className="text-danger small mt-2">{errors.bonafide_certificate}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {hasBonafideCertificate === false && BonafideMismatchItem && (
                          <div className="col-12 mb-3">
                            <p className="text-danger">{BonafideMismatchItem.description}</p>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={BonafideNotAvailableApplied}
                                onChange={handleCheckBonafideNotAvailableApplied}
                                disabled={isConsentSubmitted1}
                              />
                              <label className="form-check-label">
                                {BonafideMismatchItem.message}
                              </label>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    <div className="row">
                      {/* Do you have Aadhar field */}
                      <div className="col-lg-3 col-md-6">
                        <label className="form-label">Do you have Child's Aadhar <span className="text-danger">*</span></label>
                        <Select
                          className="input"
                          placeholder="Select"
                          options={AadharOptionData2}
                          getOptionLabel={e => e.label}
                          getOptionValue={e => e.value}
                          value={AadharOptionData2?.find(option => option.value === AadharOptionData)}
                          onChange={handleDropdownAadharOptionDataChange}
                        />

                        {errors.aadhar_option && (
                          <div className="text-danger small mt-1">{errors.aadhar_option}</div>
                        )}
                      </div>

                      {/* Conditionally show "Have you applied?" NEXT TO it when Aadhar = No */}
                      {AadharOptionData === 'No' && (
                        <div className="col-lg-3 col-md-6">
                          <label className="form-label">Have You applied for Aadhar?*</label>
                          <Select
                            className="input"
                            placeholder="Select"
                            options={AppliedData2}
                            getOptionLabel={e => e.label}
                            getOptionValue={e => e.value}
                            value={AppliedData2?.find(option => option.value === AppliedData)}
                            onChange={handleDropdownAppliedDataChange}
                          />

                          {AppliedData === 'Yes' && AadharAlreadyAppliedConsent && (
                            <>
                              <p className="text-danger mt-3">{AadharAlreadyAppliedConsent.description}</p>
                              <div className="form-check mt-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={isAadharAppliedConsentSubmitted}
                                  onChange={(e) => {
                                    if (isAadharAppliedConsentSubmitted) return;
                                    if (!e.target.checked) {
                                      setIsAadharAppliedConsentSubmitted(false);
                                      return;
                                    }
                                    const confirmed = window.confirm('Do you acknowledge and want to proceed?');
                                    if (confirmed) {
                                      postConsentData(AadharAlreadyAppliedConsent.key, () => setIsAadharAppliedConsentSubmitted(true));
                                    } else {
                                      e.preventDefault();
                                    }
                                  }}
                                  disabled={isAadharAppliedConsentSubmitted}
                                  id="aadharAppliedConsentCheckbox"
                                />
                                <label className="form-check-label" htmlFor="aadharAppliedConsentCheckbox">
                                  {AadharAlreadyAppliedConsent.message}
                                </label>
                              </div>
                            </>
                          )}

                          {AppliedData === 'No' && StudentAadharNotAppliedConsent && (
                            <>
                              <p className="text-danger mt-3">{StudentAadharNotAppliedConsent.description}</p>
                              <div className="form-check mt-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={isAadharNotAppliedConsentAccepted}
                                  onChange={(e) => {
                                    if (isAadharNotAppliedConsentAccepted) return;
                                    if (!e.target.checked) {
                                      setIsAadharNotAppliedConsentAccepted(false);
                                      return;
                                    }
                                    const confirmed = window.confirm('Do you acknowledge and want to proceed?');
                                    if (confirmed) {
                                      postConsentData(StudentAadharNotAppliedConsent.key, () => setIsAadharNotAppliedConsentAccepted(true));
                                    } else {
                                      e.preventDefault();
                                    }
                                  }}
                                  disabled={isAadharNotAppliedConsentAccepted}
                                  id="aadharNotAppliedConsentCheckbox"
                                />
                                <label className="form-check-label" htmlFor="aadharNotAppliedConsentCheckbox">
                                  {StudentAadharNotAppliedConsent.message}
                                </label>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Show Aadhar fields only if user selected "Yes" */}
                    {AadharOptionData === 'Yes' && (
                      <>
                        <div className="col-lg-3 col-md-6">
                          <label className="form-label">Aadhar Number of Child <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            className={`form-control ${errors.aadhar_no ? 'is-invalid' : ''}`}
                            placeholder="Enter Your Aadhar Card Number"
                            maxLength={12}
                            value={formData.aadhar_no}
                            // disabled={aadharVerification.student.verified}
                            onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleChange('aadhar_no', onlyNumbers);
                            }}
                          />
                          {/* Only show OTP section if STUDENT-AADHAR is active */}
                          {servicePermissions.studentAadhar && (
                            <>
                              {!aadharVerification.student.verified && (
                                <div className="d-flex mt-2">
                                  {aadharVerification.student.otpSent && activeAadharField === 'student' ? (
                                    <>
                                      <input
                                        type="text"
                                        className="form-control me-2"
                                        placeholder="Enter OTP"
                                        value={aadharOTP}
                                        onChange={(e) => setAadharOTP(e.target.value)}
                                        maxLength={6}
                                      />
                                      <button
                                        className="btn btn-primary"
                                        onClick={handleVerifyContactOTP}
                                        disabled={aadharVerification.student.verifying}
                                      >
                                        {aadharVerification.student.verifying ? 'Verifying...' : 'Verify'}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => handleContactSendOTP('student')}
                                      disabled={formData.aadhar_no?.length !== 12 || aadharVerification.student.loading}
                                    >
                                      {aadharVerification.student.loading ? 'Sending...' : 'Send OTP'}
                                    </button>
                                  )}
                                </div>
                              )}
                            </>
                          )}
                          {/* {aadharVerification.student.verified && (
                            <div className="text-success mt-2">✅ Aadhar Verified</div>
                          )} */}
                          {errors.aadhar_no && (
                            <div className="invalid-feedback d-block">{errors.aadhar_no}</div>
                          )}
                        </div>
                        <div className="col-lg-3 col-md-6 mb-3">
                          <div className="d-flex align-items-center row-gap-3 mb-3">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                              {getDocumentDisplay('aadhar_file', StudentAadharphoto, existingDocumentUrls.aadhar_file) ? (
                                <img
                                  src={getDocumentDisplay('aadhar_file', StudentAadharphoto, existingDocumentUrls.aadhar_file)}
                                  alt="Student Aadhar"
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              ) : (
                                <i className="ti ti-photo-plus fs-16" />
                              )}
                            </div>
                            <div className="profile-upload">
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn mb-1">
                                  Upload Aadhar Card <span className="text-danger">*</span>
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    accept="image/*,.pdf"
                                    onChange={(e) => {
                                      const file = e.target.files?.[0] || null;
                                      handleDocumentFileUpload('aadhar_file', file);
                                    }}
                                  />
                                </div>
                                {renderViewButton('aadhar_file')}
                                {StudentAadharphoto && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger ms-2"
                                    onClick={() => clearDocumentFile('aadhar_file')}
                                  >
                                    <i className="ti ti-x me-1"></i>Clear
                                  </button>
                                )}
                              </div>
                              <p className="fs-12">
                                Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                {existingDocumentUrls.aadhar_file && !StudentAadharphoto && (
                                  <span className="text-success ms-2">
                                    <i className="ti ti-check me-1"></i>
                                    Document uploaded
                                  </span>
                                )}
                              </p>
                              
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Student Name ( As per Aadhar ) <span className="text-danger">*</span></label>
                            <div className="input-group mb-2">
                              <input
                                type="text"
                                className={`form-control ${errors.student_aadhar_name ? 'is-invalid' : ''}`}
                                value={formData.student_aadhar_name}
                                onChange={(e) => handleChange('student_aadhar_name', e.target.value)}
                                placeholder="As per Aadhar card"
                              />
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={autoFillAadhar}
                                onChange={(e) => setAutoFillAadhar(e.target.checked)}
                                id="autoFillCheckbox"
                              />
                              <label className="form-check-label" htmlFor="autoFillCheckbox">
                                Same as birth certificate
                              </label>
                            </div>
                            {hasStudentNameMismatch && (
                              <div className="mt-2">
                                <div className="d-flex align-items-start text-warning">
                                  <i className="ti ti-alert-triangle me-2 mt-1"></i>
                                  <div>
                                    <strong>Name mismatch detected</strong>
                                    <p className="mb-0 small text-muted">
                                      Aadhaar name: {formData.student_aadhar_name || 'N/A'}<br />
                                      Entered name: {formData.student_full_name || 'N/A'}
                                    </p>
                                  </div>
                                </div>
                                {StudentnameMismatchItem && (
                                  <div className="form-check mt-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="studentNameMismatchConsent"
                                      checked={IsSelectedStudentAadhar}
                                      onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        if (isChecked) {
                                          if (!IsSelectedStudentAadhar) {
                                            setIsSelectedStudentAadhar(true);
                                            postConsentData(StudentnameMismatchItem?.key);
                                          }
                                        } else {
                                          setIsSelectedStudentAadhar(false);
                                        }
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor="studentNameMismatchConsent">
                                      {StudentnameMismatchItem.message || 'I confirm the name mismatch and have applied for correction'}
                                    </label>
                                  </div>
                                )}
                              </div>
                            )}
                            {errors.student_aadhar_name && (
                              <div className="invalid-feedback d-block">{errors.student_aadhar_name}</div>
                            )}
                          </div>
                        </div>


                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Date of Birth ( As per Aadhar ) <span className="text-danger">*</span></label>
                            <div className="input-group mb-2">
                              <DatePicker
                                className={`form-control ${errors.aadhar_date_of_birth ? 'is-invalid' : ''}`}
                                placeholder="Select Date"
                                value={formData.aadhar_date_of_birth ? moment(formData.aadhar_date_of_birth) : null}
                                onFocus={() => handleChange("aadhar_date_of_birth", "")}
                                onChange={(date) => handleChange('aadhar_date_of_birth', date ? date.format('YYYY-MM-DD') : '')}
                              />
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="aadharDobCheckbox"
                                checked={formData.aadhar_date_of_birth === formData.date_of_birth}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    handleChange('aadhar_date_of_birth', formData.date_of_birth);
                                  } else {
                                    handleChange('aadhar_date_of_birth', '');
                                  }
                                }}
                              />
                              <label className="form-check-label" htmlFor="aadharDobCheckbox">
                                Same as birth certificate
                              </label>
                            </div>
                            {/* DOB mismatch message */}
                            {hasStudentDobMismatch && (
                              <div className="mt-2">
                                <div className="d-flex align-items-start text-warning">
                                  <i className="ti ti-alert-triangle me-2 mt-1"></i>
                                  <div>
                                    <strong>Date of birth mismatch detected</strong>
                                    <p className="mb-0 small text-muted">
                                      Aadhaar DOB: {formData.aadhar_date_of_birth || 'N/A'}<br />
                                      Birth certificate DOB: {formData.date_of_birth || 'N/A'}
                                    </p>
                                  </div>
                                </div>
                                {StudentDOBMismatch && (
                                  <div className="form-check mt-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="studentDobMismatchConsent"
                                      checked={StudentDOBMismatchItem}
                                      onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        if (isChecked) {
                                          if (!StudentDOBMismatchItem) {
                                            setStudentDOBMismatchItem(true);
                                            postConsentData(StudentDOBMismatch?.key);
                                          }
                                        } else {
                                          setStudentDOBMismatchItem(false);
                                        }
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor="studentDobMismatchConsent">
                                      {StudentDOBMismatch.message || 'I confirm the DOB mismatch and have applied for correction'}
                                    </label>
                                  </div>
                                )}
                              </div>
                            )}
                            {errors.aadhar_date_of_birth && (
                              <div className="invalid-feedback d-block">{errors.aadhar_date_of_birth}</div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Student Aadhar Address/Address <span className="text-danger">*</span></label>
                        <textarea
                          className={`form-control ${errors.student_aadhar_address ? 'is-invalid' : ''}`}
                          value={formData.student_aadhar_address}
                          onChange={(e) => !useFatherAddressForStudent && !useMotherAddressForStudent && handleChange('student_aadhar_address', e.target.value)}
                          placeholder="As per Aadhar Card Address/Address"
                          rows={3}
                          readOnly={useFatherAddressForStudent || useMotherAddressForStudent}
                        />

                        {errors.student_aadhar_address && (
                          <div className="invalid-feedback d-block">{errors.student_aadhar_address}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Religion <span className="text-danger">*</span></label>
                        <Select
                          classNamePrefix="react-select"
                          options={formattedReligion}
                          value={formattedReligion?.find(
                            (religion) => religion.value === Number(formData.select_religion)
                          )}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              handleChange("select_religion", selectedOption.value);
                            }
                          }}
                          placeholder="Select"
                        />
                        {errors.select_religion && (
                          <div className="text-danger small mt-1">{errors.select_religion}</div>
                        )}
                      </div>
                    </div>
                    {formattedCastCategory?.find(
                      (caste) => caste.value === formData.student_cast_category
                    )?.label !== "d" && (
                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">Are You Minority <span className="text-danger">*</span></label>
                          {/* <Select
                            classNamePrefix="react-select"
                            options={MajorityData2}
                            value={MajorityData2.find(opt => opt.value === formData.minority_status)}
                            onChange={(selectedOption) =>
                              handleChange('minority_status', selectedOption.value)
                            }
                            placeholder="Select"
                          /> */}

                          <Select
                          classNamePrefix="react-select"
                          options={MajorityData2}
                          value={MajorityData2?.find(
                            (opt) =>
                              opt.value ===
                              (formData.minority_status || defaultMinorityValue)
                          )}
                          onChange={(selectedOption) =>
                            handleChange(
                              "minority_status",
                              selectedOption.value
                            )
                          }
                          placeholder="Select"
                        />

                          {errors.minority_status && (
                            <div className="text-danger small mt-1">{errors.minority_status}</div>
                          )}
                        </div>
                      )}
                    <div className="col-lg-3 col-md-6 mb-3">
                      <label className="form-label">Caste <span className="text-danger">*</span></label>
                      <Select
                        classNamePrefix="react-select"
                        options={formattedCastCategory}
                        value={formattedCastCategory?.find(
                          (caste) => caste.value === formData.student_cast_category
                        )}
                        onChange={(selectedOption) => {
                          handleChange("student_cast_category", selectedOption.value);

                          if (selectedOption.label === "General") {
                            handleChange("minority_status", "");
                          }
                        }}
                        placeholder="Select Caste"
                      />
                      {errors.student_cast_category && (
                        <div className="invalid-feedback">
                          {errors.student_cast_category}
                        </div>
                      )}
                    </div>





                    {/* Caste Certificate Upload */}
                    {formattedCastCategory?.find(
                      (caste) => caste.value === formData.student_cast_category
                    )?.label !== "General" && (
                        <div className="col-lg-3 col-md-6 mb-3">
                          <div className="d-flex align-items-center row-gap-3 mb-3">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                              {getDocumentDisplay('cast_certificate', Castephoto, existingDocumentUrls.cast_certificate) ? (
                                <img
                                  src={getDocumentDisplay('cast_certificate', Castephoto, existingDocumentUrls.cast_certificate)}
                                  alt="Caste Certificate"
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              ) : (
                                <i className="ti ti-photo-plus fs-16" />
                              )}
                            </div>
                            <div className="profile-upload flex-grow-1">
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn mb-1">
                                  Upload Caste Certificate <span className="text-danger">*</span>
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    accept="image/*,.pdf"
                                    onChange={(e) => {
                                      const file = e.target.files?.[0] || null;
                                      handleDocumentFileUpload('cast_certificate', file);
                                    }}
                                  />
                                </div>
                                {renderViewButton('cast_certificate')}
                                {Castephoto && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger ms-2"
                                    onClick={() => clearDocumentFile('cast_certificate')}
                                  >
                                    <i className="ti ti-x me-1"></i>Clear
                                  </button>
                                )}
                              </div>
                              <p className="fs-12">
                                Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                {existingDocumentUrls.cast_certificate && !Castephoto && (
                                  <span className="text-success ms-2">
                                    <i className="ti ti-check me-1"></i>
                                    Document uploaded
                                  </span>
                                )}
                              </p>
                              
                            </div>
                          </div>
                        </div>
                      )}




                    {!isNurseryClass && (
                      <>
                        {/* TC Dropdown */}
                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">Do you have TC
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="input"
                            placeholder="Select"
                            options={TCOptionData2}
                            getOptionLabel={e => e.label}
                            getOptionValue={e => e.value}
                            value={TCOptionData2?.find(option => option.value === TCOptionData)}
                            onChange={handleDropdownTCOptionDataChange}
                          />
                          {errors.tc_option && (
                            <div className="text-danger small mt-1">{errors.tc_option}</div>
                          )}

                          {TCOptionData === 'No' && (
                            <>
                              <div className="text-danger">{TCNotAvailable?.description}</div>
                              <div className="form-check mt-1">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={TCNotAvailableData}
                                  onChange={handleCheckTCNotAvailableData}
                                  disabled={isConsentSubmitted3}
                                />
                                <label className="form-check-label">
                                  {TCNotAvailable?.message}
                                </label>
                              </div>
                            </>
                          )}

                        </div>

                        {/* If TC = Yes */}
                        {TCOptionData === 'Yes' && (
                          <>
                            <div className="col-lg-3 col-md-6 mb-3">
                              <label className="form-label">Transfer Certificate Number</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Transfer Certificate Number"
                                value={formData.transfer_certificate_no}
                                onChange={(e) =>
                                  handleChange('transfer_certificate_no', e.target.value)
                                }
                              />
                            </div>




                            {/* Transfer Certificate Upload */}
                            {!isNurseryClass && TCOptionData === 'Yes' && (
                              <div className="col-lg-3 col-md-6 mb-3">
                                <div className="d-flex align-items-center row-gap-3 mb-3">
                                  <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    {getDocumentDisplay('tc', Transferphoto, existingDocumentUrls.tc) ? (
                                      <img
                                        src={getDocumentDisplay('tc', Transferphoto, existingDocumentUrls.tc)}
                                        alt="Transfer Certificate"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                      />
                                    ) : (
                                      <i className="ti ti-photo-plus fs-16" />
                                    )}
                                  </div>
                                  <div className="profile-upload">
                                    <div className="profile-uploader d-flex align-items-center">
                                      <div className="drag-upload-btn mb-1">
                                        Upload Transfer Certificate <span className="text-danger">*</span>
                                        <input
                                          type="file"
                                          className="form-control image-sign"
                                          accept="image/*,.pdf"
                                          onChange={(e) => {
                                            const file = e.target.files?.[0] || null;
                                            handleDocumentFileUpload('tc', file);
                                          }}
                                        />
                                      </div>
                                      {renderViewButton('tc')}
                                      {Transferphoto && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger ms-2"
                                          onClick={() => clearDocumentFile('tc')}
                                        >
                                          <i className="ti ti-x me-1"></i>Clear
                                        </button>
                                      )}
                                    </div>
                                    <p className="fs-12">
                                      Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                      {existingDocumentUrls.tc && !Transferphoto && (
                                        <span className="text-success ms-2">
                                          <i className="ti ti-check me-1"></i>
                                          Document uploaded
                                        </span>
                                      )}
                                    </p>
                                    
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {!isNurseryClass && (
                      <>
                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">Last School Name <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            className={`form-control ${errors.last_school_name ? 'is-invalid' : ''}`}
                            placeholder="Last School Name"
                            value={formData.last_school_name}
                            onChange={(e) =>
                              handleChange('last_school_name', e.target.value)
                            }
                          />
                          {errors.last_school_name && (
                            <div className="invalid-feedback">{errors.last_school_name}</div>
                          )}
                        </div>

                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">Last School Class</label>
                          <Select
                            classNamePrefix="react-select"
                            options={lastSchoolClassOptions}
                            value={lastSchoolClassOptions?.find((option) => option.value === formData.last_school_class) || null}
                            onChange={(selectedOption) =>
                              handleChange('last_school_class', selectedOption?.value || '')
                            }
                            placeholder="Select Class"
                            isClearable
                          />
                          {errors.last_school_class && (
                            <div className="text-danger small mt-1">{errors.last_school_class}</div>
                          )}
                        </div>

                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">Last School Board</label>
                          <Select
                            classNamePrefix="react-select"
                            options={lastSchoolBoardOptions}
                            value={
                              showOtherBoardInput
                                ? { label: "Other", value: "Other" } // keep showing "Other" in dropdown
                                : lastSchoolBoardOptions?.find(
                                  (option) => option.value === formData.last_school_board
                                ) || null
                            }
                            onChange={(selectedOption) => {
                              if (selectedOption?.value === "Other") {
                                setShowOtherBoardInput(true);
                                setOtherBoardName(""); // clear previous input
                                handleChange("last_school_board", ""); // clear current form value
                              } else {
                                setShowOtherBoardInput(false);
                                handleChange("last_school_board", selectedOption?.value || "");
                              }
                            }}
                            placeholder="Select Board"
                            isClearable
                          />

                          {/* Conditionally show input field for custom board name */}
                          {showOtherBoardInput && (
                            <div className="mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Board Name"
                                value={otherBoardName}
                                onChange={(e) => {
                                  setOtherBoardName(e.target.value);
                                  handleChange("last_school_board", e.target.value);
                                }}
                              />
                            </div>
                          )}

                          {errors.last_school_board && (
                            <div className="text-danger small mt-1">
                              {errors.last_school_board}
                            </div>
                          )}
                        </div>


                        <div className="col-lg-3 col-md-6 mb-3">
                          <label className="form-label">Last School Address</label>
                          <input
                            type="text"
                            className={`form-control ${errors.last_school_address ? 'is-invalid' : ''}`}
                            placeholder="Last School Address"
                            value={formData.last_school_address}
                            onChange={(e) =>
                              handleChange('last_school_address', e.target.value)
                            }
                          />
                          {errors.last_school_address && (
                            <div className="invalid-feedback">{errors.last_school_address}</div>
                          )}
                        </div>
                      </>
                    )}
                    <div className="col-lg-3 col-md-6 mb-3">
                      <label className="form-label">
                        Pre Application Status
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.pri_application_status ? "is-invalid" : ""
                        }`}
                        placeholder="Status"
                        value={formData.pri_application_status}
                        // onChange={(e) =>
                        //   handleChange("pri_application_status", e.target.value)
                        // }
                        disabled
                      />
                    </div>

                  </div>
                </div>
              </div>

              {/* /Personal Information */}
              {/* Parents & Guardian Information */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-users fs-16" />
                    </span>
                    <h4 className="text-dark">Parents & Guardian Information</h4>
                  </div>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    {formData.is_single_parent ? (
                      formData.single_parent === "father" ? (
                        <>
                          {/* Father's Information */}
                          <div className="card border-light mb-4">
                            <div className="card-header bg-light">
                              <div className="d-flex align-items-center">
                                <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                                  <i className="ti ti-user-shield fs-16" />
                                </span>
                                <h4 className="text-dark">Father's Information</h4>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="row">
                                {/* Father's Photo Upload */}
                                <div className="col-md-12 mb-4">
                                  <div className="d-flex align-items-center flex-wrap row-gap-3">
                                    <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                      {Fatherphoto ? (
                                        <img src={URL.createObjectURL(Fatherphoto)} alt="Father" />
                                      ) : (
                                        <i className="ti ti-photo-plus fs-16" />
                                      )}
                                    </div>
                                    <div className="profile-upload">
                                      <div className="profile-uploader d-flex align-items-center">
                                        <div className="drag-upload-btn mb-3">
                                          Upload Father's Photo
                                          <input
                                            type="file"
                                            className="form-control image-sign"
                                            onChange={(e) => setFatherphoto(e.target.files[0])}
                                          />
                                        </div>
                                        {renderViewButton('father_photo')}
                                      </div>
                                      <p className="fs-12">Upload image size 4MB, Format JPG, PNG, SVG</p>
                                      <div className="form-check mt-2">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="dob-certificate-in-person"
                                          checked={Boolean(inPersonDocs.father_photo?.isSelected)}
                                          onChange={() => toggleInPersonDocument('father_photo')}
                                        />
                                        <label className="form-check-label" htmlFor="father_photo-in-person">
                                          Submited original in person
                                        </label>
                                      </div>
                                      {inPersonDocs.father_photo?.isSelected && (
                                        <textarea
                                          className="form-control mt-2"
                                          rows={2}
                                          placeholder="Notes for in-person verification (optional)"
                                          value={inPersonDocs.father_photo?.notes || ''}
                                          onChange={(e) => updateInPersonNotes('father_photo', e.target.value)}
                                        />
                                      )}

                                    </div>
                                  </div>
                                </div>

                                {/* Personal Details Section */}
                                <div className="col-lg-6 col-md-12">
                                  <div className="card border-light shadow-sm mb-3">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Personal Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        {/* Father's Full Name */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Father's Full Name <span className="text-danger">*</span></label>
                                          <input
                                            type="text"
                                            className={`form-control ${errors.father_full_name ? 'is-invalid' : ''}`}
                                            placeholder="Enter father's full name"
                                            value={formData.father_full_name}
                                            onChange={(e) => handleChange('father_full_name', e.target.value)}
                                          />
                                          {errors.father_full_name && (
                                            <div className="invalid-feedback">{errors.father_full_name}</div>
                                          )}
                                        </div>

                                        {/* Aadhaar Number & Verify */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Father's Aadhaar Number <span className="text-danger">*</span></label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className={`form-control ${errors.father_aadhar_no ? 'is-invalid' : ''}`}
                                              placeholder="Enter Aadhaar Number"
                                              maxLength={12}
                                              value={formData.father_aadhar_no}
                                              onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                handleChange('father_aadhar_no', onlyNumbers);
                                              }}
                                            // disabled={aadharVerification.father.verified}
                                            />
                                            {servicePermissions.fatherAadhar && !aadharVerification.father.verified && (
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => handleContactSendOTP('father')}
                                                disabled={formData.father_aadhar_no?.length !== 12 || aadharVerification.father.loading}
                                              >
                                                {aadharVerification.father.loading ? 'Sending...' : 'Verify'}
                                              </button>
                                            )}
                                          </div>
                                        </div>

                                        {/* OTP Verification */}
                                        {servicePermissions.fatherAadhar && aadharVerification.father.otpSent && (
                                          <div className="col-md-12 mb-3">
                                            <label className="form-label">Enter OTP</label>
                                            <div className="input-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="6-digit OTP"
                                                maxLength={6}
                                                value={aadharOTP}
                                                onChange={(e) => setAadharOTP(e.target.value)}
                                              />
                                              <button
                                                className="btn btn-primary"
                                                onClick={handleVerifyContactOTP}
                                                disabled={aadharVerification.father.verifying}
                                              >
                                                {aadharVerification.father.verifying ? 'Verifying...' : 'Submit'}
                                              </button>
                                            </div>
                                          </div>
                                        )}

                                        {/* Aadhaar Verification Status */}
                                        {/* {aadharVerification.father.verified && (
                                          <div className="col-md-12 mb-3">
                                            <div className="alert alert-success mb-0">
                                              <i className="ti ti-check me-2"></i>
                                              Aadhaar successfully verified
                                            </div>
                                          </div>
                                        )} */}
                                        {errors.father_aadhar_no && (
                                          <div className="invalid-feedback d-block">{errors.father_aadhar_no}</div>
                                        )}


                                        {servicePermissions.fatherAadhar && (
                                          <div className="col-md-12 mb-3">
                                            <label className="form-label">Name on Aadhaar</label>
                                            <input
                                              type="text"
                                              className="form-control bg-light"
                                              placeholder="Will auto-fill after verification"
                                              value={formData.father_aadhar_name || ''}
                                              onChange={(e) => handleChange('father_aadhar_name', e.target.value)}
                                            />
                                          </div>
                                        )}

                                        {/* Name Mismatch Warning */}
                                        {servicePermissions.fatherAadhar &&
                                          aadharVerification.father.verified &&
                                          formData.father_full_name &&
                                          formData.father_aadhar_name &&
                                          formData.father_full_name !== formData.father_aadhar_name && (
                                            <div className="col-12 mb-3">
                                              <div className="alert alert-warning">
                                                <div className="d-flex align-items-center">
                                                  <i className="ti ti-alert-triangle me-2"></i>
                                                  <div>
                                                    <strong>Name Mismatch Detected</strong>
                                                    <p className="mb-0">
                                                      Aadhaar name: {formData.father_aadhar_name}<br />
                                                      Entered name: {formData.father_full_name}
                                                    </p>
                                                  </div>
                                                </div>
                                                <div className="form-check mt-2">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="fatherNameMismatchConsent"
                                                    checked={IsSelectedFatherAadhar}
                                                    onChange={(e) => {
                                                      const isChecked = e.target.checked;
                                                      if (isChecked) {
                                                        const confirmed = window.confirm(
                                                          'Are you sure you want to proceed with the name mismatch?'
                                                        );
                                                        if (confirmed) {
                                                          setIsSelectedFatherAadhar(true);
                                                          postConsentData(FatherAadharMismatchItem?.key, () => setIsConsentSubmitted4(true));
                                                        } else {
                                                          e.preventDefault();
                                                        }
                                                      } else {
                                                        setIsSelectedFatherAadhar(false);
                                                      }
                                                    }}
                                                  />
                                                  <label className="form-check-label" htmlFor="fatherNameMismatchConsent">
                                                    I confirm the name mismatch and have applied for correction
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          )}

                                        {servicePermissions.fatherAadhar && (
                                          <div className="col-md-6 mb-3">
                                            <label className="form-label">Date of Birth</label>
                                            <DatePicker
                                              className="form-control"
                                              placeholder="Select Date"
                                              value={formData.father_date_of_birth ? moment(formData.father_date_of_birth) : null}
                                              onFocus={() => handleChange("father_date_of_birth", "")}
                                              onChange={(date) => handleChange('father_date_of_birth', date ? date.format('YYYY-MM-DD') : '')}
                                            />
                                          </div>
                                        )}
                                        {/* Mobile Number */}

                                      </div>
                                    </div>
                                  </div>
                                </div> {/* col-lg-6 - personal */}

                                {/* Professional Details Section */}
                                <div className="col-lg-6 col-md-12">
                                  <div className="card border-light shadow-sm mb-3">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Professional Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        {/* Qualification */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Qualification </label>
                                          <input
                                            type="text"
                                            className={`form-control ${errors.father_qualification ? 'is-invalid' : ''}`}
                                            placeholder="Father's highest qualification"
                                            value={formData.father_qualification}
                                            onChange={(e) => handleChange('father_qualification', e.target.value)}
                                          />
                                          {errors.father_qualification && (
                                            <div className="invalid-feedback">{errors.father_qualification}</div>
                                          )}
                                        </div>
                                        {/* Occupation */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Occupation</label>
                                          <Select
                                            classNamePrefix="react-select"
                                            options={FatherOccupationData2}
                                            value={FatherOccupationData2?.find(opt => opt.value === formData.father_occupation)}
                                            onChange={(selected) => handleChange('father_occupation', selected?.value)}
                                            placeholder="Select Occupation"
                                          />
                                        </div>
                                        {/* Company Name */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Company Name</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Father's company/organization name"
                                            value={formData.father_company_name}
                                            onChange={(e) => handleChange('father_company_name', e.target.value)}
                                          />
                                        </div>
                                        {/* Company Address */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Company Address</label>
                                          <textarea
                                            className="form-control"
                                            rows={3}
                                            placeholder="Complete company address"
                                            value={formData.father_company_address}
                                            onChange={(e) => handleChange('father_company_address', e.target.value)}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div> {/* col-lg-6 - professional */}

                              {servicePermissions.fatherAadhar && (
                                <div className="col-12">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Father's Aadhaar Address Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Father's Aadhaar Address <span className="text-danger">*</span></label>
                                          <textarea
                                            className={`form-control ${errors.father_aadhar_address ? 'is-invalid' : ''}`}
                                            rows={3}
                                            placeholder="Address as per Aadhaar"
                                            value={formData.father_aadhar_address}
                                            onChange={(e) => {
                                              if (!useStudentAddressForFather && !useMotherAddressForFather) {
                                                handleChange('father_aadhar_address', e.target.value);
                                              }
                                            }}
                                            readOnly={useStudentAddressForFather || useMotherAddressForFather}
                                          />
                                          {errors.father_aadhar_address && (
                                            <div className="invalid-feedback">{errors.father_aadhar_address}</div>
                                          )}
                                        </div>
                                        <div className="col-md-12">
                                          <div className="form-check mb-2">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useStudentAddressForFather"
                                              checked={useStudentAddressForFather}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseStudentAddressForFather(isChecked);
                                                setUseMotherAddressForFather(false);
                                                if (isChecked) {
                                                  handleChange('father_aadhar_address', formData.student_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useStudentAddressForFather">
                                              Use Student's Address
                                            </label>
                                          </div>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useMotherAddressForFather"
                                              checked={useMotherAddressForFather}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseMotherAddressForFather(isChecked);
                                                setUseStudentAddressForFather(false);
                                                if (isChecked) {
                                                  handleChange('father_aadhar_address', formData.mother_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useMotherAddressForFather">
                                              Use Mother's Address
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                                {/* Aadhaar Upload Section */}

                                <div className="col-12 mt-3">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Upload Father's Aadhaar Card </h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="d-flex align-items-center row-gap-3">
                                        <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                          {getDocumentDisplay('father_aadhar_file', FatherAadharphoto, existingDocumentUrls.father_aadhar_file) ? (
                                            <img
                                              src={getDocumentDisplay('father_aadhar_file', FatherAadharphoto, existingDocumentUrls.father_aadhar_file)}
                                              alt="Father Aadhar"
                                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                          ) : (
                                            <i className="ti ti-photo-plus fs-16" />
                                          )}
                                        </div>
                                        <div className="profile-upload">
                                          <div className="profile-uploader d-flex align-items-center">
                                            <div className="drag-upload-btn mb-1">
                                              Upload Aadhaar Card
                                              <input
                                                type="file"
                                                className="form-control image-sign"
                                                accept="image/*,.pdf"
                                                onChange={(e) => {
                                                  const file = e.target.files?.[0] || null;
                                                  handleDocumentFileUpload('father_aadhar_file', file);
                                                }}
                                              />
                                            </div>
                                            {renderViewButton('father_aadhar_file')}
                                            {FatherAadharphoto && (
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger ms-2"
                                                onClick={() => clearDocumentFile('father_aadhar_file')}
                                              >
                                                <i className="ti ti-x me-1"></i>Clear
                                              </button>
                                            )}
                                          </div>
                                          <p className="fs-12">
                                            Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                            {existingDocumentUrls.father_aadhar_file && !FatherAadharphoto && (
                                              <span className="text-success ms-2">
                                                <i className="ti ti-check me-1"></i>
                                                Document uploaded
                                              </span>
                                            )}
                                          </p>
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          {/* Add other father fields as needed */}
                        </>
                      ) : formData.single_parent === "mother" ? (
                        <>
                          {/* Mother's Information */}
                          <div className="card border-light mb-4">
                            <div className="card-header bg-light">
                              <div className="d-flex align-items-center">
                                <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                                  <i className="ti ti-user-circle fs-16" />
                                </span>
                                <h4 className="text-dark">Mother's Information</h4>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="row">
                                {/* Mother's Photo Upload */}
                                <div className="col-md-12 mb-4">
                                  <div className="d-flex align-items-center flex-wrap row-gap-3">
                                    <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                      {Motherphoto ? (
                                        <img src={URL.createObjectURL(Motherphoto)} alt="Mother" />
                                      ) : (
                                        <i className="ti ti-photo-plus fs-16" />
                                      )}
                                    </div>
                                    <div className="profile-upload">
                                      <div className="profile-uploader d-flex align-items-center">
                                        <div className="drag-upload-btn mb-3">
                                          Upload Mother's Photo
                                          <input
                                            type="file"
                                            className="form-control image-sign"
                                            onChange={(e) => setMotherphoto(e.target.files[0])}
                                          />
                                        </div>
                                        {renderViewButton('mother_photo_upload')}
                                      </div>
                                      <p className="fs-12">Upload image size 4MB, Format JPG, PNG, SVG</p>
                                      <div className="form-check mt-2">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="dob-certificate-in-person"
                                          checked={Boolean(inPersonDocs.mother_photo_upload?.isSelected)}
                                          onChange={() => toggleInPersonDocument('mother_photo_upload')}
                                        />
                                        <label className="form-check-label" htmlFor="mother_photo_upload-in-person">
                                          Submited original in person
                                        </label>
                                      </div>
                                      {inPersonDocs.mother_photo_upload?.isSelected && (
                                        <textarea
                                          className="form-control mt-2"
                                          rows={2}
                                          placeholder="Notes for in-person verification (optional)"
                                          value={inPersonDocs.father_photo?.notes || ''}
                                          onChange={(e) => updateInPersonNotes('father_photo', e.target.value)}
                                        />
                                      )}

                                    </div>
                                  </div>
                                </div>

                                {/* Personal Details Section */}
                                <div className="col-lg-6 col-md-12">
                                  <div className="card border-light shadow-sm mb-3">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Personal Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        {/* Mother's Full Name */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Mother's Full Name <span className="text-danger">*</span></label>
                                          <input
                                            type="text"
                                            className={`form-control ${errors.mother_full_name ? 'is-invalid' : ''}`}
                                            placeholder="Enter mother's full name"
                                            value={formData.mother_full_name}
                                            onChange={(e) => handleChange('mother_full_name', e.target.value)}
                                          />
                                          {errors.mother_full_name && (
                                            <div className="invalid-feedback">{errors.mother_full_name}</div>
                                          )}
                                        </div>

                                        {/* Aadhaar Number & Verify */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Mother's Aadhaar Number <span className="text-danger">*</span></label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className={`form-control ${errors.mother_aadhar_no ? 'is-invalid' : ''}`}
                                              placeholder="Enter Aadhaar Number"
                                              maxLength={12}
                                              value={formData.mother_aadhar_no}
                                              onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                handleChange('mother_aadhar_no', onlyNumbers);
                                              }}
                                            // disabled={aadharVerification.mother.verified}
                                            />
                                            {servicePermissions.motherAadhar && !aadharVerification.mother.verified && (
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => handleContactSendOTP('mother')}
                                                disabled={formData.mother_aadhar_no?.length !== 12 || aadharVerification.mother.loading}
                                              >
                                                {aadharVerification.mother.loading ? 'Sending...' : 'Verify'}
                                              </button>
                                            )}
                                          </div>
                                        </div>

                                        {/* OTP Verification */}
                                        {servicePermissions.motherAadhar && aadharVerification.mother.otpSent && (
                                          <div className="col-md-12 mb-3">
                                            <label className="form-label">Enter OTP</label>
                                            <div className="input-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="6-digit OTP"
                                                maxLength={6}
                                                value={aadharOTP}
                                                onChange={(e) => setAadharOTP(e.target.value)}
                                              />
                                              <button
                                                className="btn btn-primary"
                                                onClick={handleVerifyContactOTP}
                                                disabled={aadharVerification.mother.verifying}
                                              >
                                                {aadharVerification.mother.verifying ? 'Verifying...' : 'Submit'}
                                              </button>
                                            </div>
                                          </div>
                                        )}

                                        {/* Aadhaar Verification Status */}
                                        {/* {aadharVerification.mother.verified && (
                                          <div className="col-md-12 mb-3">
                                            <div className="alert alert-success mb-0">
                                              <i className="ti ti-check me-2"></i>
                                              Aadhaar successfully verified
                                            </div>
                                          </div>
                                        )} */}
                                        {errors.mother_aadhar_no && (
                                          <div className="invalid-feedback d-block">{errors.mother_aadhar_no}</div>
                                        )}

                                        {/* Name on Aadhaar */}
                                        {servicePermissions.motherAadhar && (
                                          <div className="col-md-12 mb-3">
                                            <label className="form-label">Name on Aadhaar</label>
                                            <input
                                              type="text"
                                              className="form-control bg-light"
                                              placeholder="Will auto-fill after verification"
                                              value={formData.mother_aadhar_name || ''}
                                              onChange={(e) => handleChange('mother_aadhar_name', e.target.value)}
                                            />
                                          </div>
                                        )}

                                        {/* Name Mismatch Warning */}
                                        {servicePermissions.motherAadhar &&
                                          aadharVerification.mother.verified &&
                                          formData.mother_full_name &&
                                          formData.mother_aadhar_name &&
                                          formData.mother_full_name !== formData.mother_aadhar_name && (
                                            <div className="col-12 mb-3">
                                              <div className="alert alert-warning">
                                                <div className="d-flex align-items-center">
                                                  <i className="ti ti-alert-triangle me-2"></i>
                                                  <div>
                                                    <strong>Name Mismatch Detected</strong>
                                                    <p className="mb-0">
                                                      Aadhaar name: {formData.mother_aadhar_name}<br />
                                                      Entered name: {formData.mother_full_name}
                                                    </p>
                                                  </div>
                                                </div>
                                                <div className="form-check mt-2">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="motherNameMismatchConsent"
                                                    checked={MotherAadharData}
                                                    onChange={(e) => {
                                                      const isChecked = e.target.checked;
                                                      if (isChecked) {
                                                        const confirmed = window.confirm(
                                                          'Are you sure you want to proceed with the name mismatch?'
                                                        );
                                                        if (confirmed) {
                                                          setMotherAadharData(true);
                                                          postConsentData(MotherAadharMismatchItem?.key, () => setIsConsentSubmitted5(true));
                                                        } else {
                                                          e.preventDefault();
                                                        }
                                                      } else {
                                                        setMotherAadharData(false);
                                                      }
                                                    }}
                                                  />
                                                  <label className="form-check-label" htmlFor="motherNameMismatchConsent">
                                                    I confirm the name mismatch and have applied for correction
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          )}

                                        {servicePermissions.motherAadhar && (
                                          <div className="col-md-6 mb-3">
                                            <label className="form-label">Date of Birth</label>
                                            <DatePicker
                                              className="form-control"
                                              placeholder="Select Date"
                                              value={formData.mother_date_of_birth ? moment(formData.mother_date_of_birth) : null}
                                              onFocus={() => handleChange("mother_date_of_birth", "")}
                                              onChange={(date) => handleChange('mother_date_of_birth', date ? date.format('YYYY-MM-DD') : '')}
                                            />
                                          </div>
                                        )}
                                        {/* Mobile Number */}

                                      </div>
                                    </div>
                                  </div>
                                </div> {/* col-lg-6 - personal */}

                                {/* Professional Details Section */}
                                <div className="col-lg-6 col-md-12">
                                  <div className="card border-light shadow-sm mb-3">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Professional Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        {/* Qualification */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Qualification </label>
                                          <input
                                            type="text"
                                            className={`form-control ${errors.mother_qualification ? 'is-invalid' : ''}`}
                                            placeholder="Mother's highest qualification"
                                            value={formData.mother_qualification}
                                            onChange={(e) => handleChange('mother_qualification', e.target.value)}
                                          />
                                          {errors.mother_qualification && (
                                            <div className="invalid-feedback">{errors.mother_qualification}</div>
                                          )}
                                        </div>
                                        {/* Occupation */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Occupation</label>
                                          <Select
                                            classNamePrefix="react-select"
                                            options={MotherOccupationData2}
                                            value={MotherOccupationData2?.find(opt => opt.value === formData.mother_occupation)}
                                            onChange={(selected) => handleChange('mother_occupation', selected?.value)}
                                            placeholder="Select Occupation"
                                          />
                                        </div>
                                        {/* Company Name */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Company Name</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Mother's company/organization name"
                                            value={formData.mother_company_name}
                                            onChange={(e) => handleChange('mother_company_name', e.target.value)}
                                          />
                                        </div>
                                        {/* Company Address */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Company Address</label>
                                          <textarea
                                            className="form-control"
                                            rows={3}
                                            placeholder="Complete company address"
                                            value={formData.mother_company_address}
                                            onChange={(e) => handleChange('mother_company_address', e.target.value)}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div> {/* col-lg-6 - professional */}

                               {servicePermissions.motherAadhar && (
                                <div className="col-12">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Mother's Aadhaar Address Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Aadhaar Address <span className="text-danger">*</span></label>
                                          <textarea
                                            className={`form-control ${errors.mother_aadhar_address ? 'is-invalid' : ''}`}
                                            rows={3}
                                            placeholder="Address as per Aadhaar"
                                            value={formData.mother_aadhar_address}
                                            onChange={(e) => {
                                              if (!useStudentAddressForMother && !useFatherAddressForMother) {
                                                handleChange('mother_aadhar_address', e.target.value);
                                              }
                                            }}
                                            readOnly={useStudentAddressForMother || useFatherAddressForMother}
                                          />
                                          {errors.mother_aadhar_address && (
                                            <div className="invalid-feedback">{errors.mother_aadhar_address}</div>
                                          )}
                                        </div>
                                        <div className="col-md-12">
                                          <div className="form-check mb-2">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useStudentAddressForMother"
                                              checked={useStudentAddressForMother}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseStudentAddressForMother(isChecked);
                                                setUseFatherAddressForMother(false);
                                                if (isChecked) {
                                                  handleChange('mother_aadhar_address', formData.student_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useStudentAddressForMother">
                                              Use Student's Address
                                            </label>
                                          </div>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useFatherAddressForMother"
                                              checked={useFatherAddressForMother}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseFatherAddressForMother(isChecked);
                                                setUseStudentAddressForMother(false);
                                                if (isChecked) {
                                                  handleChange('mother_aadhar_address', formData.father_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useFatherAddressForMother">
                                              Use Father's Address
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                               )}
                                {/* Aadhaar Upload Section */}

                                <div className="col-12 mt-3">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Upload Mother's Aadhaar Card</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="d-flex align-items-center row-gap-3">
                                        <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                          {getDocumentDisplay('mother_aadhar_file', MotherAadharphoto, existingDocumentUrls.mother_aadhar_file) ? (
                                            <img
                                              src={getDocumentDisplay('mother_aadhar_file', MotherAadharphoto, existingDocumentUrls.mother_aadhar_file)}
                                              alt="Mother Aadhar"
                                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                          ) : (
                                            <i className="ti ti-photo-plus fs-16" />
                                          )}
                                        </div>
                                        <div className="profile-upload">
                                          <div className="profile-uploader d-flex align-items-center">
                                            <div className="drag-upload-btn mb-1">
                                              Upload Aadhaar Card
                                              <input
                                                type="file"
                                                className="form-control image-sign"
                                                onChange={(e) => {
                                                  const file = e.target.files?.[0] || null;
                                                  handleDocumentFileUpload('mother_aadhar_file', file);
                                                }}
                                              />
                                            </div>
                                            {renderViewButton('mother_aadhar_file')}
                                          </div>
                                          <p className="fs-12">
                                            Upload image size 4MB, Format JPG, PNG, SVG
                                            {existingDocumentUrls.mother_aadhar_file && !MotherAadharphoto && (
                                              <span className="text-success ms-2">
                                                <i className="ti ti-check me-1"></i>
                                                Document already uploaded
                                              </span>
                                            )}
                                          </p>
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>
                          </div>
                          {/* Add other mother fields as needed */}
                        </>
                      ) : (
                        <>
                          {/* Guardian's Information */}
                          <div className="card border-light mb-4">
                            <div className="card-header bg-light">
                              <div className="d-flex align-items-center">
                                <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                                  <i className="ti ti-user-shield fs-16" />
                                </span>
                                <h4 className="text-dark">Guardian's Information</h4>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="row">

                                {/* Guardian's Photo Upload */}
                                {/* Guardian's Photo Upload */}
                                {/* Guardian's Photo Upload - Only show when single parent is guardian */}
                                {(formData.is_single_parent && formData.single_parent === "guardian") && (
                                  <div className="col-md-12 mb-4">
                                    <div className="d-flex align-items-center flex-wrap row-gap-3">
                                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                        {getDocumentDisplay('guardian_photo', Guardianphoto, existingDocumentUrls.upload_guardian_photo) ? (
                                          <img src={getDocumentDisplay('guardian_photo', Guardianphoto, existingDocumentUrls.upload_guardian_photo)} alt="Guardian" />
                                        ) : (
                                          <i className="ti ti-photo-plus fs-16" />
                                        )}
                                      </div>
                                      <div className="profile-upload">
                                        <div className="profile-uploader d-flex align-items-center">
                                          <div className="drag-upload-btn mb-3">
                                            Upload Guardian's Photo
                                            <input
                                              type="file"
                                              className="form-control image-sign"
                                              accept="image/*"
                                              onChange={(e) => {
                                                const file = e.target.files?.[0] || null;
                                                setGuardianphoto(file);
                                                handleChange('upload_guardian_photo', file); // Make sure this matches your formData field
                                              }}
                                            />
                                          </div>
                                          {renderViewButton('guardian_photo')}
                                          {Guardianphoto && (
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-outline-danger ms-2"
                                              onClick={() => {
                                                setGuardianphoto(null);
                                                handleChange('upload_guardian_photo', null);
                                              }}
                                            >
                                              <i className="ti ti-x me-1"></i>Clear
                                            </button>
                                          )}
                                        </div>
                                        <p className="fs-12">
                                          Upload image size 4MB, Format JPG, PNG, SVG
                                          {existingDocumentUrls.upload_guardian_photo && !Guardianphoto && (
                                            <span className="text-success ms-2">
                                              <i className="ti ti-check me-1"></i>
                                              Photo already uploaded - No consent required
                                            </span>
                                          )}
                                          {!existingDocumentUrls.upload_guardian_photo && !Guardianphoto && (
                                            <span className="text-danger ms-2">
                                              <i className="ti ti-alert-triangle me-1"></i>
                                              Consent required if not uploaded
                                            </span>
                                          )}
                                        </p>

                                        {/* In-person submission option - only show if no existing document */}
                                        

                                        {errors.guardian_photo && (
                                          <div className="text-danger small mt-1">{errors.guardian_photo}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Personal Details */}
                                <div className="col-lg-6 col-md-12">
                                  <div className="card border-light shadow-sm mb-3">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Personal Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        {/* Guardian Name */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Guardian's Full Name <span className="text-danger">*</span></label>
                                          <input
                                            type="text"
                                            className={`form-control ${errors.guardian_name ? 'is-invalid' : ''}`}
                                            placeholder="Enter Guardian's Full Name"
                                            value={formData.guardian_name}
                                            onChange={(e) => handleChange("guardian_name", e.target.value)}
                                          />
                                          {errors.guardian_name && (
                                            <div className="invalid-feedback">{errors.guardian_name}</div>
                                          )}
                                        </div>

                                        {/* Relation */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Guardian's Relation</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Guardian's Relation"
                                            value={formData.guardian_relation}
                                            onChange={(e) => handleChange("guardian_relation", e.target.value)}
                                          />
                                        </div>

                                        {/* Aadhaar Number */}
                                        {/* Aadhaar Number & Verify */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Guardian's Aadhaar Number <span className="text-danger">*</span></label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className={`form-control ${errors.guardian_aadhar_no ? 'is-invalid' : ''}`}
                                              placeholder="Enter Aadhaar Number"
                                              maxLength={12}
                                              value={formData.guardian_aadhar_no}
                                              onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                handleChange('guardian_aadhar_no', onlyNumbers);
                                              }}
                                             
                                            />
                                            {servicePermissions.guardianAadhar && !aadharVerification.guardian.verified && (
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => handleContactSendOTP('guardian')}
                                                disabled={formData.guardian_aadhar_no?.length !== 12 || aadharVerification.guardian.loading}
                                              >
                                                {aadharVerification.guardian.loading ? 'Sending...' : 'Verify'}
                                              </button>
                                            )}
                                          </div>
                                        </div>

                                        {/* OTP Verification */}
                                        {aadharVerification.guardian.otpSent && (
                                          <div className="col-md-12 mb-3">
                                            <label className="form-label">Enter OTP</label>
                                            <div className="input-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="6-digit OTP"
                                                maxLength={6}
                                                value={aadharOTP}
                                                onChange={(e) => setAadharOTP(e.target.value)}
                                              />
                                              <button
                                                className="btn btn-primary"
                                                onClick={handleVerifyContactOTP}
                                                disabled={aadharVerification.guardian.verifying}
                                              >
                                                {aadharVerification.guardian.verifying ? 'Verifying...' : 'Submit'}
                                              </button>
                                            </div>
                                          </div>
                                        )}

                                        {/* Aadhaar Verification Status */}
                                        {/* {aadharVerification.guardian.verified && (
                                          <div className="col-md-12 mb-3">
                                            <div className="alert alert-success mb-0">
                                              <i className="ti ti-check me-2"></i>
                                              Aadhaar successfully verified
                                            </div>
                                          </div>
                                        )} */}
                                        {errors.guardian_aadhar_no && (
                                          <div className="invalid-feedback d-block">{errors.guardian_aadhar_no}</div>
                                        )}
                                        {errors.guardian_aadhar_no && (
                                          <div className="invalid-feedback d-block">{errors.guardian_aadhar_no}</div>
                                        )}

                                        {/* Name on Aadhaar */}
                                        {servicePermissions.guardianAadhar && (
                                          <div className="col-md-12 mb-3">
                                            <label className="form-label">Name on Aadhaar</label>
                                            <input
                                              type="text"
                                              className="form-control bg-light"
                                              placeholder="Will auto-fill after verification"
                                              value={formData.guardian_aadhar_name || ''}
                                              onChange={(e) => handleChange('guardian_aadhar_name', e.target.value)}
                                            />
                                          </div>
                                        )}
                                        {/* Name Mismatch Warning for Guardian */}
                                        {servicePermissions.guardianAadhar &&
                                          aadharVerification.guardian.verified &&
                                          formData.guardian_name &&
                                          formData.guardian_aadhar_name &&
                                          formData.guardian_name !== formData.guardian_aadhar_name && (
                                            <div className="col-12 mb-3">
                                              <div className="alert alert-warning">
                                                <div className="d-flex align-items-center">
                                                  <i className="ti ti-alert-triangle me-2"></i>
                                                  <div>
                                                    <strong>Name Mismatch Detected</strong>
                                                    <p className="mb-0">
                                                      Aadhaar name: {formData.guardian_aadhar_name}<br />
                                                      Entered name: {formData.guardian_name}
                                                    </p>
                                                  </div>
                                                </div>
                                                <div className="form-check mt-2">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="guardianNameMismatchConsent"
                                                    checked={IsSelectedGuardianAadhar}
                                                    onChange={(e) => {
                                                      const isChecked = e.target.checked;
                                                      if (isChecked) {
                                                        const confirmed = window.confirm(
                                                          'Are you sure you want to proceed with the name mismatch?'
                                                        );
                                                        if (confirmed) {
                                                          setIsSelectedGuardianAadhar(true);
                                                          postConsentData(GuardianAadharMismatchItem?.key, () => setIsConsentSubmitted8(true));
                                                        } else {
                                                          e.preventDefault();
                                                        }
                                                      } else {
                                                        setIsSelectedGuardianAadhar(false);
                                                      }
                                                    }}
                                                  />
                                                  <label className="form-check-label" htmlFor="guardianNameMismatchConsent">
                                                    I confirm the name mismatch and have applied for correction
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        {servicePermissions.guardianAadhar && (
                                          <div className="col-md-12 mb-3">
                                            <label className="form-label">Date of Birth</label>
                                            <DatePicker
                                              className="form-control"
                                              placeholder="Select Date"
                                              value={formData.guardian_date_of_birth ? dayjs(formData.guardian_date_of_birth) : null}
                                              onFocus={() => handleChange("guardian_date_of_birth", "")}
                                              onChange={(date) =>
                                                handleChange("guardian_date_of_birth", date ? date.format("YYYY-MM-DD") : "")
                                              }
                                              format="YYYY-MM-DD"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Professional Details */}
                                <div className="col-lg-6 col-md-12">
                                  <div className="card border-light shadow-sm mb-3">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Professional Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        {/* Qualification */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Qualification</label>
                                          <input
                                            type="text"
                                            className={`form-control ${errors.guardian_qualification ? 'is-invalid' : ''}`}
                                            placeholder="Guardian's Qualification"
                                            value={formData.guardian_qualification}
                                            onChange={(e) => handleChange("guardian_qualification", e.target.value)}
                                          />
                                          {errors.guardian_qualification && (
                                            <div className="invalid-feedback">{errors.guardian_qualification}</div>
                                          )}
                                        </div>

                                        {/* Occupation */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Occupation</label>
                                          <Select
                                            classNamePrefix="react-select"
                                            options={FatherOccupationData2}
                                            value={FatherOccupationData2?.find((opt) => opt.value === formData.guardian_occupation)}
                                            onChange={(selected) => handleChange("guardian_occupation", selected?.value)}
                                            placeholder="Select Occupation"
                                          />
                                        </div>

                                        {/* Company Name */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Company Name</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Guardian's Company"
                                            value={formData.guardian_company_name}
                                            onChange={(e) => handleChange("guardian_company_name", e.target.value)}
                                          />
                                        </div>

                                        {/* Company Address */}
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Company Address</label>
                                          <textarea
                                            className="form-control"
                                            rows={3}
                                            placeholder="Company Address"
                                            value={formData.guardian_company_address}
                                            onChange={(e) => handleChange("guardian_company_address", e.target.value)}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Aadhaar Address */}
                                {servicePermissions.guardianAadhar && (
                                <div className="col-12">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Guardian's Aadhaar Address Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <label className="form-label">Guardian's Aadhaar Address <span className="text-danger">*</span></label>
                                      <textarea
                                        className={`form-control ${errors.guardian_aadhar_address ? 'is-invalid' : ''}`}
                                        rows={3}
                                        placeholder="Guardian's Aadhaar Address"
                                        value={formData.guardian_aadhar_address}
                                        onChange={(e) => handleChange("guardian_aadhar_address", e.target.value)}
                                      />
                                      {errors.guardian_aadhar_address && (
                                        <div className="invalid-feedback d-block">{errors.guardian_aadhar_address}</div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                )}
                                {/* Aadhaar Upload */}
                                <div className="col-12 mt-3">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Upload Guardian's Aadhaar Card</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="d-flex align-items-center row-gap-3">
                                        <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                          {getDocumentDisplay('guardian_aadhar_file', GuardianAadharphoto, existingDocumentUrls.guardian_aadhar_file) ? (
                                            <img
                                              src={getDocumentDisplay('guardian_aadhar_file', GuardianAadharphoto, existingDocumentUrls.guardian_aadhar_file)}
                                              alt="Guardian Aadhaar"
                                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                          ) : (
                                            <i className="ti ti-photo-plus fs-16" />
                                          )}
                                        </div>
                                        <div className="profile-upload">
                                          <div className="profile-uploader d-flex align-items-center">
                                            <div className="drag-upload-btn mb-1">
                                              Upload Aadhaar Card
                                              <input
                                                type="file"
                                                className="form-control image-sign"
                                                accept="image/*,.pdf"
                                                onChange={(e) => {
                                                  const file = e.target.files?.[0] || null;
                                                  handleDocumentFileUpload('guardian_aadhar_file', file);
                                                }}
                                              />
                                            </div>
                                            {renderViewButton('guardian_aadhar_file')}
                                            {GuardianAadharphoto && (
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger ms-2"
                                                onClick={() => clearDocumentFile('guardian_aadhar_file')}
                                              >
                                                <i className="ti ti-x me-1"></i>Clear
                                              </button>
                                            )}
                                          </div>
                                          <p className="fs-12">
                                            Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                            {existingDocumentUrls.guardian_aadhar_file && !GuardianAadharphoto && (
                                              <span className="text-success ms-2">
                                                <i className="ti ti-check me-1"></i>
                                                Document uploaded
                                              </span>
                                            )}
                                          </p>
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>

                        </>
                      )
                    ) : (
                      <>
                        {/* Father's Information */}
                        <div className="card border-light mb-4">
                          <div className="card-header bg-light">
                            <div className="d-flex align-items-center">
                              <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                                <i className="ti ti-user-shield fs-16" />
                              </span>
                              <h4 className="text-dark">Father's Information</h4>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              {/* Father's Photo Upload */}
                              {/* Father's Photo Upload */}
                              <div className="col-md-12 mb-4">
                                <div className="d-flex align-items-center flex-wrap row-gap-3">
                                  <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    {getDocumentDisplay('father_photo', Fatherphoto, existingDocumentUrls.father_photo) ? (
                                      <img
                                        src={getDocumentDisplay('father_photo', Fatherphoto, existingDocumentUrls.father_photo)}
                                        alt="Father"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                      />
                                    ) : (
                                      <i className="ti ti-photo-plus fs-16" />
                                    )}
                                  </div>
                                  <div className="profile-upload">
                                    <div className="profile-uploader d-flex align-items-center">
                                      <div className="drag-upload-btn mb-3">
                                        Upload Father's Photo
                                        <input
                                          type="file"
                                          className="form-control image-sign"
                                          accept="image/*"
                                          onChange={(e) => {
                                            const file = e.target.files?.[0] || null;
                                            setFatherphoto(file);
                                            handleChange('father_photo', file);
                                          }}
                                        />
                                      </div>
                                      {renderViewButton('father_photo')}
                                      {/* Clear button when new file is selected */}
                                      {Fatherphoto && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger ms-2"
                                          onClick={() => {
                                            setFatherphoto(null);
                                            handleChange('father_photo', null);
                                          }}
                                        >
                                          <i className="ti ti-x me-1"></i>Clear
                                        </button>
                                      )}
                                    </div>
                                    <p className="fs-12">
                                      Upload image size 4MB, Format JPG, PNG, SVG
                                      {existingDocumentUrls.father_photo && !Fatherphoto && (
                                        <span className="text-success ms-2">
                                          <i className="ti ti-check me-1"></i>
                                          Photo already uploaded
                                        </span>
                                      )}
                                    </p>

                                    {/* In-person submission option */}
                                    

                                    {errors.father_photo && (
                                      <div className="text-danger small mt-1">{errors.father_photo}</div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Personal Details Section */}
                              <div className="col-lg-6 col-md-12">
                                <div className="card border-light shadow-sm mb-3">
                                  <div className="card-header bg-light py-2">
                                    <h6 className="mb-0">Personal Details</h6>
                                  </div>
                                  <div className="card-body">
                                    <div className="row">
                                      {/* Father's Full Name */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Father's Full Name <span className="text-danger">*</span></label>
                                        <input
                                          type="text"
                                          className={`form-control ${errors.father_full_name ? 'is-invalid' : ''}`}
                                          placeholder="Enter father's full name"
                                          value={formData.father_full_name}
                                          onChange={(e) => handleChange('father_full_name', e.target.value)}
                                        />
                                        {errors.father_full_name && (
                                          <div className="invalid-feedback">{errors.father_full_name}</div>
                                        )}
                                      </div>

                                      {/* Aadhaar Number & Verify */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Father's Aadhaar Number <span className="text-danger">*</span></label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className={`form-control ${errors.father_aadhar_no ? 'is-invalid' : ''}`}
                                            placeholder="Enter Aadhaar Number"
                                            maxLength={12}
                                            value={formData.father_aadhar_no}
                                            onChange={(e) => {
                                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                              handleChange('father_aadhar_no', onlyNumbers);
                                            }}
                                          // disabled={aadharVerification.father.verified}
                                          />
                                          {servicePermissions.fatherAadhar && !aadharVerification.father.verified && (
                                            <button
                                              className="btn btn-primary"
                                              onClick={() => handleContactSendOTP('father')}
                                              disabled={formData.father_aadhar_no?.length !== 12 || aadharVerification.father.loading}
                                            >
                                              {aadharVerification.father.loading ? 'Sending...' : 'Verify'}
                                            </button>
                                          )}
                                        </div>
                                        {errors.father_aadhar_no && (
                                          <div className="invalid-feedback d-block">{errors.father_aadhar_no}</div>
                                        )}
                                      </div>

                                      {/* OTP Verification */}
                                      {servicePermissions.fatherAadhar && aadharVerification.father.otpSent && (
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Enter OTP</label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="6-digit OTP"
                                              maxLength={6}
                                              value={aadharOTP}
                                              onChange={(e) => setAadharOTP(e.target.value)}
                                            />
                                            <button
                                              className="btn btn-primary"
                                              onClick={handleVerifyContactOTP}
                                              disabled={aadharVerification.father.verifying}
                                            >
                                              {aadharVerification.father.verifying ? 'Verifying...' : 'Submit'}
                                            </button>
                                          </div>
                                        </div>
                                      )}

                                      {/* Aadhaar Verification Status */}
                                      {/* {aadharVerification.father.verified && (
                                        <div className="col-md-12 mb-3">
                                          <div className="alert alert-success mb-0">
                                            <i className="ti ti-check me-2"></i>
                                            Aadhaar successfully verified
                                          </div>
                                        </div>
                                      )} */}


                                      {servicePermissions.fatherAadhar && (
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Name on Aadhaar</label>
                                          <input
                                            type="text"
                                            className="form-control bg-light"
                                            placeholder="Will auto-fill after verification"
                                            value={formData.father_aadhar_name || ''}
                                            onChange={(e) => handleChange('father_aadhar_name', e.target.value)}
                                          />
                                        </div>
                                      )}

                                      {/* Name Mismatch Warning */}
                                      {servicePermissions.fatherAadhar &&
                                        aadharVerification.father.verified &&
                                        formData.father_full_name &&
                                        formData.father_aadhar_name &&
                                        formData.father_full_name !== formData.father_aadhar_name && (
                                          <div className="col-12 mb-3">
                                            <div className="alert alert-warning">
                                              <div className="d-flex align-items-center">
                                                <i className="ti ti-alert-triangle me-2"></i>
                                                <div>
                                                  <strong>Name Mismatch Detected</strong>
                                                  <p className="mb-0">
                                                    Aadhaar name: {formData.father_aadhar_name}<br />
                                                    Entered name: {formData.father_full_name}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="form-check mt-2">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id="fatherNameMismatchConsent"
                                                  checked={IsSelectedFatherAadhar}
                                                  onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    if (isChecked) {
                                                      const confirmed = window.confirm(
                                                        'Are you sure you want to proceed with the name mismatch?'
                                                      );
                                                      if (confirmed) {
                                                        setIsSelectedFatherAadhar(true);
                                                        postConsentData(FatherAadharMismatchItem?.key, () => setIsConsentSubmitted4(true));
                                                      } else {
                                                        e.preventDefault();
                                                      }
                                                    } else {
                                                      setIsSelectedFatherAadhar(false);
                                                    }
                                                  }}
                                                />
                                                <label className="form-check-label" htmlFor="fatherNameMismatchConsent">
                                                  I confirm the name mismatch and have applied for correction
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                      {servicePermissions.fatherAadhar && (
                                        <div className="col-md-6 mb-3">
                                          <label className="form-label">Date of Birth</label>
                                          <DatePicker
                                            className="form-control"
                                            placeholder="Select Date"
                                            value={formData.father_date_of_birth ? moment(formData.father_date_of_birth) : null}
                                            onFocus={() => handleChange("father_date_of_birth", "")}
                                            onChange={(date) => handleChange('father_date_of_birth', date ? date.format('YYYY-MM-DD') : '')}
                                          />
                                        </div>
                                      )}
                                      {/* Mobile Number */}

                                    </div>
                                  </div>
                                </div>
                              </div> {/* col-lg-6 - personal */}

                              {/* Professional Details Section */}
                              <div className="col-lg-6 col-md-12">
                                <div className="card border-light shadow-sm mb-3">
                                  <div className="card-header bg-light py-2">
                                    <h6 className="mb-0">Professional Details</h6>
                                  </div>
                                  <div className="card-body">
                                    <div className="row">
                                      {/* Qualification */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Qualification </label>
                                        <input
                                          type="text"
                                          className={`form-control ${errors.father_qualification ? 'is-invalid' : ''}`}
                                          placeholder="Father's highest qualification"
                                          value={formData.father_qualification}
                                          onChange={(e) => handleChange('father_qualification', e.target.value)}
                                        />
                                        {errors.father_qualification && (
                                          <div className="invalid-feedback">{errors.father_qualification}</div>
                                        )}
                                      </div>
                                      {/* Occupation */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Occupation</label>
                                        <Select
                                          classNamePrefix="react-select"
                                          options={FatherOccupationData2}
                                          value={FatherOccupationData2?.find(opt => opt.value === formData.father_occupation)}
                                          onChange={(selected) => handleChange('father_occupation', selected?.value)}
                                          placeholder="Select Occupation"
                                        />
                                      </div>
                                      {/* Company Name */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Company Name</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Father's company/organization name"
                                          value={formData.father_company_name}
                                          onChange={(e) => handleChange('father_company_name', e.target.value)}
                                        />
                                      </div>
                                      {/* Company Address */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Company Address</label>
                                        <textarea
                                          className="form-control"
                                          rows={3}
                                          placeholder="Complete company address"
                                          value={formData.father_company_address}
                                          onChange={(e) => handleChange('father_company_address', e.target.value)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> {/* col-lg-6 - professional */}

                              {servicePermissions.fatherAadhar && (
                                <div className="col-12">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Father's Aadhaar Address Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Aadhaar Address <span className="text-danger">*</span></label>
                                          <textarea
                                            className={`form-control ${errors.father_aadhar_address ? 'is-invalid' : ''}`}
                                            rows={3}
                                            placeholder="Address as per Aadhaar"
                                            value={formData.father_aadhar_address}
                                            onChange={(e) => {
                                              if (!useStudentAddressForFather && !useMotherAddressForFather) {
                                                handleChange('father_aadhar_address', e.target.value);
                                              }
                                            }}
                                            readOnly={useStudentAddressForFather || useMotherAddressForFather}
                                          />
                                          {errors.father_aadhar_address && (
                                            <div className="invalid-feedback">{errors.father_aadhar_address}</div>
                                          )}
                                        </div>
                                        <div className="col-md-12">
                                          <div className="form-check mb-2">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useStudentAddressForFather"
                                              checked={useStudentAddressForFather}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseStudentAddressForFather(isChecked);
                                                setUseMotherAddressForFather(false);
                                                if (isChecked) {
                                                  handleChange('father_aadhar_address', formData.student_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useStudentAddressForFather">
                                              Use Student's Address
                                            </label>
                                          </div>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useMotherAddressForFather"
                                              checked={useMotherAddressForFather}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseMotherAddressForFather(isChecked);
                                                setUseStudentAddressForFather(false);
                                                if (isChecked) {
                                                  handleChange('father_aadhar_address', formData.mother_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useMotherAddressForFather">
                                              Use Mother's Address
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* Aadhaar Upload Section */}

                              <div className="col-12 mt-3">
                                <div className="card border-light shadow-sm">
                                  <div className="card-header bg-light py-2">
                                    <h6 className="mb-0">Upload Father's Aadhaar Card </h6>
                                  </div>
                                  <div className="card-body">
                                    <div className="d-flex align-items-center row-gap-3">
                                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                        {getDocumentDisplay('father_aadhar_file', FatherAadharphoto, existingDocumentUrls.father_aadhar_file) ? (
                                          <img
                                            src={getDocumentDisplay('father_aadhar_file', FatherAadharphoto, existingDocumentUrls.father_aadhar_file)}
                                            alt="Father Aadhar"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                          />
                                        ) : (
                                          <i className="ti ti-photo-plus fs-16" />
                                        )}
                                      </div>
                                      <div className="profile-upload">
                                        <div className="profile-uploader d-flex align-items-center">
                                          <div className="drag-upload-btn mb-1">
                                            Upload Aadhaar Card
                                            <input
                                              type="file"
                                              className="form-control image-sign"
                                              accept="image/*,.pdf"
                                              onChange={(e) => {
                                                const file = e.target.files?.[0] || null;
                                                handleDocumentFileUpload('father_aadhar_file', file);
                                              }}
                                            />
                                          </div>
                                          {renderViewButton('father_aadhar_file')}
                                          {FatherAadharphoto && (
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-outline-danger ms-2"
                                              onClick={() => clearDocumentFile('father_aadhar_file')}
                                            >
                                              <i className="ti ti-x me-1"></i>Clear
                                            </button>
                                          )}
                                        </div>
                                        <p className="fs-12">
                                          Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                          {existingDocumentUrls.father_aadhar_file && !FatherAadharphoto && (
                                            <span className="text-success ms-2">
                                              <i className="ti ti-check me-1"></i>
                                              Document uploaded
                                            </span>
                                          )}
                                        </p>
                                        
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        {/* Add other father fields as in original code */}
                        {/* Mother's Information */}
                        <div className="card border-light mb-4">
                          <div className="card-header bg-light">
                            <div className="d-flex align-items-center">
                              <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                                <i className="ti ti-user-circle fs-16" />
                              </span>
                              <h4 className="text-dark">Mother's Information</h4>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              {/* Mother's Photo Upload */}
                              {/* Mother's Photo Upload */}
                              <div className="col-md-12 mb-4">
                                <div className="d-flex align-items-center flex-wrap row-gap-3">
                                  <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    {getDocumentDisplay('mother_photo_upload', Motherphoto, existingDocumentUrls.mother_photo_upload) ? (
                                      <img
                                        src={getDocumentDisplay('mother_photo_upload', Motherphoto, existingDocumentUrls.mother_photo_upload)}
                                        alt="Mother"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                      />
                                    ) : (
                                      <i className="ti ti-photo-plus fs-16" />
                                    )}
                                  </div>
                                  <div className="profile-upload">
                                    <div className="profile-uploader d-flex align-items-center">
                                      <div className="drag-upload-btn mb-3">
                                        Upload Mother's Photo
                                        <input
                                          type="file"
                                          className="form-control image-sign"
                                          accept="image/*"
                                          onChange={(e) => {
                                            const file = e.target.files?.[0] || null;
                                            setMotherphoto(file);
                                            handleChange('mother_photo_upload', file);
                                          }}
                                        />
                                      </div>
                                      {renderViewButton('mother_photo_upload')}
                                      {/* Clear button when new file is selected */}
                                      {Motherphoto && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger ms-2"
                                          onClick={() => {
                                            setMotherphoto(null);
                                            handleChange('mother_photo_upload', null);
                                          }}
                                        >
                                          <i className="ti ti-x me-1"></i>Clear
                                        </button>
                                      )}
                                    </div>
                                    <p className="fs-12">
                                      Upload image size 4MB, Format JPG, PNG, SVG
                                      {existingDocumentUrls.mother_photo_upload && !Motherphoto && (
                                        <span className="text-success ms-2">
                                          <i className="ti ti-check me-1"></i>
                                          Photo already uploaded
                                        </span>
                                      )}
                                    </p>

                                   

                                    {errors.mother_photo && (
                                      <div className="text-danger small mt-1">{errors.mother_photo}</div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Personal Details Section */}
                              <div className="col-lg-6 col-md-12">
                                <div className="card border-light shadow-sm mb-3">
                                  <div className="card-header bg-light py-2">
                                    <h6 className="mb-0">Personal Details</h6>
                                  </div>
                                  <div className="card-body">
                                    <div className="row">
                                      {/* Mother's Full Name */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Mother's Full Name <span className="text-danger">*</span></label>
                                        <input
                                          type="text"
                                          className={`form-control ${errors.mother_full_name ? 'is-invalid' : ''}`}
                                          placeholder="Enter mother's full name"
                                          value={formData.mother_full_name}
                                          onChange={(e) => handleChange('mother_full_name', e.target.value)}
                                        />
                                        {errors.mother_full_name && (
                                          <div className="invalid-feedback">{errors.mother_full_name}</div>
                                        )}
                                      </div>

                                      {/* Aadhaar Number & Verify */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Mother's Aadhaar Number <span className="text-danger">*</span></label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className={`form-control ${errors.mother_aadhar_no ? 'is-invalid' : ''}`}
                                            placeholder="Enter Aadhaar Number"
                                            maxLength={12}
                                            value={formData.mother_aadhar_no}
                                            onChange={(e) => {
                                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                              handleChange('mother_aadhar_no', onlyNumbers);
                                            }}
                                          // disabled={aadharVerification.mother.verified}
                                          />
                                          {servicePermissions.motherAadhar && !aadharVerification.mother.verified && (
                                            <button
                                              className="btn btn-primary"
                                              onClick={() => handleContactSendOTP('mother')}
                                              disabled={formData.mother_aadhar_no?.length !== 12 || aadharVerification.mother.loading}
                                            >
                                              {aadharVerification.mother.loading ? 'Sending...' : 'Verify'}
                                            </button>
                                          )}
                                        </div>
                                        {errors.mother_aadhar_no && (
                                          <div className="invalid-feedback d-block">{errors.mother_aadhar_no}</div>
                                        )}
                                      </div>

                                      {/* OTP Verification */}
                                      {servicePermissions.motherAadhar && aadharVerification.mother.otpSent && (
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Enter OTP</label>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="6-digit OTP"
                                              maxLength={6}
                                              value={aadharOTP}
                                              onChange={(e) => setAadharOTP(e.target.value)}
                                            />
                                            <button
                                              className="btn btn-primary"
                                              onClick={handleVerifyContactOTP}
                                              disabled={aadharVerification.mother.verifying}
                                            >
                                              {aadharVerification.mother.verifying ? 'Verifying...' : 'Submit'}
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                      {/* Aadhaar Verification Status */}
                                      {/* {aadharVerification.mother.verified && (
                                        <div className="col-md-12 mb-3">
                                          <div className="alert alert-success mb-0">
                                            <i className="ti ti-check me-2"></i>
                                            Aadhaar successfully verified
                                          </div>
                                        </div>
                                      )} */}

                                      {/* Name on Aadhaar */}
                                      {servicePermissions.motherAadhar && (
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Name on Aadhaar</label>
                                          <input
                                            type="text"
                                            className="form-control bg-light"
                                            placeholder="Will auto-fill after verification"
                                            value={formData.mother_aadhar_name || ''}
                                            onChange={(e) => handleChange('mother_aadhar_name', e.target.value)}
                                          />
                                        </div>
                                      )}

                                      {/* Name Mismatch Warning */}
                                      {servicePermissions.motherAadhar &&
                                        aadharVerification.mother.verified &&
                                        formData.mother_full_name &&
                                        formData.mother_aadhar_name &&
                                        formData.mother_full_name !== formData.mother_aadhar_name && (
                                          <div className="col-12 mb-3">
                                            <div className="alert alert-warning">
                                              <div className="d-flex align-items-center">
                                                <i className="ti ti-alert-triangle me-2"></i>
                                                <div>
                                                  <strong>Name Mismatch Detected</strong>
                                                  <p className="mb-0">
                                                    Aadhaar name: {formData.mother_aadhar_name}<br />
                                                    Entered name: {formData.mother_full_name}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="form-check mt-2">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id="motherNameMismatchConsent"
                                                  checked={MotherAadharData}
                                                  onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    if (isChecked) {
                                                      const confirmed = window.confirm(
                                                        'Are you sure you want to proceed with the name mismatch?'
                                                      );
                                                      if (confirmed) {
                                                        setMotherAadharData(true);
                                                        postConsentData(MotherAadharMismatchItem?.key, () => setIsConsentSubmitted5(true));
                                                      } else {
                                                        e.preventDefault();
                                                      }
                                                    } else {
                                                      setMotherAadharData(false);
                                                    }
                                                  }}
                                                />
                                                <label className="form-check-label" htmlFor="motherNameMismatchConsent">
                                                  I confirm the name mismatch and have applied for correction
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                      {servicePermissions.motherAadhar && (
                                        <div className="col-md-6 mb-3">
                                          <label className="form-label">Date of Birth</label>
                                          <DatePicker
                                            className="form-control"
                                            placeholder="Select Date"
                                            value={formData.mother_date_of_birth ? moment(formData.mother_date_of_birth) : null}
                                            onFocus={() => handleChange("mother_date_of_birth", "")}
                                            onChange={(date) => handleChange('mother_date_of_birth', date ? date.format('YYYY-MM-DD') : '')}
                                          />
                                        </div>
                                      )}
                                      {/* Mobile Number */}

                                    </div>
                                  </div>
                                </div>
                              </div> {/* col-lg-6 - personal */}

                              {/* Professional Details Section */}
                              <div className="col-lg-6 col-md-12">
                                <div className="card border-light shadow-sm mb-3">
                                  <div className="card-header bg-light py-2">
                                    <h6 className="mb-0">Professional Details</h6>
                                  </div>
                                  <div className="card-body">
                                    <div className="row">
                                      {/* Qualification */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Qualification </label>
                                        <input
                                          type="text"
                                          className={`form-control ${errors.mother_qualification ? 'is-invalid' : ''}`}
                                          placeholder="Mother's highest qualification"
                                          value={formData.mother_qualification}
                                          onChange={(e) => handleChange('mother_qualification', e.target.value)}
                                        />
                                        {errors.mother_qualification && (
                                          <div className="invalid-feedback">{errors.mother_qualification}</div>
                                        )}
                                      </div>
                                      {/* Occupation */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Occupation</label>
                                        <Select
                                          classNamePrefix="react-select"
                                          options={MotherOccupationData2}
                                          value={MotherOccupationData2?.find(opt => opt.value === formData.mother_occupation)}
                                          onChange={(selected) => handleChange('mother_occupation', selected?.value)}
                                          placeholder="Select Occupation"
                                        />
                                      </div>
                                      {/* Company Name */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Company Name</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Mother's company/organization name"
                                          value={formData.mother_company_name}
                                          onChange={(e) => handleChange('mother_company_name', e.target.value)}
                                        />
                                      </div>
                                      {/* Company Address */}
                                      <div className="col-md-12 mb-3">
                                        <label className="form-label">Company Address</label>
                                        <textarea
                                          className="form-control"
                                          rows={3}
                                          placeholder="Complete company address"
                                          value={formData.mother_company_address}
                                          onChange={(e) => handleChange('mother_company_address', e.target.value)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> {/* col-lg-6 - professional */}

                              {servicePermissions.motherAadhar && (
                                <div className="col-12">
                                  <div className="card border-light shadow-sm">
                                    <div className="card-header bg-light py-2">
                                      <h6 className="mb-0">Mother's Aadhaar Address Details</h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-md-12 mb-3">
                                          <label className="form-label">Aadhaar Address <span className="text-danger">*</span></label>
                                          <textarea
                                            className={`form-control ${errors.mother_aadhar_address ? 'is-invalid' : ''}`}
                                            rows={3}
                                            placeholder="Address as per Aadhaar"
                                            value={formData.mother_aadhar_address}
                                            onChange={(e) => {
                                              if (!useStudentAddressForMother && !useFatherAddressForMother) {
                                                handleChange('mother_aadhar_address', e.target.value);
                                              }
                                            }}
                                            readOnly={useStudentAddressForMother || useFatherAddressForMother}
                                          />
                                          {errors.mother_aadhar_address && (
                                            <div className="invalid-feedback">{errors.mother_aadhar_address}</div>
                                          )}
                                        </div>
                                        <div className="col-md-12">
                                          <div className="form-check mb-2">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useStudentAddressForMother"
                                              checked={useStudentAddressForMother}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseStudentAddressForMother(isChecked);
                                                setUseFatherAddressForMother(false);
                                                if (isChecked) {
                                                  handleChange('mother_aadhar_address', formData.student_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useStudentAddressForMother">
                                              Use Student's Address
                                            </label>
                                          </div>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="useFatherAddressForMother"
                                              checked={useFatherAddressForMother}
                                              onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setUseFatherAddressForMother(isChecked);
                                                setUseStudentAddressForMother(false);
                                                if (isChecked) {
                                                  handleChange('mother_aadhar_address', formData.father_aadhar_address || '');
                                                }
                                              }}
                                            />
                                            <label className="form-check-label" htmlFor="useFatherAddressForMother">
                                              Use Father's Address
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* Aadhaar Upload Section */}

                              <div className="col-12 mt-3">
                                <div className="card border-light shadow-sm">
                                  <div className="card-header bg-light py-2">
                                    <h6 className="mb-0">Upload Mother's Aadhaar Card </h6>
                                  </div>
                                  <div className="card-body">
                                    <div className="d-flex align-items-center row-gap-3">
                                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                        {getDocumentDisplay('mother_aadhar_file', MotherAadharphoto, existingDocumentUrls.mother_aadhar_file) ? (
                                          <img
                                            src={getDocumentDisplay('mother_aadhar_file', MotherAadharphoto, existingDocumentUrls.mother_aadhar_file)}
                                            alt="Mother Aadhar"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                          />
                                        ) : (
                                          <i className="ti ti-photo-plus fs-16" />
                                        )}
                                      </div>
                                      <div className="profile-upload">
                                        <div className="profile-uploader d-flex align-items-center">
                                          <div className="drag-upload-btn mb-1">
                                            Upload Aadhaar Card
                                            <input
                                              type="file"
                                              className="form-control image-sign"
                                              accept="image/*,.pdf"
                                              onChange={(e) => {
                                                const file = e.target.files?.[0] || null;
                                                handleDocumentFileUpload('mother_aadhar_file', file);
                                              }}
                                            />
                                          </div>
                                          {renderViewButton('mother_aadhar_file')}
                                          {MotherAadharphoto && (
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-outline-danger ms-2"
                                              onClick={() => clearDocumentFile('mother_aadhar_file')}
                                            >
                                              <i className="ti ti-x me-1"></i>Clear
                                            </button>
                                          )}
                                        </div>
                                        <p className="fs-12">
                                          Upload image/PDF size 4MB, Format JPG, PNG, SVG, PDF
                                          {existingDocumentUrls.mother_aadhar_file && !MotherAadharphoto && (
                                            <span className="text-success ms-2">
                                              <i className="ti ti-check me-1"></i>
                                              Document uploaded
                                            </span>
                                          )}
                                        </p>
                                        
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                        {/* Add other mother fields as in original code */}
                      </>
                    )}
                  </div>
                </div>
              </div>


              {/* Contact Details Section - Redesigned */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-phone fs-16" />
                    </span>
                    <h4 className="text-dark">Contact Details</h4>
                  </div>
                </div>
                <div className="contact-consent-message">
                  {formData.consentMessage && (
                    <div className="alert alert-info">
                      <strong>Consent:</strong> {formData.consentMessage}
                    </div>
                  )}
                </div>

                <div className="card-body">
                  <div className="row">
                    {/* Contact Selection Section */}
                    <div className="col-md-12 mb-4">
                      <div className="border-bottom pb-3">
                        <h5 className="text-primary mb-3">Select Primary Contacts</h5>

                        <div className="row g-3">
                          {formData.is_single_parent ? (
                            // Single Parent Cases
                            formData.single_parent === "father" ? (
                              // Father as Single Parent
                              <div className="col-md-6">
                                <div className="card border-light shadow-sm">
                                  <div className="card-body">
                                    <h6 className="card-title text-muted mb-3">Primary Contact Number (Single Parent - Father)</h6>

                                    {/* Default Primary Contact */}
                                    <div className="form-check mb-2">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="primaryContact"
                                        id="defaultPrimary"
                                        checked={ContactNumberData === "Primary"}
                                        onChange={() => {
                                          setContactNumberData("Primary");
                                        }}
                                      />
                                      <label className="form-check-label" htmlFor="defaultPrimary">
                                        <strong>Default Primary Contact</strong><br />
                                        <span className="text-muted">{formData.contact_phone || 'Not available'}</span>
                                      </label>
                                    </div>

                                    {/* Change Primary Contact Options */}
                                    <div className="mt-3 pt-3 border-top">
                                      <small className="text-muted mb-2 d-block">Change Primary Contact To:</small>

                                      {/* Father's Contact as Primary */}
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="primaryContact"
                                          id="fatherPrimary"
                                          checked={ContactNumberData === "Father"}
                                          onChange={() => {
                                            setContactNumberData("Father");
                                          }}
                                        />
                                        <label className="form-check-label" htmlFor="fatherPrimary">
                                          Set Father as Primary Contact
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : formData.single_parent === "mother" ? (
                              // Mother as Single Parent
                              <div className="col-md-6">
                                <div className="card border-light shadow-sm">
                                  <div className="card-body">
                                    <h6 className="card-title text-muted mb-3">Primary Contact Number (Single Parent - Mother)</h6>

                                    {/* Default Primary Contact */}
                                    <div className="form-check mb-2">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="primaryContact"
                                        id="defaultPrimary"
                                        checked={ContactNumberData === "Primary"}
                                        onChange={() => {
                                          setContactNumberData("Primary");
                                        }}
                                      />
                                      <label className="form-check-label" htmlFor="defaultPrimary">
                                        <strong>Default Primary Contact</strong><br />
                                        <span className="text-muted">{formData.contact_phone || 'Not available'}</span>
                                      </label>
                                    </div>

                                    {/* Change Primary Contact Options */}
                                    <div className="mt-3 pt-3 border-top">
                                      <small className="text-muted mb-2 d-block">Change Primary Contact To:</small>

                                      {/* Mother's Contact as Primary */}
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="primaryContact"
                                          id="motherPrimary"
                                          checked={ContactNumberData === "Mother"}
                                          onChange={() => {
                                            setContactNumberData("Mother");
                                          }}
                                        />
                                        <label className="form-check-label" htmlFor="motherPrimary">
                                          Set Mother as Primary Contact
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              // Guardian as Single Parent
                              <div className="col-md-6">
                                <div className="card border-light shadow-sm">
                                  <div className="card-body">
                                    <h6 className="card-title text-muted mb-3">Primary Contact Number (Single Parent - Guardian)</h6>

                                    {/* Default Primary Contact */}
                                    <div className="form-check mb-2">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="primaryContact"
                                        id="defaultPrimary"
                                        checked={ContactNumberData === "Primary"}
                                        onChange={() => {
                                          setContactNumberData("Primary");
                                        }}
                                      />
                                      <label className="form-check-label" htmlFor="defaultPrimary">
                                        <strong>Default Primary Contact</strong><br />
                                        <span className="text-muted">{formData.contact_phone || 'Not available'}</span>
                                      </label>
                                    </div>

                                    {/* Change Primary Contact Options */}
                                    <div className="mt-3 pt-3 border-top">
                                      <small className="text-muted mb-2 d-block">Change Primary Contact To:</small>

                                      {/* Guardian's Contact as Primary */}
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="primaryContact"
                                          id="guardianPrimary"
                                          checked={ContactNumberData === "Guardian"}
                                          onChange={() => {
                                            setContactNumberData("Guardian");
                                          }}
                                        />
                                        <label className="form-check-label" htmlFor="guardianPrimary">
                                          Set Guardian as Primary Contact
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          ) : (
                            // Normal Case (Both Parents)
                            <div className="col-md-6">
                              <div className="card border-light shadow-sm">
                                <div className="card-body">
                                  <h6 className="card-title text-muted mb-3">Primary Contact Number</h6>

                                  {/* Default Primary Contact - Auto selected */}
                                  <div className="form-check mb-2">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="primaryContact"
                                      id="defaultPrimary"
                                      checked={ContactNumberData === "Primary"}
                                      onChange={() => {
                                        setContactNumberData("Primary");
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor="defaultPrimary">
                                      <strong>Default Primary Contact</strong><br />
                                      <span className="text-muted">{formData.contact_phone || 'Not available'}</span>
                                    </label>
                                  </div>

                                  {/* Change Primary Contact Options */}
                                  <div className="mt-3 pt-3 border-top">
                                    <small className="text-muted mb-2 d-block">Change Primary Contact To:</small>

                                    {/* Father's Contact as Primary */}
                                    <div className="form-check mb-2">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="primaryContact"
                                        id="fatherPrimary"
                                        checked={ContactNumberData === "Father"}
                                        onChange={() => {
                                          setContactNumberData("Father");
                                        }}
                                      />
                                      <label className="form-check-label" htmlFor="fatherPrimary">
                                        Set Father as Primary Contact
                                      </label>
                                    </div>

                                    {/* Mother's Contact as Primary */}
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="primaryContact"
                                        id="motherPrimary"
                                        checked={ContactNumberData === "Mother"}
                                        onChange={() => {
                                          setContactNumberData("Mother");
                                        }}
                                      />
                                      <label className="form-check-label" htmlFor="motherPrimary">
                                        Set Mother as Primary Contact
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Current Selection Display */}
                          <div className="col-md-6">
                            <div className="card border-primary">
                              <div className="card-header bg-primary-light">
                                <h6 className="mb-0 text-primary">Current Selection</h6>
                              </div>
                              <div className="card-body">
                                <p className="mb-2">
                                  <strong>Primary Contact Type:</strong>
                                  <span className="ms-2 badge bg-primary">
                                    {ContactNumberData === "Primary" ? "Default Primary" :
                                      ContactNumberData === "Father" ? "Father" :
                                        ContactNumberData === "Mother" ? "Mother" :
                                          ContactNumberData === "Guardian" ? "Guardian" : "Not Selected"}
                                  </span>
                                </p>

                                <p className="mb-1">
                                  <i className="ti ti-phone-call text-muted me-2"></i>
                                  <strong>Primary Contact Number:</strong>
                                  <span className="ms-2">
                                    {ContactNumberData === "Primary" ? RegistrationData?.data?.formData.contact_phone :
                                      ContactNumberData === "Father" ? formData.father_mobile_no :
                                        ContactNumberData === "Mother" ? formData.mother_mobile_no :
                                          ContactNumberData === "Guardian" ? formData.guardian_mobile_no : "Not selected"}
                                  </span>
                                </p>

                                {!formData.is_single_parent && (
                                  <>
                                    <p className="mb-1 mt-2">
                                      <i className="ti ti-user-circle text-muted me-2"></i>
                                      <strong>Father's Number:</strong>
                                      <span className="ms-2">{formData.father_mobile_no || "Not set"}</span>
                                      <span
                                        className={`ms-2 badge ${formData.father_mobile_no ? (verifiedContacts.father_mobile_no ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                      >
                                        {formData.father_mobile_no
                                          ? verifiedContacts.father_mobile_no
                                            ? 'Verified'
                                            : 'Not Verified'
                                          : 'Not Provided'}
                                      </span>
                                    </p>
                                    <p className="mb-0">
                                      <i className="ti ti-user text-muted me-2"></i>
                                      <strong>Mother's Number:</strong>
                                      <span className="ms-2">{formData.mother_mobile_no || "Not set"}</span>
                                      <span
                                        className={`ms-2 badge ${formData.mother_mobile_no ? (verifiedContacts.mother_mobile_no ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                      >
                                        {formData.mother_mobile_no
                                          ? verifiedContacts.mother_mobile_no
                                            ? 'Verified'
                                            : 'Not Verified'
                                          : 'Not Provided'}
                                      </span>
                                    </p>
                                    {formData.guardian_mobile_no && (
                                      <p className="mb-0 mt-1">
                                        <i className="ti ti-shield-check text-muted me-2"></i>
                                        <strong>Guardian's Number:</strong>
                                        <span className="ms-2">{formData.guardian_mobile_no}</span>
                                        <span
                                          className={`ms-2 badge ${verifiedContacts.guardian_mobile_no ? 'bg-success' : 'bg-danger'}`}
                                        >
                                          {verifiedContacts.guardian_mobile_no ? 'Verified' : 'Not Verified'}
                                        </span>
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Contact Display Section - NO CHANGES HERE */}
                    <div className="col-md-12">
                      <h5 className="text-primary mb-3">Current Contact Information</h5>
                      <div
                        className={`${primaryContactSummary.number ? 'alert alert-info' : 'alert alert-warning'} d-flex align-items-start gap-2 py-2 px-3`}
                      >
                        <i className="ti ti-info-circle fs-5 mt-1"></i>
                        <div className="flex-grow-1">
                          {primaryContactSummary.number ? (
                            <>
                              <div className="fw-semibold">
                                {primaryContactSummary.label} is selected as the primary contact.
                              </div>
                              <div className="d-flex align-items-center flex-wrap gap-2 small mt-1">
                                <span>
                                  Number: <span className="fw-semibold">{primaryContactSummary.number}</span>
                                </span>
                                <span
                                  className={`badge ${primaryContactSummary.verified ? 'bg-success' : 'bg-warning'}`}
                                >
                                  {primaryContactSummary.verified ? 'Verified' : 'Verification Pending'}
                                </span>
                                <span className="text-muted">
                                  Update or verify other contacts below as needed.
                                </span>
                              </div>
                            </>
                          ) : (
                            <div className="small">
                              Choose a primary contact number so we know whom to reach first.
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row g-3">
                        {formData.is_single_parent ? (
                          // Single Parent Contact Display
                          formData.single_parent === "father" ? (
                            // Father as Single Parent
                            <div className="col-md-4">
                              <div className="card border-light shadow-sm h-100">
                                <div className="card-body">
                                  <div className="d-flex align-items-center mb-2">
                                    <span className="avatar avatar-sm bg-primary-light text-primary rounded-circle me-2">
                                      <i className="ti ti-user" />
                                    </span>
                                    <h6 className="mb-0">Father's Number (Single Parent)</h6>
                                    {!RegistrationData?.data?.is_primary_contact_verified && (
                                      verifiedContacts.father_mobile_no ? (
                                        <span className="badge bg-success ms-2">Verified</span>
                                      ) : (
                                        <span className="badge bg-danger ms-2">Not Verified</span>
                                      )
                                    )}
                                  </div>
                                  <div className="input-group">
                                    <span className="input-group-text">
                                      <i className="ti ti-phone" />
                                    </span>
                                    <input
                                      type="tel"
                                      className="form-control bg-light"
                                      value={formData.father_mobile_no || "Not selected"}
                                      readOnly
                                    />
                                    {!RegistrationData?.data?.is_primary_contact_verified && (
                                      !verifiedContacts.father_mobile_no ? (
                                        <>
                                          {!otpSent || otpTargetField !== "father_mobile_no" ? (
                                            <button
                                              type="button"
                                              className="btn btn-outline-primary"
                                              onClick={() => sendContactOtp("father_mobile_no")}
                                              disabled={isVerifyingContact || !formData.father_mobile_no}
                                            >
                                              {isVerifyingContact ? "Sending..." : "Verify"}
                                            </button>
                                          ) : (
                                            <div className="d-flex gap-2">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter OTP"
                                                value={enteredOtp}
                                                onChange={(e) => setEnteredOtp(e.target.value.replace(/\D/g, ""))}
                                                maxLength={6}
                                              />
                                              <div className="d-flex gap-2">
                                                <button
                                                  type="button"
                                                  className="btn btn-success"
                                                  onClick={verifyContactOtp}
                                                  disabled={isSubmittingOtp}
                                                >
                                                  {isSubmittingOtp ? "Verifying..." : "Submit"}
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-secondary"
                                                  onClick={() => sendContactOtp("father_mobile_no")}
                                                  disabled={isVerifyingContact}
                                                >
                                                  {isVerifyingContact ? "Resending..." : "Resend"}
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <span className="badge bg-success ms-2">Verified</span>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : formData.single_parent === "mother" ? (
                            // Mother as Single Parent
                            <div className="col-md-4">
                              <div className="card border-light shadow-sm h-100">
                                <div className="card-body">
                                  <div className="d-flex align-items-center mb-2">
                                    <span className="avatar avatar-sm bg-primary-light text-primary rounded-circle me-2">
                                      <i className="ti ti-user" />
                                    </span>
                                    <h6 className="mb-0">Mother's Number (Single Parent)</h6>
                                    {!RegistrationData?.data?.is_primary_contact_verified && (
                                      verifiedContacts.mother_contact_no ? (
                                        <span className="badge bg-success ms-2">Verified</span>
                                      ) : (
                                        <span className="badge bg-danger ms-2">Not Verified</span>
                                      )
                                    )}
                                  </div>
                                  <div className="input-group">
                                    <span className="input-group-text">
                                      <i className="ti ti-phone" />
                                    </span>
                                    <input
                                      type="tel"
                                      className="form-control bg-light"
                                      value={formData.mother_contact_no || "Not selected"}
                                      readOnly
                                    />
                                    {!RegistrationData?.data?.is_primary_contact_verified && (
                                      !verifiedContacts.mother_contact_no ? (
                                        <>
                                          {!otpSent || otpTargetField !== "mother_contact_no" ? (
                                            <button
                                              type="button"
                                              className="btn btn-outline-primary"
                                              onClick={() => sendContactOtp("mother_contact_no")}
                                              disabled={isVerifyingContact || !formData.mother_contact_no}
                                            >
                                              {isVerifyingContact ? "Sending..." : "Verify"}
                                            </button>
                                          ) : (
                                            <div className="d-flex gap-2">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter OTP"
                                                value={enteredOtp}
                                                onChange={(e) => setEnteredOtp(e.target.value.replace(/\D/g, ""))}
                                                maxLength={6}
                                              />
                                              <div className="d-flex gap-2">
                                                <button
                                                  type="button"
                                                  className="btn btn-success"
                                                  onClick={verifyContactOtp}
                                                  disabled={isSubmittingOtp}
                                                >
                                                  {isSubmittingOtp ? "Verifying..." : "Submit"}
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-secondary"
                                                  onClick={() => sendContactOtp("mother_contact_no")}
                                                  disabled={isVerifyingContact}
                                                >
                                                  {isVerifyingContact ? "Resending..." : "Resend"}
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <span className="badge bg-success ms-2">Verified</span>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (

                            <div className="col-md-12 mb-3">
                              <label className="form-label">Guardian's Mobile Number <span className="text-danger">*</span></label>

                              {!isEditingContact.guardian_mobile_no ? (
                                <>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className={`form-control ${errors.guardian_mobile_no ? 'is-invalid' : ''}`}
                                      placeholder="Guardian's Mobile Number"
                                      value={formData.guardian_mobile_no}
                                      readOnly
                                      style={{
                                        backgroundColor: "#f8f9fa",
                                        color: "#6c757d",
                                        cursor: "not-allowed"
                                      }}
                                    />
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => handleEditContact('guardian_mobile_no')}
                                    >
                                      <i className="ti ti-edit"></i> Edit
                                    </button>
                                    {verifiedContacts.guardian_mobile_no && (
                                      <span className="input-group-text text-success">
                                        <i className="ti ti-check"></i> Verified
                                      </span>
                                    )}
                                  </div>
                                  <div className="mt-1 small">
                                    <span
                                      className={`badge ${formData.guardian_mobile_no ? (verifiedContacts.guardian_mobile_no ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                    >
                                      {formData.guardian_mobile_no
                                        ? verifiedContacts.guardian_mobile_no
                                          ? 'Verified'
                                          : 'Not Verified'
                                        : 'Not Provided'}
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div>
                                  {/* Mobile Number Input */}
                                  <div className="input-group mb-2">
                                    <input
                                      type="tel"
                                      className={`form-control ${errors.guardian_mobile_no ? 'is-invalid' : ''}`}
                                      placeholder="Enter new mobile number"
                                      value={tempContactNumbers.guardian_mobile_no}
                                      onChange={(e) => handleTempContactChange('guardian_mobile_no', e.target.value)}
                                      maxLength={10}
                                    />
                                    <button
                                      className="btn btn-outline-success"
                                      type="button"
                                      onClick={() => handleSaveContact('guardian_mobile_no')}
                                    >
                                      <i className="ti ti-check"></i> Save
                                    </button>
                                    <button
                                      className="btn btn-outline-danger"
                                      type="button"
                                      onClick={() => handleCancelEdit('guardian_mobile_no')}
                                    >
                                      <i className="ti ti-x"></i> Cancel
                                    </button>
                                  </div>

                                  {/* OTP Section - Separate Send and Verify Buttons */}
                                  {isEditingContact.guardian_mobile_no && tempContactNumbers.guardian_mobile_no && (
                                    <div className="mt-2">
                                      {isGuardianTempAlreadyVerified ? (
                                        <div className="text-success small fw-semibold d-flex align-items-center">
                                          <i className="ti ti-check me-1"></i>Already verified
                                        </div>
                                      ) : !otpState.sent || otpState.targetField !== 'guardian_mobile_no' ? (
                                        <button
                                          className="btn btn-primary mb-2"
                                          onClick={() => sendContactOtp('guardian_mobile_no')}
                                          disabled={isVerifyingContact}
                                        >
                                          {isVerifyingContact ? 'Sending...' : 'Send OTP'}
                                        </button>
                                      ) : (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter OTP received on your mobile"
                                            value={enteredOtp}
                                            onChange={(e) => setEnteredOtp(e.target.value)}
                                            maxLength={6}
                                          />
                                          <button
                                            className="btn btn-success"
                                            onClick={verifyContactOtp}
                                            disabled={isSubmittingOtp}
                                          >
                                            {isSubmittingOtp ? 'Verifying...' : 'Verify OTP'}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}

                              {errors.guardian_mobile_no && (
                                <div className="invalid-feedback d-block">{errors.guardian_mobile_no}</div>
                              )}
                            </div>
                          )
                        ) : (
                          // Normal Case Contact Display (Both Parents) - NO CHANGES
                          <>

                            {/* Father's Mobile Number Field */}
                            <div className="col-md-4">
                              <label className="form-label">Father's Mobile Number <span className="text-danger">*</span></label>
                              <div className="input-group">
                                <input
                                  type="tel"
                                  className={`form-control ${errors.father_mobile_no ? 'is-invalid' : ''}`}
                                  placeholder="Father's Mobile Number"
                                  value={isEditingContact.father_mobile_no ? tempContactNumbers.father_mobile_no : formData.father_mobile_no}
                                  onChange={(e) => {
                                    const nextValue = sanitizeContactInput(e.target.value);
                                    if (isEditingContact.father_mobile_no) {
                                      handleTempContactChange('father_mobile_no', nextValue);
                                    } else {
                                      handleChange('father_mobile_no', nextValue);
                                    }
                                  }}
                                  readOnly={!isEditingContact.father_mobile_no && verifiedContacts.father_mobile_no}
                                  maxLength={10}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  style={{
                                    backgroundColor: !isEditingContact.father_mobile_no && verifiedContacts.father_mobile_no ? "#f8f9fa" : "",
                                    color: !isEditingContact.father_mobile_no && verifiedContacts.father_mobile_no ? "#6c757d" : ""
                                  }}
                                />

                                {!isEditingContact.father_mobile_no ? (
                                  <>
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => handleEditContact('father_mobile_no')}
                                    >
                                      <i className="ti ti-edit"></i>
                                    </button>
                                    {verifiedContacts.father_mobile_no && (
                                      <span className="input-group-text text-success">
                                        <i className="ti ti-check"></i>
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-success"
                                      type="button"
                                      onClick={() => handleSaveContact('father_mobile_no')}
                                    >
                                      <i className="ti ti-check"></i>
                                    </button>
                                    <button
                                      className="btn btn-outline-danger"
                                      type="button"
                                      onClick={() => handleCancelEdit('father_mobile_no')}
                                    >
                                      <i className="ti ti-x"></i>
                                    </button>
                                  </>
                                )}
                              </div>

                              <div className="mt-1 small">
                                <span
                                  className={`badge ${formData.father_mobile_no ? (verifiedContacts.father_mobile_no ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                >
                                  {formData.father_mobile_no
                                    ? verifiedContacts.father_mobile_no
                                      ? 'Verified'
                                      : 'Not Verified'
                                    : 'Not Provided'}
                                </span>
                              </div>

                              {/* OTP Section */}
                              {isEditingContact.father_mobile_no && (
                                <div className="mt-2">
                                  {isFatherTempAlreadyVerified ? (
                                    <div className="text-success small fw-semibold d-flex align-items-center">
                                      <i className="ti ti-check me-1"></i>Already verified
                                    </div>
                                  ) : !otpState.sent || otpState.targetField !== 'father_mobile_no' ? (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => sendContactOtp('father_mobile_no')}
                                      disabled={isVerifyingContact}
                                    >
                                      {isVerifyingContact ? 'Sending...' : 'Send OTP'}
                                    </button>
                                  ) : (
                                    <div className="d-flex gap-2 align-items-center">
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Enter OTP"
                                        value={enteredOtp}
                                        onChange={(e) => setEnteredOtp(e.target.value)}
                                        maxLength={6}
                                      />
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={verifyContactOtp}
                                        disabled={isSubmittingOtp}
                                      >
                                        {isSubmittingOtp ? 'Verifying...' : 'Verify'}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}

                              {errors.father_mobile_no && (
                                <div className="invalid-feedback d-block">{errors.father_mobile_no}</div>
                              )}
                            </div>

                            {/* Mother's Mobile Number Field - Similar Structure */}
                            <div className="col-md-4">
                              <label className="form-label">Mother's Mobile Number <span className="text-danger">*</span></label>
                              <div className="input-group">
                                <input
                                  type="tel"
                                  className={`form-control ${errors.mother_mobile_no ? 'is-invalid' : ''}`}
                                  placeholder="Mother's Mobile Number"
                                  value={isEditingContact.mother_mobile_no ? tempContactNumbers.mother_mobile_no : formData.mother_mobile_no}
                                  onChange={(e) => {
                                    const nextValue = sanitizeContactInput(e.target.value);
                                    if (isEditingContact.mother_mobile_no) {
                                      handleTempContactChange('mother_mobile_no', nextValue);
                                    } else {
                                      handleChange('mother_mobile_no', nextValue);
                                    }
                                  }}
                                  readOnly={!isEditingContact.mother_mobile_no && verifiedContacts.mother_mobile_no}
                                  maxLength={10}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  style={{
                                    backgroundColor: !isEditingContact.mother_mobile_no && verifiedContacts.mother_mobile_no ? "#f8f9fa" : "",
                                    color: !isEditingContact.mother_mobile_no && verifiedContacts.mother_mobile_no ? "#6c757d" : ""
                                  }}
                                />

                                {!isEditingContact.mother_mobile_no ? (
                                  <>
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => handleEditContact('mother_mobile_no')}
                                    >
                                      <i className="ti ti-edit"></i>
                                    </button>
                                    {verifiedContacts.mother_mobile_no && (
                                      <span className="input-group-text text-success">
                                        <i className="ti ti-check"></i>
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-success"
                                      type="button"
                                      onClick={() => handleSaveContact('mother_mobile_no')}
                                    >
                                      <i className="ti ti-check"></i>
                                    </button>
                                    <button
                                      className="btn btn-outline-danger"
                                      type="button"
                                      onClick={() => handleCancelEdit('mother_mobile_no')}
                                    >
                                      <i className="ti ti-x"></i>
                                    </button>
                                  </>
                                )}
                              </div>

                              <div className="mt-1 small">
                                <span
                                  className={`badge ${formData.mother_mobile_no ? (verifiedContacts.mother_mobile_no ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                >
                                  {formData.mother_mobile_no
                                    ? verifiedContacts.mother_mobile_no
                                      ? 'Verified'
                                      : 'Not Verified'
                                    : 'Not Provided'}
                                </span>
                              </div>

                              {/* OTP Section for Mother */}
                              {isEditingContact.mother_mobile_no && (
                                <div className="mt-2">
                                  {isMotherTempAlreadyVerified ? (
                                    <div className="text-success small fw-semibold d-flex align-items-center">
                                      <i className="ti ti-check me-1"></i>Already verified
                                    </div>
                                  ) : !otpState.sent || otpState.targetField !== 'mother_mobile_no' ? (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => sendContactOtp('mother_mobile_no')}
                                      disabled={isVerifyingContact}
                                    >
                                      {isVerifyingContact ? 'Sending...' : 'Send OTP'}
                                    </button>
                                  ) : (
                                    <div className="d-flex gap-2 align-items-center">
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Enter OTP"
                                        value={enteredOtp}
                                        onChange={(e) => setEnteredOtp(e.target.value)}
                                        maxLength={6}
                                      />
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={verifyContactOtp}
                                        disabled={isSubmittingOtp}
                                      >
                                        {isSubmittingOtp ? 'Verifying...' : 'Verify'}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}

                              {errors.mother_mobile_no && (
                                <div className="invalid-feedback d-block">{errors.mother_mobile_no}</div>
                              )}
                            </div>
                          </>
                        )}

                        {/* Emergency Contact - Always Visible */}
                        <div className="col-md-4">
                          <div className="card border-light shadow-sm h-100">
                            <div className="card-body">
                              <div className="d-flex align-items-center mb-2">
                                <span className="avatar avatar-sm bg-danger-light text-danger rounded-circle me-2">
                                  <i className="ti ti-alert-circle" />
                                </span>
                                <h6 className="mb-0">Emergency Contact</h6>
                              </div>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="ti ti-phone" />
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter emergency number"
                                  value={formData.emergency_mobile_no}
                                  onChange={(e) => handleChange("emergency_mobile_no", e.target.value)}
                                  maxLength={10}
                                />
                              </div>
                              <small className="text-muted">Must be different from parent contacts</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-building-bank fs-16" />
                    </span>
                    <h4 className="text-dark">Email Details</h4>
                  </div>
                </div>

                <div className="card-body pb-1">
                  <div className="row g-3 mb-3">
                    {(!formData.is_single_parent || formData.single_parent === "father" || formData.father_email) && (
                      <div className="col-md-4">
                        <div className="border border-light rounded p-3 h-100 bg-light">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center">
                              <span className="avatar avatar-sm bg-primary-light text-primary rounded-circle me-2">
                                <i className="ti ti-male" />
                              </span>
                              <div>
                                <h6 className="mb-0">Father's Email</h6>

                              </div>
                            </div>
                            <span
                              className={`badge ${formData.father_email ? (verifiedEmails.father_email ? 'bg-success' : 'bg-warning') : 'bg-secondary'}`}
                            >
                              {formData.father_email
                                ? verifiedEmails.father_email
                                  ? 'Verified'
                                  : 'Awaiting Verification'
                                : 'Not Provided'}
                            </span>
                          </div>
                          <div className="text-truncate">
                            {formData.father_email || <span className="text-muted">Add an email to stay informed.</span>}
                          </div>
                          <div className="mt-2">
                            <small className="text-muted">Tap Edit below to update or verify.</small>
                          </div>
                        </div>
                      </div>
                    )}

                    {(!formData.is_single_parent || formData.single_parent === "mother" || formData.mother_email) && (
                      <div className="col-md-4">
                        <div className="border border-light rounded p-3 h-100 bg-light">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center">
                              <span className="avatar avatar-sm bg-danger-light text-danger rounded-circle me-2">
                                <i className="ti ti-female" />
                              </span>
                              <div>
                                <h6 className="mb-0">Mother's Email</h6>

                              </div>
                            </div>
                            <span
                              className={`badge ${formData.mother_email ? (verifiedEmails.mother_email ? 'bg-success' : 'bg-warning') : 'bg-secondary'}`}
                            >
                              {formData.mother_email
                                ? verifiedEmails.mother_email
                                  ? 'Verified'
                                  : 'Awaiting Verification'
                                : 'Not Provided'}
                            </span>
                          </div>
                          <div className="text-truncate">
                            {formData.mother_email || <span className="text-muted">Share an email to receive reminders.</span>}
                          </div>
                          <div className="mt-2">
                            <small className="text-muted">Use the Edit option below to make changes.</small>
                          </div>
                        </div>
                      </div>
                    )}

                    {((formData.is_single_parent && formData.single_parent === "guardian") || hasGuardianEmail) && (
                      <div className="col-md-4">
                        <div className="border border-light rounded p-3 h-100 bg-light">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center">
                              <span className="avatar avatar-sm bg-success-light text-success rounded-circle me-2">
                                <i className="ti ti-shield" />
                              </span>
                              <div>
                                <h6 className="mb-0">Guardian's Email</h6>
                              </div>
                            </div>
                            <span
                              className={`badge ${formData.guardian_email ? (verifiedEmails.guardian_email ? 'bg-success' : 'bg-warning') : 'bg-secondary'}`}
                            >
                              {formData.guardian_email
                                ? verifiedEmails.guardian_email
                                  ? 'Verified'
                                  : 'Awaiting Verification'
                                : 'Not Provided'}
                            </span>
                          </div>
                          <div className="text-truncate">
                            {formData.guardian_email || <span className="text-muted">Capture guardian details when required.</span>}
                          </div>
                          <div className="mt-2">
                            <small className="text-muted">Select Edit to update the guardian email.</small>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    {/* Primary Email Selection */}
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Primary Email Contact <span className="text-danger">*</span></label>
                        <Select
                          classNamePrefix="react-select"
                          placeholder="Select Primary Email"
                          options={EmailData2}
                          getOptionLabel={(e) => e.label}
                          getOptionValue={(e) => e.value}
                          value={EmailData2?.find((opt) => opt.value === emailData)}
                          onChange={(item) => handleDropdownEmailDataChange(item)}
                        />
                        <div className="form-text text-muted small">
                          This email will be used for primary communication
                        </div>
                      </div>
                    </div>

                    {/* Email Fields based on Selection */}
                    <div className="col-md-8">
                      <div className="row">
                        {/* Father's Email - Always shown for non-single parent or when father is selected */}
                        {(!formData.is_single_parent || formData.single_parent === "father" || emailData === "Father") && (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Father's Email {servicePermissions.emailVerify && <span className="text-danger">*</span>}
                              </label>
                              <div className="email-input-container">
                                {isEditingEmail.father_email ? (
                                  <div className="email-edit-mode">
                                    <input
                                      type="email"
                                      className="form-control mb-2"
                                      placeholder="Enter father's email"
                                      value={tempEmailValues.father_email ?? formData.father_email ?? ""}
                                      onChange={(e) => handleTempEmailChange('father_email', e.target.value)}
                                    />
                                    {emailInfoMessages.father_email && (
                                      <div className="small text-primary d-flex align-items-center mb-2">
                                        <i className="ti ti-info-circle me-1"></i>
                                        {emailInfoMessages.father_email}
                                      </div>
                                    )}
                                    <div className="d-flex gap-2 mb-2">
                                      <button
                                        type="button"
                                        className="btn btn-success btn-sm"
                                        onClick={() => handleSaveEmail('father_email')}
                                      >
                                        <i className="ti ti-check me-1"></i>Save
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => handleCancelEditEmail('father_email')}
                                      >
                                        <i className="ti ti-x me-1"></i>Cancel
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="email-view-mode">
                                    <div className="input-group">
                                      <input
                                        type="email"
                                        className={`form-control ${errors.father_email ? 'is-invalid' : ''}`}
                                        placeholder="Father's email"
                                        value={formData.father_email || ''}
                              
                                        readOnly
                                        style={{
                                          backgroundColor: verifiedEmails.father_email ? "#f0f9ff" : "#f8f9fa",
                                          borderColor: verifiedEmails.father_email ? "#b8daff" : "#dee2e6"
                                        }}
                                      />
                                      {servicePermissions.emailVerify && (
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary"
                                          onClick={() => handleEditEmail('father_email')}
                                        >
                                          <i className="ti ti-edit"></i>
                                        </button>
                                      )}
                                      {verifiedEmails.father_email && (
                                        <span className="input-group-text bg-success text-white">
                                          <i className="ti ti-check"></i>
                                        </span>
                                      )}
                                    </div>
                                    <div className="mt-1 small">
                                      <span
                                        className={`badge ${formData.father_email ? (verifiedEmails.father_email ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                      >
                                        {formData.father_email
                                          ? verifiedEmails.father_email
                                            ? 'Verified'
                                            : 'Not Verified'
                                          : 'Not Provided'}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {/* Email Verification Section */}
                                {servicePermissions.emailVerify && isEditingEmail.father_email && (
                                  <div className="email-verification-section mt-2 p-3 border rounded bg-light">
                                    <label className="form-label small fw-bold mb-2">Email Verification</label>
                                    {isFatherTempEmailAlreadyVerified ? (
                                      <div className="text-success small fw-semibold d-flex align-items-center">
                                        <i className="ti ti-check me-1"></i>Already verified
                                      </div>
                                    ) : !parentEmailSent || parentEmailTarget !== 'father_email' ? (
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm w-100"
                                        onClick={() => sendParentEmailOTP('father_email')}
                                        disabled={isSendingParentOTP || !tempEmailValues.father_email}
                                      >
                                        {isSendingParentOTP ? (
                                          <>
                                            <i className="ti ti-loader me-1"></i>Sending OTP...
                                          </>
                                        ) : (
                                          <>
                                            <i className="ti ti-mail me-1"></i>Send Verification OTP
                                          </>
                                        )}
                                      </button>
                                    ) : (
                                      <div className="verification-inputs">
                                        <div className="input-group input-group-sm mb-2">
                                          <span className="input-group-text">
                                            <i className="ti ti-key"></i>
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter 6-digit OTP"
                                            value={parentEmailOTP}
                                            onChange={(e) => setParentEmailOTP(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                            maxLength={6}
                                          />
                                        </div>
                                        <div className="d-flex gap-2">
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm flex-grow-1"
                                            onClick={verifyParentEmailOTP}
                                            disabled={isVerifyingParentOTP || parentEmailOTP.length !== 6}
                                          >
                                            {isVerifyingParentOTP ? (
                                              <>
                                                <i className="ti ti-loader me-1"></i>Verifying...
                                              </>
                                            ) : (
                                              <>
                                                <i className="ti ti-check me-1"></i>Verify
                                              </>
                                            )}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => sendParentEmailOTP('father_email')}
                                            disabled={isSendingParentOTP}
                                          >
                                            <i className="ti ti-refresh"></i>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              {errors.father_email && (
                                <div className="invalid-feedback d-block">{errors.father_email}</div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Mother's Email - Always shown for non-single parent or when mother is selected */}
                        {(!formData.is_single_parent || formData.single_parent === "mother" || emailData === "Mother") && (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Mother's Email {servicePermissions.emailVerify && <span className="text-danger">*</span>}
                              </label>
                              <div className="email-input-container">
                                {isEditingEmail.mother_email ? (
                                  <div className="email-edit-mode">
                                    <input
                                      type="email"
                                      className="form-control mb-2"
                                      placeholder="Enter mother's email"
                                      value={tempEmailValues.mother_email ?? formData.mother_email ?? ""}
                                      onChange={(e) => handleTempEmailChange('mother_email', e.target.value)}
                                    />
                                    {emailInfoMessages.mother_email && (
                                      <div className="small text-primary d-flex align-items-center mb-2">
                                        <i className="ti ti-info-circle me-1"></i>
                                        {emailInfoMessages.mother_email}
                                      </div>
                                    )}
                                    <div className="d-flex gap-2 mb-2">
                                      <button
                                        type="button"
                                        className="btn btn-success btn-sm"
                                        onClick={() => handleSaveEmail('mother_email')}
                                      >
                                        <i className="ti ti-check me-1"></i>Save
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => handleCancelEditEmail('mother_email')}
                                      >
                                        <i className="ti ti-x me-1"></i>Cancel
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="email-view-mode">
                                    <div className="input-group">
                                      <input
                                        type="email"
                                        className={`form-control ${errors.mother_email ? 'is-invalid' : ''}`}
                                        placeholder="Mother's email"
                                        value={formData.mother_email || ''}
                                        readOnly
                                        style={{
                                          backgroundColor: verifiedEmails.mother_email ? "#f0f9ff" : "#f8f9fa",
                                          borderColor: verifiedEmails.mother_email ? "#b8daff" : "#dee2e6"
                                        }}
                                      />
                                      {servicePermissions.emailVerify && (
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary"
                                          onClick={() => handleEditEmail('mother_email')}
                                        >
                                          <i className="ti ti-edit"></i>
                                        </button>
                                      )}
                                      {verifiedEmails.mother_email && (
                                        <span className="input-group-text bg-success text-white">
                                          <i className="ti ti-check"></i>
                                        </span>
                                      )}
                                    </div>
                                    <div className="mt-1 small">
                                      <span
                                        className={`badge ${formData.mother_email ? (verifiedEmails.mother_email ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                      >
                                        {formData.mother_email
                                          ? verifiedEmails.mother_email
                                            ? 'Verified'
                                            : 'Not Verified'
                                          : 'Not Provided'}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {/* Email Verification Section */}
                                {servicePermissions.emailVerify && isEditingEmail.mother_email && (
                                  <div className="email-verification-section mt-2 p-3 border rounded bg-light">
                                    <label className="form-label small fw-bold mb-2">Email Verification</label>
                                    {isMotherTempEmailAlreadyVerified ? (
                                      <div className="text-success small fw-semibold d-flex align-items-center">
                                        <i className="ti ti-check me-1"></i>Already verified
                                      </div>
                                    ) : !parentEmailSent || parentEmailTarget !== 'mother_email' ? (
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm w-100"
                                        onClick={() => sendParentEmailOTP('mother_email')}
                                        disabled={isSendingParentOTP || !tempEmailValues.mother_email}
                                      >
                                        {isSendingParentOTP ? (
                                          <>
                                            <i className="ti ti-loader me-1"></i>Sending OTP...
                                          </>
                                        ) : (
                                          <>
                                            <i className="ti ti-mail me-1"></i>Send Verification OTP
                                          </>
                                        )}
                                      </button>
                                    ) : (
                                      <div className="verification-inputs">
                                        <div className="input-group input-group-sm mb-2">
                                          <span className="input-group-text">
                                            <i className="ti ti-key"></i>
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter 6-digit OTP"
                                            value={parentEmailOTP}
                                            onChange={(e) => setParentEmailOTP(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                            maxLength={6}
                                          />
                                        </div>
                                        <div className="d-flex gap-2">
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm flex-grow-1"
                                            onClick={verifyParentEmailOTP}
                                            disabled={isVerifyingParentOTP || parentEmailOTP.length !== 6}
                                          >
                                            {isVerifyingParentOTP ? (
                                              <>
                                                <i className="ti ti-loader me-1"></i>Verifying...
                                              </>
                                            ) : (
                                              <>
                                                <i className="ti ti-check me-1"></i>Verify
                                              </>
                                            )}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => sendParentEmailOTP('mother_email')}
                                            disabled={isSendingParentOTP}
                                          >
                                            <i className="ti ti-refresh"></i>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              {errors.mother_email && (
                                <div className="invalid-feedback d-block">{errors.mother_email}</div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Guardian's Email - Available when guardian email is relevant */}
                        {(formData.is_single_parent && formData.single_parent === "guardian") ||
                          emailData === "Guardian" ||
                          hasGuardianEmail
                          ? (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Guardian's Email {servicePermissions.emailVerify && <span className="text-danger">*</span>}
                              </label>
                              <div className="email-input-container">
                                {isEditingEmail.guardian_email ? (
                                  <div className="email-edit-mode">
                                    <input
                                      type="email"
                                      className="form-control mb-2"
                                      placeholder="Enter guardian's email"
                                      value={
                                        tempEmailValues.guardian_email ??
                                        formData.guardian_email ??
                                        ""
                                      }
                                      onChange={(e) => handleTempEmailChange('guardian_email', e.target.value)}
                                    />
                                    {emailInfoMessages.guardian_email && (
                                      <div className="small text-primary d-flex align-items-center mb-2">
                                        <i className="ti ti-info-circle me-1"></i>
                                        {emailInfoMessages.guardian_email}
                                      </div>
                                    )}
                                    <div className="d-flex gap-2 mb-2">
                                      <button
                                        type="button"
                                        className="btn btn-success btn-sm"
                                        onClick={() => handleSaveEmail('guardian_email')}
                                      >
                                        <i className="ti ti-check me-1"></i>Save
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => handleCancelEditEmail('guardian_email')}
                                      >
                                        <i className="ti ti-x me-1"></i>Cancel
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="email-view-mode">
                                    <div className="input-group">
                                      <input
                                        type="email"
                                        className={`form-control ${errors.guardian_email ? 'is-invalid' : ''}`}
                                        placeholder="Guardian's email"
                                        value={formData.guardian_email || ''}
                                        readOnly
                                        style={{
                                          backgroundColor: verifiedEmails.guardian_email ? "#f0f9ff" : "#f8f9fa",
                                          borderColor: verifiedEmails.guardian_email ? "#b8daff" : "#dee2e6"
                                        }}
                                      />
                                      {servicePermissions.emailVerify && (
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary"
                                          onClick={() => handleEditEmail('guardian_email')}
                                        >
                                          <i className="ti ti-edit"></i>
                                        </button>
                                      )}
                                      {verifiedEmails.guardian_email && (
                                        <span className="input-group-text bg-success text-white">
                                          <i className="ti ti-check"></i>
                                        </span>
                                      )}
                                    </div>
                                    <div className="mt-1 small">
                                      <span
                                        className={`badge ${formData.guardian_email ? (verifiedEmails.guardian_email ? 'bg-success' : 'bg-danger') : 'bg-secondary'}`}
                                      >
                                        {formData.guardian_email
                                          ? verifiedEmails.guardian_email
                                            ? 'Verified'
                                            : 'Not Verified'
                                          : 'Not Provided'}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {/* Email Verification Section */}
                                {servicePermissions.emailVerify && isEditingEmail.guardian_email && (
                                  <div className="email-verification-section mt-2 p-3 border rounded bg-light">
                                    <label className="form-label small fw-bold mb-2">Email Verification</label>
                                    {isGuardianTempEmailAlreadyVerified ? (
                                      <div className="text-success small fw-semibold d-flex align-items-center">
                                        <i className="ti ti-check me-1"></i>Already verified
                                      </div>
                                    ) : !parentEmailSent || parentEmailTarget !== 'guardian_email' ? (
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm w-100"
                                        onClick={() => sendParentEmailOTP('guardian_email')}
                                        disabled={isSendingParentOTP || !tempEmailValues.guardian_email}
                                      >
                                        {isSendingParentOTP ? (
                                          <>
                                            <i className="ti ti-loader me-1"></i>Sending OTP...
                                          </>
                                        ) : (
                                          <>
                                            <i className="ti ti-mail me-1"></i>Send Verification OTP
                                          </>
                                        )}
                                      </button>
                                    ) : (
                                      <div className="verification-inputs">
                                        <div className="input-group input-group-sm mb-2">
                                          <span className="input-group-text">
                                            <i className="ti ti-key"></i>
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter 6-digit OTP"
                                            value={parentEmailOTP}
                                            onChange={(e) => setParentEmailOTP(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                            maxLength={6}
                                          />
                                        </div>
                                        <div className="d-flex gap-2">
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm flex-grow-1"
                                            onClick={verifyParentEmailOTP}
                                            disabled={isVerifyingParentOTP || parentEmailOTP.length !== 6}
                                          >
                                            {isVerifyingParentOTP ? (
                                              <>
                                                <i className="ti ti-loader me-1"></i>Verifying...
                                              </>
                                            ) : (
                                              <>
                                                <i className="ti ti-check me-1"></i>Verify
                                              </>
                                            )}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => sendParentEmailOTP('guardian_email')}
                                            disabled={isSendingParentOTP}
                                          >
                                            <i className="ti ti-refresh"></i>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              {errors.guardian_email && (
                                <div className="invalid-feedback d-block">{errors.guardian_email}</div>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  {/* Status Summary */}

                </div>
              </div>


              {/* Address Section */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-map fs-16" />
                    </span>
                    <h4 className="text-dark">Address Details</h4>
                  </div>
                </div>

                <div className="card-body">
                  {/* Aadhar Verified Addresses Section */}
                  <div className="mb-4">
                    {/* <h5 className="mb-3 text-primary">Aadhar Verified Addresses</h5> */}
                    <div className="row g-3">
                      {/* Father's Aadhar Address */}
                      {/* Father's Aadhar Address */}

                    </div>
                  </div>

                  {/* Current Address Section */}
                  <div className="mb-4">
                    <h5 className="mb-3 text-primary">Current Address</h5>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Address Type<span className="text-danger">*</span></label>
                          {/* <Select
                            classNamePrefix="react-select"
                            options={AddressSelectData || []
                            }
                            placeholder="Select Address Type"
                            value={AddressSelectData || []
                              .find(opt => opt.value === selectedAddressType)}
                            onChange={handleAddressSelect}
                          /> */}

                          <Select
    classNamePrefix="react-select"
    options={AddressSelectData || []}
    placeholder="Select Address Type"
    value={
      (AddressSelectData || [])?.find(opt => opt.value === selectedAddressType) || null
    }
    onChange={handleAddressSelect}
  />
                        </div>
                      </div>

                      {selectedAddressType === 'Other' && (
                        <>
                          <div className="col-md-8">
                            <div className="mb-3">
                              <label className="form-label">Full Address <span className="text-danger">*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.contact_address}
                                placeholder="House No, Street, Area"
                                onChange={(e) => handleChange("contact_address", e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label">City<span className="text-danger">*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.city_state}
                                placeholder="City/District"
                                onChange={(e) => handleChange("city_state", e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label">Pincode</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.pincode}
                                placeholder="6-digit PIN"
                                maxLength={6}
                                onChange={(e) => handleChange("pincode", e.target.value)}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Permanent Address Section */}
                  <div className="border-top pt-4">
                    <h5 className="mb-3 text-primary">Permanent Address</h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-check mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="sameAsCurrent"
                            checked={isPermanentSameAsCurrent}
                            onChange={(e) => {
                              const { checked } = e.target;
                              setIsPermanentSameAsCurrent(checked);
                              if (checked) {
                                handleChange("permanent_address", formData.contact_address || '');
                              } else {
                                handleChange("permanent_address", "");
                              }
                            }}
                          />
                          <label className="form-check-label fw-medium" htmlFor="sameAsCurrent">
                            Same as Current Address
                          </label>
                        </div>
                      </div>

                      {isPermanentSameAsCurrent ? (
                        <div className="col-md-12">
                          <div className="alert alert-light">
                            <p className="mb-0">
                              <strong>Permanent Address will be same as:</strong><br />
                              {formData.contact_address}, {formData.city_state} - {formData.pincode}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Full Permanent Address*</label>
                            <textarea
                              className="form-control"
                              rows={3}
                              value={formData.permanent_address}
                              placeholder="House No, Street, Area, City, PIN"
                              onChange={(e) => handleChange("permanent_address", e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>



              {/* /Address */}

              {/* Sibling Section */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-users fs-16" />
                    </span>
                    <h4 className="text-dark">Sibling Details</h4>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    {/* Sibling Selection Dropdown */}
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Has Sibling in School? <span className="text-danger">*</span></label>
                        <Select
                          classNamePrefix="react-select"
                          options={SiblingSelectData2}
                          placeholder="Select"
                          value={SiblingSelectData2?.find(opt => opt.value === siblingSelectData)}
                          onChange={handleDropdownSiblingSelectDataChange}
                        />
                        {errors.siblingSelectData && (
                          <div className="text-danger small mt-1">{errors.siblingSelectData}</div>
                        )}
                      </div>
                    </div>

                    {/* Sibling Search Section */}
                    {siblingSelectData === 'Yes' && (
                      <>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Admission Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Admission No"
                                value={admissionNumber}
                                onChange={(e) => {
                                  setAdmissionNumber(e.target.value);
                                  setHasFetched(false);
                                }}
                              />
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={handleSiblingSearch}
                                disabled={!admissionNumber || admissionNumber.length < 3}
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Sibling Details Display */}
                        {siblingAdmissionData.length > 0 && (
                          <div className="col-12">
                            <div className="card border-primary">
                              <div className="card-body">
                                <h5 className="text-primary mb-3">Sibling Information</h5>

                                {/* Validation Messages */}
                                {!parentInfoMatched && (
                                  <div className="alert alert-danger">
                                    <h6 className="fw-bold">Parent Information Mismatch!</h6>
                                    <p>Please verify the following details:</p>
                                    <ul className="mb-0">
                                      {formData.father_mobile_no !== siblingAdmissionData[0].father_mobile_no && (
                                        <li>Father's Mobile: Data has {siblingAdmissionData[0].father_mobile_no}, you entered {formData.father_mobile_no}</li>
                                      )}
                                      {formData.father_email !== siblingAdmissionData[0].father_email && (
                                        <li>Father's Email: Data has {siblingAdmissionData[0].father_email}, you entered {formData.father_email}</li>
                                      )}
                                      {formData.mother_mobile_no !== siblingAdmissionData[0].mother_mobile_no && (
                                        <li>Mother's Mobile: Data has {siblingAdmissionData[0].mother_mobile_no}, you entered {formData.mother_mobile_no}</li>
                                      )}
                                      {formData.mother_email !== siblingAdmissionData[0].mother_email && (
                                        <li>Mother's Email: Data has {siblingAdmissionData[0].mother_email}, you entered {formData.mother_email}</li>
                                      )}
                                    </ul>
                                  </div>
                                )}

                                {/* Sibling Details */}
                                <div className="row">
                                  <div className="col-md-4">
                                    <p><strong>Student Name:</strong> {siblingAdmissionData[0].student_full_name || 'N/A'}</p>
                                  </div>
                                  <div className="col-md-4">
                                    <p><strong>Class:</strong> {siblingAdmissionData[0].cls_sec?.cls?.Classes || 'N/A'} {siblingAdmissionData[0].cls_sec?.section?.section || ''}</p>
                                  </div>
                                  <div className="col-md-4">
                                    <p><strong>Admission No:</strong> {siblingAdmissionData[0].admission_num || 'N/A'}</p>
                                  </div>
                                  <div className="col-md-4">
                                    <p><strong>Father's Name:</strong> {siblingAdmissionData[0].father_full_name || 'N/A'}</p>
                                  </div>
                                  <div className="col-md-4">
                                    <p><strong>Mother's Name:</strong> {siblingAdmissionData[0].mother_full_name || 'N/A'}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {hasFetched && siblingSelectData === 'Yes' && admissionNumber && siblingAdmissionData.length === 0 && (
                          <div className="col-12">
                            <div className="alert alert-info mb-0">No sibling record found for the provided admission number.</div>
                          </div>
                        )}
                        {/* Reference Details Section */}

                      </>
                    )}
                  </div>
                </div>
              </div>

              


              <div className="card mb-3">
                <div className="card-header bg-light">
                  <h6 className="mb-0">Associated Members - Connection with School (Current or Former)</h6>
                </div>
                <div className="card-body">
                  {activeReferrals.map(({ referral, originalIndex }, displayIndex) => (
                    <div key={originalIndex} className="border p-3 mb-3 position-relative rounded">
                      <h6>Associated Member - Connection with School (Current or Former) {displayIndex + 1}</h6>

                      {/* Delete Button */}
                      <button
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "10px", right: "10px" }}
                        onClick={() => deleteReferral(originalIndex)}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>

                      <div className="row g-3">
                        {/* Role */}
                        <div className="col-md-4">
                          <label className="form-label">Role / Association with School <span className="text-danger">*</span></label>
                          <Select
                            options={[
                              { value: "Ex student (alumni)", label: "Ex student (alumni)" },
                              { value: "Present student (cousin)", label: "Present student (cousin)" },
                              { value: "Ex staff", label: "Ex staff" },
                              { value: "Present staff", label: "Present staff" },
                              { value: "Others", label: "Others" },
                            ]}
                            value={referral.ref_role ? { value: referral.ref_role, label: referral.ref_role } : null}
                            onChange={(option) => updateReferral(originalIndex, "ref_role", option.value)}
                            placeholder="Select Role"
                          />
                        </div>

                        {/* Name of alumni/cousin */}
                        <div className="col-md-4">
                          <label className="form-label">Associated Member Name <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter name"
                            value={referral.ref_name}
                            onChange={(e) => updateReferral(originalIndex, "ref_name", e.target.value)}
                          />
                        </div>

                        {/* Relation */}
                        <div className="col-md-4">
                          <label className="form-label">Member's Relation with the Child (Seeking Admission)</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g., Sibling, Parent"
                            value={referral.ref_relation}
                            onChange={(e) => updateReferral(originalIndex, "ref_relation", e.target.value)}
                          />
                        </div>

                        {/* Mobile No */}
                        <div className="col-md-4">
                          <label className="form-label">Associated Contact No</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="10-digit number"
                            maxLength="10"
                            value={referral.ref_contact_no}
                            onChange={(e) => updateReferral(originalIndex, "ref_contact_no", e.target.value)}
                          />
                        </div>

                        {/* Note */}
                        <div className="col-md-8">
                          <label className="form-label">Note - Any other Information</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Optional note"
                            value={referral.ref_note}
                            onChange={(e) => updateReferral(originalIndex, "ref_note", e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Add Button */}
                  <button className="btn btn-primary mt-3" type="button" onClick={addNewReferral}>
                    Add New Referral
                  </button>
                </div>
              </div>


              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-building-bank fs-16" />
                    </span>
                    <h4 className="text-dark">Registration Fee Details</h4>
                  </div>
                </div>

                <div className="card-body pb-1">
                  {getRegistration?.data?.registration_fee_status === "paid" && (
                    <div className="alert alert-success d-flex align-items-center" role="alert">
                      <i className="ti ti-check me-2"></i>
                      <span>Registration fee already paid for this registration.</span>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="registration_fee">
                          Registration Fee
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.registration_fee ? 'is-invalid' : ''}`}
                          id="registration_fee"
                          placeholder="1000"
                          value={formData.registration_fee}
                          onChange={(e) =>
                            handleChange("registration_fee", e.target.value)
                          }
                          disabled
                        />
                        {errors.registration_fee && (
                          <div className="invalid-feedback">{errors.registration_fee}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Payment Method</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.payment_mode ? "is-invalid" : ""
                          }`}
                          id="payment_mode"
                          placeholder="Online"
                          // value={formData.payment_mode}
                          // onChange={(e) =>
                          //   handleChange("payment_mode", e.target.value)
                          // }
                          disabled
                        />
                      </div>
                      {/* {getRegistration?.data?.registration_fee_status === "paid" && (
                                              <div className="verified-text text-success fw-bold">
                                            ✅ Registration payment has been successfully completed.
                                          </div>
                                            )} */}
                    </div>
                   
                  </div>

                 
                </div>
              </div>
              {/* Submit Button Section */}
              <div className="text-end">

                <button
                  type="button"
                  className="btn btn-light me-3"
                  onClick={() => navigate("/registration")}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
                
              </div>
            </form>
            <Modal
              show={consentModalState.visible}
              onHide={handleConsentModalClose}
              centered
              backdrop="static"
              keyboard={!consentModalSubmitting}
            >
              <Modal.Header closeButton={!consentModalSubmitting}>
                <Modal.Title>Required Consents</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className="mb-3">
                  Please review and accept the following consents to proceed with the registration.
                </p>
                {(consentModalState.items || []).map(({ consent }) => (
                  <div className="mb-3" key={consent.key}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`consent-${consent.key}`}
                        checked={Boolean(selectedConsentKeys[consent.key])}
                        onChange={() => handleConsentCheckboxToggle(consent.key)}
                        disabled={consentModalSubmitting}
                      />
                      <label className="form-check-label" htmlFor={`consent-${consent.key}`}>
                        <strong>{consent.label}</strong>
                      </label>
                    </div>
                    {consent.description && (
                      <p className="ms-4 mb-1 small text-muted">{consent.description}</p>
                    )}
                    {consent.message && (
                      <p className="ms-4 mb-0 small text-muted">{consent.message}</p>
                    )}
                  </div>
                ))}
                {consentModalError && (
                  <div className="alert alert-danger mt-3 mb-0" role="alert">
                    {consentModalError}
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-outline-secondary me-2"
                  onClick={handleConsentModalClose}
                  disabled={consentModalSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConsentModalConfirm}
                  disabled={!allConsentSelected || consentModalSubmitting}
                >
                  {consentModalSubmitting ? 'Submitting...' : 'Accept & Continue'}
                </button>
              </Modal.Footer>
            </Modal>
            <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)} size="xl" centered className="student-360-modal">
              <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title style={{ color: "white" }}>
                  <FontAwesomeIcon icon={faUserGraduate} className="me-2" />
                  {referenceVerificationData?.currentIndex !== undefined && referrals[referenceVerificationData.currentIndex]?.ref_role === 'student' ? 'Student 360° View' : 'Staff 360° View'} -
                  {referenceVerificationData?.currentIndex !== undefined &&
                    (referenceVerificationData[referenceVerificationData.currentIndex]?.student_full_name ||
                      referenceVerificationData[referenceVerificationData.currentIndex]?.staff_full_name || 'Unknown')}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-0">
                {referenceVerificationData && referenceVerificationData.currentIndex !== undefined && referenceVerificationData[referenceVerificationData.currentIndex] ? (
                  <div>
                    {/* Modal content, e.g., student/staff details */}
                    <div className="bg-light p-3 border-bottom">
                      <div className="row align-items-center">
                        <div className="col-md-8">
                          <div className="d-flex align-items-center">
                            <div className="me-3">
                              <img
                                src={
                                  referrals[referenceVerificationData.currentIndex]?.ref_role === 'student'
                                    ? referenceVerificationData[referenceVerificationData.currentIndex]?.upload_photo?.link || "https://via.placeholder.com/60"
                                    : referenceVerificationData[referenceVerificationData.currentIndex]?.photo || "https://via.placeholder.com/60"
                                }
                                alt={referrals[referenceVerificationData.currentIndex]?.ref_role === 'student' ? 'Student' : 'Staff'}
                                className="rounded-circle"
                                style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                              />
                            </div>
                            <div>
                              <h5 className="mb-1 fw-bold">
                                {referrals[referenceVerificationData.currentIndex]?.ref_role === 'student'
                                  ? referenceVerificationData[referenceVerificationData.currentIndex]?.student_full_name
                                  : referenceVerificationData[referenceVerificationData.currentIndex]?.staff_full_name || 'N/A'}
                              </h5>
                              {/* Other fields */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Enhanced Tabs */}
                    <nav>
                      <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                        <button
                          className="nav-link active"
                          id="nav-basic-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-basic"
                          type="button"
                          role="tab"
                          aria-controls="nav-basic"
                          aria-selected="true"
                        >
                          <FontAwesomeIcon icon={faUserGraduate} className="me-2" />
                          Basic Details
                        </button>
                        <button
                          className="nav-link"
                          id="nav-family-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-family"
                          type="button"
                          role="tab"
                          aria-controls="nav-family"
                          aria-selected="false"
                        >
                          <FontAwesomeIcon icon={faUsers} className="me-2" />
                          Family Details
                        </button>
                        <button
                          className="nav-link"
                          id="nav-education-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-education"
                          type="button"
                          role="tab"
                          aria-controls="nav-education"
                          aria-selected="false"
                        >
                          <FontAwesomeIcon icon={faGraduationCap} className="me-2" />
                          {formData.ref_role === 'student' ? 'Education' : 'Employment'}
                        </button>
                        <button
                          className="nav-link"
                          id="nav-contact-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-contact"
                          type="button"
                          role="tab"
                          aria-controls="nav-contact"
                          aria-selected="false"
                        >
                          <FontAwesomeIcon icon={faPhone} className="me-2" />
                          Contact Details
                        </button>
                        <button
                          className="nav-link"
                          id="nav-documents-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-documents"
                          type="button"
                          role="tab"
                          aria-controls="nav-documents"
                          aria-selected="false"
                        >
                          <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                          Documents
                        </button>
                      </div>
                    </nav>

                    <div className="tab-content p-4" id="nav-tabContent">
                      {/* Basic Details Tab */}
                      <div className="tab-pane fade show active" id="nav-basic" role="tabpanel" aria-labelledby="nav-basic-tab">
                        <h5 className="mb-4 text-primary">
                          <FontAwesomeIcon icon={faUserGraduate} className="me-2" />
                          Basic Information
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="card mb-3">
                              <div className="card-header bg-light">
                                <h6 className="mb-0">Basic Information</h6>
                              </div>
                              <div className="card-body">
                                {formData.ref_role === 'student' ? (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Admission No:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.admission_num || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Full Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.student_full_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Gender:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.gender || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Date of Birth:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.date_of_birth ? moment(referenceVerificationData[referenceVerificationData.currentIndex]?.date_of_birth).format("DD MMM YYYY") : 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Class/Section:</div>
                                      <div className="col-7 fw-medium">
                                        {referenceVerificationData[referenceVerificationData.currentIndex]?.cls_sec?.cls?.Classes || referenceVerificationData[referenceVerificationData.currentIndex]?.select_class || 'N/A'} {referenceVerificationData[referenceVerificationData.currentIndex]?.cls_sec?.section?.section || referenceVerificationData[referenceVerificationData.currentIndex]?.section_id || 'N/A'}
                                      </div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Active:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.is_active ? 'Yes' : 'No'}</div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Employee Code:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.employee_code || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Full Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.staff_full_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Gender:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.gender || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Date of Birth:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.dob ? moment(referenceVerificationData[referenceVerificationData.currentIndex]?.dob, "DD-MM-YYYY").format("DD MMM YYYY") : 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Designation:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.designation || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Active:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.is_active ? 'Yes' : 'No'}</div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="card mb-3">
                              <div className="card-header bg-light">
                                <h6 className="mb-0">Additional Information</h6>
                              </div>
                              <div className="card-body">
                                {formData.ref_role === 'student' ? (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Aadhar No:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.aadhar_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Blood Group:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.blood_group || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Religion:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.region?.name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Cast Category:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.cast?.category || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Roll No:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.roll_num || 'N/A'}</div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Aadhar No:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.aadhar_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Blood Group:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.blood_group || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Religion ID:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.religion_id || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Cast Category ID:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.cast_category_id || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Marital Status:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.marital_status || 'N/A'}</div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Family Details Tab */}
                      <div className="tab-pane fade" id="nav-family" role="tabpanel" aria-labelledby="nav-family-tab">
                        <h5 className="mb-4 text-primary">
                          <FontAwesomeIcon icon={faUsers} className="me-2" />
                          Family Information
                        </h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="card mb-3">
                              <div className="card-header bg-light">
                                <h6 className="mb-0">Family Details</h6>
                              </div>
                              <div className="card-body">
                                {formData.ref_role === 'student' ? (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Father's Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_full_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Father's Mobile:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_mobile_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Father's Email:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_email || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Father's Aadhar:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_aadhar_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Father's Occupation:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_occupation || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mother's Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.mother_full_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mother's Mobile:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.mother_mobile_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mother's Email:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.mother_email || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mother's Aadhar:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.mother_aadhar_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mother's Occupation:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.mother_occupation || 'N/A'}</div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Father's Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_full_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mother's Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.mother_full_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Spouse Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.spouse_name || 'N/A'}</div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Education/Employment Tab */}
                      <div className="tab-pane fade" id="nav-education" role="tabpanel" aria-labelledby="nav-education-tab">
                        <h5 className="mb-4 text-primary">
                          <FontAwesomeIcon icon={faGraduationCap} className="me-2" />
                          {formData.ref_role === 'student' ? 'Education' : 'Employment'} Information
                        </h5>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="card mb-3">
                              <div className="card-body">
                                {formData.ref_role === 'student' ? (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Admission Date:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.admission_date || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">House ID:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.house_id || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Username:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.username || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Leaving Date:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.leaving_date ? moment(referenceVerificationData[referenceVerificationData.currentIndex]?.leaving_date).format("DD MMM YYYY") : 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Reason for Leaving:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.reason_for_leaving || 'N/A'}</div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Designation:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.designation || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Department:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.department || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Basic Salary:</div>
                                      <div className="col-7 fw-medium">₹{referenceVerificationData[referenceVerificationData.currentIndex]?.Basic_salary || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Experience:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.experience || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Joined Date:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.joined_date ? moment(referenceVerificationData[referenceVerificationData.currentIndex]?.joined_date, "DD-MM-YYYY").format("DD MMM YYYY") : 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Relieving Date:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.reliving_date || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Qualification:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.qualification || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Has Graduation:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.has_graduation ? 'Yes' : 'No'}</div>
                                    </div>
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.has_graduation && (
                                      <>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Graduation Degree:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.grad_degree_type || 'N/A'}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Graduation Subjects:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.grad_subjects || 'N/A'}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Graduation College:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.grad_college || 'N/A'}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Graduation Year:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.grad_year || 'N/A'}</div>
                                        </div>
                                      </>
                                    )}
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.has_postgraduation && (
                                      <>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Postgrad Degree:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.postgrad_degree_type || 'N/A'}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Postgrad Subjects:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.postgrad_subjects || 'N/A'}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Postgrad College:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.postgrad_college || 'N/A'}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-5 text-muted">Postgrad Year:</div>
                                          <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.postgrad_year || 'N/A'}</div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Contact Details Tab */}
                      <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                        <h5 className="mb-4 text-primary">
                          <FontAwesomeIcon icon={faPhone} className="me-2" />
                          Contact Information
                        </h5>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="card mb-3">
                              <div className="card-body">
                                {formData.ref_role === 'student' ? (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Contact Address:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.contact_address || referenceVerificationData[referenceVerificationData.currentIndex]?.address || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Permanent Address:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.permanent_address || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Pincode:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.pincode || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">City/State:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.city_state || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Emergency Mobile:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.emergency_mobile_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Email:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_email || referenceVerificationData[referenceVerificationData.currentIndex]?.email || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mobile No:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.father_mobile_no || referenceVerificationData[referenceVerificationData.currentIndex]?.mobile_no || 'N/A'}</div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Contact Address:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.address || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Permanent Address:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.permanent_address || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Pincode:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.pincode || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">City/State:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.city_state_id || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Emergency Mobile:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.emergency_mobile_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Email:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.email || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Mobile No:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.mobile_no || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Bank Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.bank_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Account Number:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.account_number || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">Account Name:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.account_name || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                      <div className="col-5 text-muted">IFSC Code:</div>
                                      <div className="col-7 fw-medium">{referenceVerificationData[referenceVerificationData.currentIndex]?.ifsc_code || 'N/A'}</div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Documents Tab */}
                      <div className="tab-pane fade" id="nav-documents" role="tabpanel" aria-labelledby="nav-documents-tab">
                        <h5 className="mb-4 text-primary">
                          <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                          Document Information
                        </h5>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="card mb-3">
                              <div className="card-body">
                                {formData.ref_role === 'student' ? (
                                  <>
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.upload_photo?.link && (
                                      <div className="mb-3">
                                        <strong>Student Photo:</strong>
                                        <div className="mt-2">
                                          <img
                                            src={referenceVerificationData[referenceVerificationData.currentIndex]?.upload_photo.link}
                                            alt="Student"
                                            style={{ maxWidth: '100%', maxHeight: '200px' }}
                                            className="img-thumbnail"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.father_photo?.link && (
                                      <div className="mb-3">
                                        <strong>Father's Photo:</strong>
                                        <div className="mt-2">
                                          <img
                                            src={referenceVerificationData[referenceVerificationData.currentIndex]?.father_photo.link}
                                            alt="Father"
                                            style={{ maxWidth: '100%', maxHeight: '200px' }}
                                            className="img-thumbnail"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.mother_photo_upload?.link && (
                                      <div className="mb-3">
                                        <strong>Mother's Photo:</strong>
                                        <div className="mt-2">
                                          <img
                                            src={referenceVerificationData[referenceVerificationData.currentIndex]?.mother_photo_upload.link}
                                            alt="Mother"
                                            style={{ maxWidth: '100%', maxHeight: '200px' }}
                                            className="img-thumbnail"
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.photo && (
                                      <div className="mb-3">
                                        <strong>Staff Photo:</strong>
                                        <div className="mt-2">
                                          <img
                                            src={referenceVerificationData[referenceVerificationData.currentIndex]?.photo}
                                            alt="Staff"
                                            style={{ maxWidth: '100%', maxHeight: '200px' }}
                                            className="img-thumbnail"
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.cast_certificate && (
                                      <div className="mb-3">
                                        <strong>Caste Certificate:</strong>
                                        <div className="mt-2">
                                          <a
                                            href={`https://erish-school-app.s3.ap-south-1.amazonaws.com/${referenceVerificationData[referenceVerificationData.currentIndex]?.cast_certificate}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary btn-sm"
                                          >
                                            View Caste Certificate
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.teaching_certificate && (
                                      <div className="mb-3">
                                        <strong>Teaching Certificate:</strong>
                                        <div className="mt-2">
                                          <a
                                            href={`https://erish-school-app.s3.ap-south-1.amazonaws.com/${referenceVerificationData[referenceVerificationData.currentIndex]?.teaching_certificate}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary btn-sm"
                                          >
                                            View Teaching Certificate
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                    {referenceVerificationData[referenceVerificationData.currentIndex]?.bank_proof_file && (
                                      <div className="mb-3">
                                        <strong>Bank Proof:</strong>
                                        <div className="mt-2">
                                          <a
                                            href={`https://erish-school-app.s3.ap-south-1.amazonaws.com/${referenceVerificationData[referenceVerificationData.currentIndex]?.bank_proof_file}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary btn-sm"
                                          >
                                            View Bank Proof
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 fs-5 text-muted">Loading comprehensive data...</p>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer className="bg-light">
                <button className="btn btn-secondary" onClick={() => setIsModalVisible(false)}>
                  <FontAwesomeIcon icon={faTimes} className="me-2" />
                  Close
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpdateRegistration;